/* tslint:disable */
/* eslint-disable */

/**
 * 
 * @export
 */
export const ActionType = {
    Exclude: 'EXCLUDE',
    IncreasePrice: 'INCREASE_PRICE',
    ReducePrice: 'REDUCE_PRICE'
} as const;
export type ActionType = typeof ActionType[keyof typeof ActionType];

/**
 * 
 * @export
 * @interface AddBotMessageRequest
 */
export interface AddBotMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof AddBotMessageRequest
     */
    botMessage: string;
}
/**
 * 
 * @export
 * @interface AftersalesConfigurationDTO
 */
export interface AftersalesConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof AftersalesConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AftersalesConfigurationDTO
     */
    aftersalesEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AftersalesConfigurationDTO
     */
    bookingURL?: string;
    /**
     * 
     * @type {string}
     * @memberof AftersalesConfigurationDTO
     */
    recallURL?: string;
    /**
     * 
     * @type {WorkScheduleDTO}
     * @memberof AftersalesConfigurationDTO
     */
    aftersalesWorkSchedule?: WorkScheduleDTO;
    /**
     * 
     * @type {EmailConfigurationDTO}
     * @memberof AftersalesConfigurationDTO
     */
    emailConfiguration?: EmailConfigurationDTO;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof AftersalesConfigurationDTO
     */
    supportedVehicleManufacturers?: { [key: string]: Array<string>; };
}


/**
 * @export
 */
export const AftersalesConfigurationDTOSupportedVehicleManufacturersEnum = {
    Car: 'CAR',
    Lcv: 'LCV',
    Bike: 'BIKE'
} as const;
export type AftersalesConfigurationDTOSupportedVehicleManufacturersEnum = typeof AftersalesConfigurationDTOSupportedVehicleManufacturersEnum[keyof typeof AftersalesConfigurationDTOSupportedVehicleManufacturersEnum];

/**
 * 
 * @export
 * @interface AgentHandoverChatEventDTO
 */
export interface AgentHandoverChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof AgentHandoverChatEventDTO
     */
    agent_name?: AgentHandoverChatEventDTOAgentNameEnum;
}


/**
 * @export
 */
export const AgentHandoverChatEventDTOAgentNameEnum = {
    UsedVehicleSearch: 'USED_VEHICLE_SEARCH',
    NewVehicleSearch: 'NEW_VEHICLE_SEARCH',
    Booking: 'BOOKING',
    Requests: 'REQUESTS',
    Aftersales: 'AFTERSALES',
    Knowledge: 'KNOWLEDGE',
    PxValuation: 'PX_VALUATION',
    Finance: 'FINANCE',
    Reservation: 'RESERVATION',
    UtilityHandover: 'UTILITY_HANDOVER'
} as const;
export type AgentHandoverChatEventDTOAgentNameEnum = typeof AgentHandoverChatEventDTOAgentNameEnum[keyof typeof AgentHandoverChatEventDTOAgentNameEnum];


/**
 * 
 * @export
 */
export const AgentName = {
    UsedVehicleSearch: 'USED_VEHICLE_SEARCH',
    NewVehicleSearch: 'NEW_VEHICLE_SEARCH',
    Booking: 'BOOKING',
    Requests: 'REQUESTS',
    Aftersales: 'AFTERSALES',
    Knowledge: 'KNOWLEDGE',
    PxValuation: 'PX_VALUATION',
    Finance: 'FINANCE',
    Reservation: 'RESERVATION',
    UtilityHandover: 'UTILITY_HANDOVER'
} as const;
export type AgentName = typeof AgentName[keyof typeof AgentName];

/**
 * 
 * @export
 * @interface AgentRuntimeOverride
 */
export interface AgentRuntimeOverride {
    /**
     * 
     * @type {string}
     * @memberof AgentRuntimeOverride
     */
    prompt?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentRuntimeOverride
     */
    model?: string;
    /**
     * 
     * @type {number}
     * @memberof AgentRuntimeOverride
     */
    temperature?: number;
}
/**
 * 
 * @export
 * @interface AgentRuntimeOverrides
 */
export interface AgentRuntimeOverrides {
    /**
     * 
     * @type {string}
     * @memberof AgentRuntimeOverrides
     */
    sharedPrompt?: string;
    /**
     * 
     * @type {{ [key: string]: AgentRuntimeOverride; }}
     * @memberof AgentRuntimeOverrides
     */
    agentOverrides?: { [key: string]: AgentRuntimeOverride; };
}
/**
 * 
 * @export
 * @interface AppliedAction
 */
export interface AppliedAction {
    /**
     * 
     * @type {string}
     * @memberof AppliedAction
     */
    actionType?: AppliedActionActionTypeEnum;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof AppliedAction
     */
    priceModifier?: SubtractionDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppliedAction
     */
    matchedConditions?: Array<string>;
}


/**
 * @export
 */
export const AppliedActionActionTypeEnum = {
    Exclude: 'EXCLUDE',
    IncreasePrice: 'INCREASE_PRICE',
    ReducePrice: 'REDUCE_PRICE'
} as const;
export type AppliedActionActionTypeEnum = typeof AppliedActionActionTypeEnum[keyof typeof AppliedActionActionTypeEnum];

/**
 * 
 * @export
 * @interface AssistantCloneResult
 */
export interface AssistantCloneResult {
    /**
     * 
     * @type {string}
     * @memberof AssistantCloneResult
     */
    assistantPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantCloneResult
     */
    assistantName?: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantCloneResult
     */
    franchisesCopied?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantCloneResult
     */
    locationsCopied?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantCloneResult
     */
    offersCopied?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantCloneResult
     */
    vehicleRowsCopied?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssistantCloneResult
     */
    vehicleCloneFailed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssistantCloneResult
     */
    knowledgeVectorsCopied?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantCloneResult
     */
    knowledgeRecordsEmbedded?: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssistantCloneResult
     */
    knowledgeCloneFailed?: boolean;
}
/**
 * 
 * @export
 * @interface AssistantImportResult
 */
export interface AssistantImportResult {
    /**
     * 
     * @type {string}
     * @memberof AssistantImportResult
     */
    assistantPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistantImportResult
     */
    assistantName?: string;
    /**
     * 
     * @type {number}
     * @memberof AssistantImportResult
     */
    franchisesCreated?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantImportResult
     */
    franchisesUpdated?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantImportResult
     */
    locationsCreated?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantImportResult
     */
    locationsUpdated?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantImportResult
     */
    offersRestored?: number;
    /**
     * 
     * @type {number}
     * @memberof AssistantImportResult
     */
    offersSkipped?: number;
}
/**
 * 
 * @export
 * @interface AutotraderAccessTokenResponse
 */
export interface AutotraderAccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AutotraderAccessTokenResponse
     */
    access_token?: string;
}
/**
 * 
 * @export
 * @interface AutotraderAndFileOnSftpVehicleDataConfigurationDTO
 */
export interface AutotraderAndFileOnSftpVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof AutotraderAndFileOnSftpVehicleDataConfigurationDTO
     */
    advertiserId: string;
    /**
     * 
     * @type {string}
     * @memberof AutotraderAndFileOnSftpVehicleDataConfigurationDTO
     */
    filePath: string;
}


/**
 * 
 * @export
 * @interface AutotraderVehicleDataConfigurationDTO
 */
export interface AutotraderVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof AutotraderVehicleDataConfigurationDTO
     */
    advertiserId: string;
}



/**
 * 
 * @export
 */
export const AvailabilityCheckStatus = {
    Available: 'AVAILABLE',
    TooLate: 'TOO_LATE',
    TooEarly: 'TOO_EARLY',
    OutOfWorkingHours: 'OUT_OF_WORKING_HOURS',
    Closed: 'CLOSED',
    Past: 'PAST',
    NoSuitableTimeIn7Days: 'NO_SUITABLE_TIME_IN_7_DAYS'
} as const;
export type AvailabilityCheckStatus = typeof AvailabilityCheckStatus[keyof typeof AvailabilityCheckStatus];

/**
 * 
 * @export
 * @interface BookedCallBackChatEventDTO
 */
export interface BookedCallBackChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {boolean}
     * @memberof BookedCallBackChatEventDTO
     */
    isCanceled: boolean;
    /**
     * 
     * @type {ChatEventDTO}
     * @memberof BookedCallBackChatEventDTO
     */
    associated_check_chat_event: ChatEventDTO;
    /**
     * 
     * @type {string}
     * @memberof BookedCallBackChatEventDTO
     */
    booking_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof BookedCallBackChatEventDTO
     */
    location_identifier: string;
}


/**
 * 
 * @export
 * @interface BookedEmailFollowUpChatEventDTO
 */
export interface BookedEmailFollowUpChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof BookedEmailFollowUpChatEventDTO
     */
    location_identifier: string;
}


/**
 * 
 * @export
 * @interface BookedServiceCallBackChatEventDTO
 */
export interface BookedServiceCallBackChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof BookedServiceCallBackChatEventDTO
     */
    location_identifier: string;
    /**
     * 
     * @type {string}
     * @memberof BookedServiceCallBackChatEventDTO
     */
    user_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedServiceCallBackChatEventDTO
     */
    service_call_back_user_name: string;
    /**
     * 
     * @type {string}
     * @memberof BookedServiceCallBackChatEventDTO
     */
    service_call_back_user_phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof BookedServiceCallBackChatEventDTO
     */
    user_vehicle_vrm: string;
    /**
     * 
     * @type {number}
     * @memberof BookedServiceCallBackChatEventDTO
     */
    service_call_back_vehicle_mileage: number;
}


/**
 * 
 * @export
 * @interface BookedTestDriveChatEventDTO
 */
export interface BookedTestDriveChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {boolean}
     * @memberof BookedTestDriveChatEventDTO
     */
    isCanceled: boolean;
    /**
     * 
     * @type {ChatEventDTO}
     * @memberof BookedTestDriveChatEventDTO
     */
    associated_check_chat_event: ChatEventDTO;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    booking_datetime: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    location_identifier: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    vds_internal_id?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    vehicle_make?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    vehicle_model?: string;
    /**
     * 
     * @type {string}
     * @memberof BookedTestDriveChatEventDTO
     */
    vehicle_variant?: string;
}


/**
 * 
 * @export
 * @interface BookingConfigDTO
 */
export interface BookingConfigDTO {
    /**
     * 
     * @type {number}
     * @memberof BookingConfigDTO
     */
    id?: number;
    /**
     * 
     * @type {BookingType}
     * @memberof BookingConfigDTO
     */
    bookingType: BookingType;
    /**
     * 
     * @type {number}
     * @memberof BookingConfigDTO
     */
    bookingStepSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof BookingConfigDTO
     */
    timeToCloseSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof BookingConfigDTO
     */
    minimumNoticeSeconds: number;
}


/**
 * 
 * @export
 * @interface BookingConfigUi
 */
export interface BookingConfigUi {
    /**
     * 
     * @type {number}
     * @memberof BookingConfigUi
     */
    id: number;
    /**
     * 
     * @type {BookingType}
     * @memberof BookingConfigUi
     */
    bookingType: BookingType;
    /**
     * 
     * @type {number}
     * @memberof BookingConfigUi
     */
    bookingStepSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof BookingConfigUi
     */
    timeToCloseSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof BookingConfigUi
     */
    minimumNoticeSeconds: number;
}



/**
 * 
 * @export
 */
export const BookingType = {
    CallBack: 'CALL_BACK',
    TestDrive: 'TEST_DRIVE'
} as const;
export type BookingType = typeof BookingType[keyof typeof BookingType];

/**
 * 
 * @export
 * @interface BotDTO
 */
export interface BotDTO {
    /**
     * 
     * @type {number}
     * @memberof BotDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    siteURL?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    groupHash?: string;
    /**
     * 
     * @type {BotType}
     * @memberof BotDTO
     */
    botType?: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    useMultiAgent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    vehicleProviderWarningEmailEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    externalCommunicationsDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    sharingLinkEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    surveyAfterMessagesEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BotDTO
     */
    surveyAfterMessagesCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    surveyAfterBookingEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotDTO
     */
    isReimportFinished?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BotDTO
     */
    conversationLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    lastRenewalDate?: string;
    /**
     * 
     * @type {number}
     * @memberof BotDTO
     */
    workingRange?: number;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof BotDTO
     */
    redirectProvider?: RedirectProvider;
    /**
     * 
     * @type {UrlProcessorConfigurationDTO}
     * @memberof BotDTO
     */
    urlProcessorConfiguration?: UrlProcessorConfigurationDTO;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof BotDTO
     */
    openAiModel?: BotDTOOpenAiModelEnum;
    /**
     * 
     * @type {SupportedTimezone}
     * @memberof BotDTO
     */
    timezone?: SupportedTimezone;
    /**
     * 
     * @type {LocaleTag}
     * @memberof BotDTO
     */
    defaultLocale?: LocaleTag;
    /**
     * 
     * @type {Array<Country>}
     * @memberof BotDTO
     */
    supportedPhoneNumberLocales?: Array<Country>;
    /**
     * 
     * @type {Array<CcRecipientDTO>}
     * @memberof BotDTO
     */
    ccRecipients?: Array<CcRecipientDTO>;
    /**
     * 
     * @type {Array<FranchiseDTO>}
     * @memberof BotDTO
     */
    franchiseList?: Array<FranchiseDTO>;
    /**
     * 
     * @type {Array<KnowledgeRecordDTO>}
     * @memberof BotDTO
     */
    knowledgeRecords?: Array<KnowledgeRecordDTO>;
    /**
     * 
     * @type {Array<KnowledgeTypeDefinitionDTO>}
     * @memberof BotDTO
     */
    knowledgeTypes?: Array<KnowledgeTypeDefinitionDTO>;
    /**
     * 
     * @type {Array<KnowledgeAttributeDefinitionDTO>}
     * @memberof BotDTO
     */
    knowledgeAttributes?: Array<KnowledgeAttributeDefinitionDTO>;
    /**
     * 
     * @type {EmailConfigurationDTO}
     * @memberof BotDTO
     */
    emailConfiguration?: EmailConfigurationDTO;
    /**
     * 
     * @type {ToolSettingsDTO}
     * @memberof BotDTO
     */
    toolSettings?: ToolSettingsDTO;
    /**
     * 
     * @type {Array<ConfigurationIssue>}
     * @memberof BotDTO
     */
    configurationIssues?: Array<ConfigurationIssue>;
    /**
     * 
     * @type {Array<WarningUi>}
     * @memberof BotDTO
     */
    warnings?: Array<WarningUi>;
}


/**
 * @export
 */
export const BotDTOOpenAiModelEnum = {
    _6Sol: 'gpt-5.6-sol',
    _6Terra: 'gpt-5.6-terra',
    _6Luna: 'gpt-5.6-luna',
    _4: 'gpt-5.4',
    _4Nano: 'gpt-5.4-nano',
    _4Mini: 'gpt-5.4-mini'
} as const;
export type BotDTOOpenAiModelEnum = typeof BotDTOOpenAiModelEnum[keyof typeof BotDTOOpenAiModelEnum];

/**
 * 
 * @export
 * @interface BotInListDTO
 */
export interface BotInListDTO {
    /**
     * 
     * @type {string}
     * @memberof BotInListDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof BotInListDTO
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof BotInListDTO
     */
    siteURL: string;
    /**
     * 
     * @type {number}
     * @memberof BotInListDTO
     */
    conversationCountAllTime: number;
    /**
     * 
     * @type {number}
     * @memberof BotInListDTO
     */
    conversationCountLastRenewalDate: number;
    /**
     * 
     * @type {number}
     * @memberof BotInListDTO
     */
    usedConversationPercentage: number;
    /**
     * 
     * @type {boolean}
     * @memberof BotInListDTO
     */
    hasConfigurationErrors?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotInListDTO
     */
    hasWarnings?: boolean;
}
/**
 * 
 * @export
 * @interface BotInfoResponse
 */
export interface BotInfoResponse {
    /**
     * 
     * @type {string}
     * @memberof BotInfoResponse
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof BotInfoResponse
     */
    siteName: string;
    /**
     * 
     * @type {BotType}
     * @memberof BotInfoResponse
     */
    botType: BotType;
}


/**
 * 
 * @export
 * @interface BotIntegrations
 */
export interface BotIntegrations {
    /**
     * 
     * @type {SuperchatConfigurationDTO}
     * @memberof BotIntegrations
     */
    superchatConfiguration?: SuperchatConfigurationDTO;
}
/**
 * 
 * @export
 * @interface BotOptionDTO
 */
export interface BotOptionDTO {
    /**
     * 
     * @type {number}
     * @memberof BotOptionDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BotOptionDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof BotOptionDTO
     */
    siteName?: string;
}
/**
 * 
 * @export
 * @interface BotTableRequest
 */
export interface BotTableRequest {
    /**
     * 
     * @type {number}
     * @memberof BotTableRequest
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof BotTableRequest
     */
    pageSize: number;
    /**
     * 
     * @type {BotTableSortingField}
     * @memberof BotTableRequest
     */
    sortBy?: BotTableSortingField;
    /**
     * 
     * @type {SortDirection}
     * @memberof BotTableRequest
     */
    sortDirection?: SortDirection;
    /**
     * 
     * @type {string}
     * @memberof BotTableRequest
     */
    searchQuery?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BotTableRequest
     */
    botTypes?: Array<BotTableRequestBotTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BotTableRequest
     */
    franchisePublicIds?: Array<string>;
    /**
     * 
     * @type {PageableObject}
     * @memberof BotTableRequest
     */
    pageable?: PageableObject;
}


/**
 * @export
 */
export const BotTableRequestBotTypesEnum = {
    AimeStarter: 'AIME_STARTER',
    AimeStock: 'AIME_STOCK',
    AimePx: 'AIME_PX',
    AimeFinance: 'AIME_FINANCE',
    AimeReservation: 'AIME_RESERVATION',
    TmcAime: 'TMC_AIME',
    AimeBuy: 'AIME_BUY'
} as const;
export type BotTableRequestBotTypesEnum = typeof BotTableRequestBotTypesEnum[keyof typeof BotTableRequestBotTypesEnum];

/**
 * 
 * @export
 * @interface BotTableResponse
 */
export interface BotTableResponse {
    /**
     * 
     * @type {Array<BotInListDTO>}
     * @memberof BotTableResponse
     */
    bots: Array<BotInListDTO>;
    /**
     * 
     * @type {number}
     * @memberof BotTableResponse
     */
    totalCount: number;
}
/**
 * 
 * @export
 */
export const BotTableSortingField = {
    Name: 'NAME',
    Website: 'WEBSITE',
    ConversationCountAllTime: 'CONVERSATION_COUNT_ALL_TIME',
    UsedConversationPercentage: 'USED_CONVERSATION_PERCENTAGE'
} as const;
export type BotTableSortingField = typeof BotTableSortingField[keyof typeof BotTableSortingField];

/**
 * 
 * @export
 * @interface BotTranscriptUi
 */
export interface BotTranscriptUi {
    /**
     * 
     * @type {string}
     * @memberof BotTranscriptUi
     */
    botType: BotTranscriptUiBotTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BotTranscriptUi
     */
    siteName: string;
    /**
     * 
     * @type {Array<CcRecipientDTO>}
     * @memberof BotTranscriptUi
     */
    notificationRecipients?: Array<CcRecipientDTO>;
}


/**
 * @export
 */
export const BotTranscriptUiBotTypeEnum = {
    AimeStarter: 'AIME_STARTER',
    AimeStock: 'AIME_STOCK',
    AimePx: 'AIME_PX',
    AimeFinance: 'AIME_FINANCE',
    AimeReservation: 'AIME_RESERVATION',
    TmcAime: 'TMC_AIME',
    AimeBuy: 'AIME_BUY'
} as const;
export type BotTranscriptUiBotTypeEnum = typeof BotTranscriptUiBotTypeEnum[keyof typeof BotTranscriptUiBotTypeEnum];


/**
 * 
 * @export
 */
export const BotType = {
    AimeStarter: 'AIME_STARTER',
    AimeStock: 'AIME_STOCK',
    AimePx: 'AIME_PX',
    AimeFinance: 'AIME_FINANCE',
    AimeReservation: 'AIME_RESERVATION',
    TmcAime: 'TMC_AIME',
    AimeBuy: 'AIME_BUY'
} as const;
export type BotType = typeof BotType[keyof typeof BotType];

/**
 * 
 * @export
 * @interface BotWithoutToolSettingsDTO
 */
export interface BotWithoutToolSettingsDTO {
    /**
     * 
     * @type {number}
     * @memberof BotWithoutToolSettingsDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    siteName?: string;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    siteURL?: string;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    groupHash?: string;
    /**
     * 
     * @type {BotType}
     * @memberof BotWithoutToolSettingsDTO
     */
    botType?: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof BotWithoutToolSettingsDTO
     */
    useMultiAgent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotWithoutToolSettingsDTO
     */
    vehicleProviderWarningEmailEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotWithoutToolSettingsDTO
     */
    externalCommunicationsDisabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BotWithoutToolSettingsDTO
     */
    isReimportFinished?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BotWithoutToolSettingsDTO
     */
    conversationLimit?: number;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    lastRenewalDate?: string;
    /**
     * 
     * @type {number}
     * @memberof BotWithoutToolSettingsDTO
     */
    workingRange?: number;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof BotWithoutToolSettingsDTO
     */
    redirectProvider?: RedirectProvider;
    /**
     * 
     * @type {UrlProcessorConfigurationDTO}
     * @memberof BotWithoutToolSettingsDTO
     */
    urlProcessorConfiguration?: UrlProcessorConfigurationDTO;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof BotWithoutToolSettingsDTO
     */
    openAiModel?: BotWithoutToolSettingsDTOOpenAiModelEnum;
    /**
     * 
     * @type {SupportedTimezone}
     * @memberof BotWithoutToolSettingsDTO
     */
    timezone?: SupportedTimezone;
    /**
     * 
     * @type {LocaleTag}
     * @memberof BotWithoutToolSettingsDTO
     */
    defaultLocale?: LocaleTag;
    /**
     * 
     * @type {Array<Country>}
     * @memberof BotWithoutToolSettingsDTO
     */
    supportedPhoneNumberLocales?: Array<Country>;
    /**
     * 
     * @type {Array<FranchiseDTO>}
     * @memberof BotWithoutToolSettingsDTO
     */
    franchiseList?: Array<FranchiseDTO>;
    /**
     * 
     * @type {EmailConfigurationDTO}
     * @memberof BotWithoutToolSettingsDTO
     */
    emailConfiguration?: EmailConfigurationDTO;
}


/**
 * @export
 */
export const BotWithoutToolSettingsDTOOpenAiModelEnum = {
    _6Sol: 'gpt-5.6-sol',
    _6Terra: 'gpt-5.6-terra',
    _6Luna: 'gpt-5.6-luna',
    _4: 'gpt-5.4',
    _4Nano: 'gpt-5.4-nano',
    _4Mini: 'gpt-5.4-mini'
} as const;
export type BotWithoutToolSettingsDTOOpenAiModelEnum = typeof BotWithoutToolSettingsDTOOpenAiModelEnum[keyof typeof BotWithoutToolSettingsDTOOpenAiModelEnum];

/**
 * @type CancelChatBooking200Response
 * 
 * @export
 */
export type CancelChatBooking200Response = AgentHandoverChatEventDTO | BookedCallBackChatEventDTO | BookedEmailFollowUpChatEventDTO | BookedServiceCallBackChatEventDTO | BookedTestDriveChatEventDTO | CheckedCallBackBookingAvailabilityChatEventDTO | CheckedTestDriveBookingAvailabilityChatEventDTO | HumanHandoverChatEventDTO | RequestedCallbackChatEventDTO | RequestedEmailFollowUpChatEventDTO | RequestedLimitedFinanceIllustrationChatEventDTO | RequestedLimitedVehicleInformationChatEventDTO | RequestedLimitedVehicleReservationChatEventDTO | RequestedLimitedVehicleValuationChatEventDTO | RequestedServiceCallbackChatEventDTO | RequestedTestDriveChatEventDTO | ReservedVehicleChatEventDTO | ReturnedAftersalesInformationChatEventDTO | ReturnedAftersalesWorkingHoursChatEventDTO | ReturnedCompanyInformationChatEventDTO | ReturnedCompanyWorkingHoursChatEventDTO | ReturnedFinanceApplicationChatEventDTO | ReturnedFinanceQuoteChatEventDTO | ReturnedFuelCostChatEventDTO | ReturnedJourneyDetailsChatEventDTO | ReturnedLocationInformationChatEventDTO | ReturnedNewVehicleInformationChatEventDTO | ReturnedRecallUrlChatEventDTO | ReturnedServiceBookingUrlChatEventDTO | ReturnedStripeFormChatEventDTO | ReturnedUsedVehicleInformationChatEventDTO | ReturnedVehicleValuationChatEventDTO;
/**
 * 
 * @export
 * @interface CcRecipientDTO
 */
export interface CcRecipientDTO {
    /**
     * 
     * @type {string}
     * @memberof CcRecipientDTO
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CcRecipientDTO
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface ChatEventDTO
 */
export interface ChatEventDTO {
    /**
     * 
     * @type {number}
     * @memberof ChatEventDTO
     */
    id: number;
    /**
     * 
     * @type {EventType}
     * @memberof ChatEventDTO
     */
    event_type: EventType;
}


/**
 * 
 * @export
 * @interface ChatHistoryDTO
 */
export interface ChatHistoryDTO {
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTO
     */
    id: number;
    /**
     * 
     * @type {MessageRole}
     * @memberof ChatHistoryDTO
     */
    messageRole: MessageRole;
    /**
     * 
     * @type {MessageType}
     * @memberof ChatHistoryDTO
     */
    messageType?: MessageType;
    /**
     * 
     * @type {InputType}
     * @memberof ChatHistoryDTO
     */
    inputType?: InputType;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    timestamp: string;
    /**
     * 
     * @type {ConversationDTO}
     * @memberof ChatHistoryDTO
     */
    conversation: ConversationDTO;
    /**
     * 
     * @type {UserDTO}
     * @memberof ChatHistoryDTO
     */
    user: UserDTO;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    fullJsonMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    message?: string;
    /**
     * 
     * @type {Array<VehicleDataDTO>}
     * @memberof ChatHistoryDTO
     */
    vehicleDataList?: Array<VehicleDataDTO>;
    /**
     * 
     * @type {Array<OfferCardDataDTO>}
     * @memberof ChatHistoryDTO
     */
    offerCardDataList?: Array<OfferCardDataDTO>;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    videoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    toolCallId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    toolResponse?: string;
    /**
     * 
     * @type {Array<ToolCallDTO>}
     * @memberof ChatHistoryDTO
     */
    toolCalls?: Array<ToolCallDTO>;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    stripeMessageStatus?: ChatHistoryDTOStripeMessageStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTO
     */
    stripePaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    pageFullUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryDTO
     */
    isSuccessfulResponse?: boolean;
    /**
     * 
     * @type {ChatHistoryDTOResponseDuration}
     * @memberof ChatHistoryDTO
     */
    responseDuration?: ChatHistoryDTOResponseDuration;
    /**
     * 
     * @type {ChatHistoryDTOResponseDuration}
     * @memberof ChatHistoryDTO
     */
    completionDuration?: ChatHistoryDTOResponseDuration;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTO
     */
    inputTokens?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTO
     */
    outputTokens?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTO
     */
    totalInputTokens?: number;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTO
     */
    totalOutputTokens?: number;
    /**
     * 
     * @type {AgentName}
     * @memberof ChatHistoryDTO
     */
    responseAgent?: AgentName;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    activeFranchisePublicId?: string;
    /**
     * 
     * @type {HierarchyContextSource}
     * @memberof ChatHistoryDTO
     */
    activeFranchiseContextSource?: HierarchyContextSource;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryDTO
     */
    activeLocationPublicId?: string;
    /**
     * 
     * @type {HierarchyContextSource}
     * @memberof ChatHistoryDTO
     */
    activeLocationContextSource?: HierarchyContextSource;
}


/**
 * @export
 */
export const ChatHistoryDTOStripeMessageStatusEnum = {
    NotPaid: 'NOT_PAID',
    Processing: 'PROCESSING',
    PaidNotConfirmed: 'PAID_NOT_CONFIRMED',
    PaidConfirmed: 'PAID_CONFIRMED'
} as const;
export type ChatHistoryDTOStripeMessageStatusEnum = typeof ChatHistoryDTOStripeMessageStatusEnum[keyof typeof ChatHistoryDTOStripeMessageStatusEnum];

/**
 * 
 * @export
 * @interface ChatHistoryDTOResponseDuration
 */
export interface ChatHistoryDTOResponseDuration {
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTOResponseDuration
     */
    seconds?: number;
    /**
     * 
     * @type {Array<ChatHistoryDTOResponseDurationUnitsInner>}
     * @memberof ChatHistoryDTOResponseDuration
     */
    units?: Array<ChatHistoryDTOResponseDurationUnitsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryDTOResponseDuration
     */
    positive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryDTOResponseDuration
     */
    zero?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryDTOResponseDuration
     */
    negative?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryDTOResponseDuration
     */
    nano?: number;
}
/**
 * 
 * @export
 * @interface ChatHistoryDTOResponseDurationUnitsInner
 */
export interface ChatHistoryDTOResponseDurationUnitsInner {
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryDTOResponseDurationUnitsInner
     */
    durationEstimated?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryDTOResponseDurationUnitsInner
     */
    dateBased?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryDTOResponseDurationUnitsInner
     */
    timeBased?: boolean;
}
/**
 * 
 * @export
 * @interface ChatHistoryResponse
 */
export interface ChatHistoryResponse {
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryResponse
     */
    id: number;
    /**
     * 
     * @type {MessageRole}
     * @memberof ChatHistoryResponse
     */
    messageRole: MessageRole;
    /**
     * 
     * @type {MessageType}
     * @memberof ChatHistoryResponse
     */
    messageType?: MessageType;
    /**
     * 
     * @type {InputType}
     * @memberof ChatHistoryResponse
     */
    inputType?: InputType;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryResponse
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<VehicleDataDTO>}
     * @memberof ChatHistoryResponse
     */
    vehicleDataList?: Array<VehicleDataDTO>;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryResponse
     */
    videoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryResponse
     */
    toolCallId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryResponse
     */
    toolResponse?: string;
    /**
     * 
     * @type {Array<ToolCallDTO>}
     * @memberof ChatHistoryResponse
     */
    toolCalls?: Array<ToolCallDTO>;
    /**
     * 
     * @type {StripeMessageStatus}
     * @memberof ChatHistoryResponse
     */
    stripeMessageStatus?: StripeMessageStatus;
    /**
     * 
     * @type {number}
     * @memberof ChatHistoryResponse
     */
    stripePaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof ChatHistoryResponse
     */
    pageFullUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatHistoryResponse
     */
    isSuccessfulResponse?: boolean;
    /**
     * 
     * @type {ChatHistoryDTOResponseDuration}
     * @memberof ChatHistoryResponse
     */
    responseDuration?: ChatHistoryDTOResponseDuration;
    /**
     * 
     * @type {ChatHistoryDTOResponseDuration}
     * @memberof ChatHistoryResponse
     */
    completionDuration?: ChatHistoryDTOResponseDuration;
}


/**
 * 
 * @export
 * @interface CheckedCallBackBookingAvailabilityChatEventDTO
 */
export interface CheckedCallBackBookingAvailabilityChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckedCallBackBookingAvailabilityChatEventDTO
     */
    checked_date: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedCallBackBookingAvailabilityChatEventDTO
     */
    checked_time: string;
    /**
     * 
     * @type {AvailabilityCheckStatus}
     * @memberof CheckedCallBackBookingAvailabilityChatEventDTO
     */
    check_status: AvailabilityCheckStatus;
}


/**
 * 
 * @export
 * @interface CheckedTestDriveBookingAvailabilityChatEventDTO
 */
export interface CheckedTestDriveBookingAvailabilityChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    vds_internal_id?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    vehicle_make?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    vehicle_model?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    vehicle_variant?: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    checked_date: string;
    /**
     * 
     * @type {string}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    checked_time: string;
    /**
     * 
     * @type {AvailabilityCheckStatus}
     * @memberof CheckedTestDriveBookingAvailabilityChatEventDTO
     */
    check_status: AvailabilityCheckStatus;
}



/**
 * 
 * @export
 */
export const ClickAction = {
    SendMessage: 'SEND_MESSAGE',
    RedirectToDetailsPage: 'REDIRECT_TO_DETAILS_PAGE'
} as const;
export type ClickAction = typeof ClickAction[keyof typeof ClickAction];

/**
 * 
 * @export
 * @interface CloneAssistantRequest
 */
export interface CloneAssistantRequest {
    /**
     * 
     * @type {string}
     * @memberof CloneAssistantRequest
     */
    namePrefix: string;
    /**
     * 
     * @type {boolean}
     * @memberof CloneAssistantRequest
     */
    copyFranchisesAndLocations: boolean;
    /**
     * 
     * @type {EmailCloneStrategy}
     * @memberof CloneAssistantRequest
     */
    emailStrategy?: EmailCloneStrategy;
    /**
     * 
     * @type {string}
     * @memberof CloneAssistantRequest
     */
    placeholderEmail?: string;
}


/**
 * 
 * @export
 * @interface ConditionDTO
 */
export interface ConditionDTO {
    /**
     * 
     * @type {number}
     * @memberof ConditionDTO
     */
    id?: number;
    /**
     * 
     * @type {ConditionOperator}
     * @memberof ConditionDTO
     */
    operator: ConditionOperator;
    /**
     * 
     * @type {ConditionField}
     * @memberof ConditionDTO
     */
    conditionField: ConditionField;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionDTO
     */
    comparedValues?: Array<string>;
}



/**
 * 
 * @export
 */
export const ConditionField = {
    ServiceHistory: 'SERVICE_HISTORY',
    VehicleCondition: 'VEHICLE_CONDITION',
    Mileage: 'MILEAGE',
    Price: 'PRICE',
    OutstandingFinances: 'OUTSTANDING_FINANCES',
    BodyType: 'BODY_TYPE',
    Drivetrain: 'DRIVETRAIN',
    EmissionClass: 'EMISSION_CLASS',
    FuelType: 'FUEL_TYPE',
    Make: 'MAKE',
    Model: 'MODEL',
    TransmissionType: 'TRANSMISSION_TYPE',
    Owners: 'OWNERS',
    FirstRegistrationYear: 'FIRST_REGISTRATION_YEAR'
} as const;
export type ConditionField = typeof ConditionField[keyof typeof ConditionField];

/**
 * 
 * @export
 * @interface ConditionGroupDTO
 */
export interface ConditionGroupDTO {
    /**
     * 
     * @type {number}
     * @memberof ConditionGroupDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionGroupDTO
     */
    isAllMatch: boolean;
    /**
     * 
     * @type {Set<ConditionDTO>}
     * @memberof ConditionGroupDTO
     */
    conditions?: Set<ConditionDTO>;
}
/**
 * 
 * @export
 * @interface ConditionGroupResponse
 */
export interface ConditionGroupResponse {
    /**
     * 
     * @type {number}
     * @memberof ConditionGroupResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConditionGroupResponse
     */
    isAllMatch: boolean;
    /**
     * 
     * @type {Set<ConditionResponse>}
     * @memberof ConditionGroupResponse
     */
    conditions: Set<ConditionResponse>;
}
/**
 * 
 * @export
 * @interface ConditionMultipliersDTO
 */
export interface ConditionMultipliersDTO {
    /**
     * 
     * @type {number}
     * @memberof ConditionMultipliersDTO
     */
    id?: number;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    excellentSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    goodSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    averageSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    belowAverageSubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ConditionMultipliersDTO
     */
    poorSubtraction?: SubtractionDTO;
}
/**
 * 
 * @export
 * @interface ConditionMultipliersUi
 */
export interface ConditionMultipliersUi {
    /**
     * 
     * @type {number}
     * @memberof ConditionMultipliersUi
     */
    id: number;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    excellentSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    goodSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    averageSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    belowAverageSubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ConditionMultipliersUi
     */
    poorSubtraction: SubtractionUi;
}

/**
 * 
 * @export
 */
export const ConditionOperator = {
    Present: 'PRESENT',
    NotPresent: 'NOT_PRESENT',
    EqualsString: 'EQUALS_STRING',
    NotEqualsString: 'NOT_EQUALS_STRING',
    Match: 'MATCH',
    NotMatch: 'NOT_MATCH',
    Contains: 'CONTAINS',
    NotContain: 'NOT_CONTAIN',
    More: 'MORE',
    Less: 'LESS',
    MoreAndEquals: 'MORE_AND_EQUALS',
    LessAndEquals: 'LESS_AND_EQUALS',
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    In: 'IN',
    NotIn: 'NOT_IN'
} as const;
export type ConditionOperator = typeof ConditionOperator[keyof typeof ConditionOperator];

/**
 * 
 * @export
 * @interface ConditionResponse
 */
export interface ConditionResponse {
    /**
     * 
     * @type {number}
     * @memberof ConditionResponse
     */
    id?: number;
    /**
     * 
     * @type {ConditionOperator}
     * @memberof ConditionResponse
     */
    operator: ConditionOperator;
    /**
     * 
     * @type {ConditionField}
     * @memberof ConditionResponse
     */
    conditionField: ConditionField;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConditionResponse
     */
    comparedValues?: Array<string>;
}


/**
 * 
 * @export
 * @interface ConfidentAiChatRequest
 */
export interface ConfidentAiChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ConfidentAiChatRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {ConfidentAiState}
     * @memberof ConfidentAiChatRequest
     */
    state?: ConfidentAiState;
    /**
     * 
     * @type {UserDTO}
     * @memberof ConfidentAiChatRequest
     */
    user?: UserDTO;
    /**
     * 
     * @type {Array<ConfidentAiSeedMessage>}
     * @memberof ConfidentAiChatRequest
     */
    messages: Array<ConfidentAiSeedMessage>;
    /**
     * 
     * @type {AgentRuntimeOverrides}
     * @memberof ConfidentAiChatRequest
     */
    agentRuntimeOverrides?: AgentRuntimeOverrides;
    /**
     * 
     * @type {number}
     * @memberof ConfidentAiChatRequest
     */
    maxMessageLength?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ConfidentAiChatRequest
     */
    isHumanHandoverEnabled: boolean;
    /**
     * 
     * @type {FocusedVehicle}
     * @memberof ConfidentAiChatRequest
     */
    focusedVehicle?: FocusedVehicle;
}
/**
 * 
 * @export
 * @interface ConfidentAiChatResponse
 */
export interface ConfidentAiChatResponse {
    /**
     * 
     * @type {ConfidentAiResponsePayload}
     * @memberof ConfidentAiChatResponse
     */
    response?: ConfidentAiResponsePayload;
    /**
     * 
     * @type {ConfidentAiState}
     * @memberof ConfidentAiChatResponse
     */
    state?: ConfidentAiState;
}
/**
 * 
 * @export
 * @interface ConfidentAiResponsePayload
 */
export interface ConfidentAiResponsePayload {
    /**
     * 
     * @type {string}
     * @memberof ConfidentAiResponsePayload
     */
    actual_output?: string;
    /**
     * 
     * @type {Array<CancelChatBooking200Response>}
     * @memberof ConfidentAiResponsePayload
     */
    chat_events?: Array<CancelChatBooking200Response>;
    /**
     * 
     * @type {Array<ConfidentAiToolCall>}
     * @memberof ConfidentAiResponsePayload
     */
    tools_called?: Array<ConfidentAiToolCall>;
}
/**
 * 
 * @export
 * @interface ConfidentAiSeedMessage
 */
export interface ConfidentAiSeedMessage {
    /**
     * 
     * @type {string}
     * @memberof ConfidentAiSeedMessage
     */
    role: ConfidentAiSeedMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfidentAiSeedMessage
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof ConfidentAiSeedMessage
     */
    timestamp: string;
}


/**
 * @export
 */
export const ConfidentAiSeedMessageRoleEnum = {
    User: 'USER',
    Assistant: 'ASSISTANT'
} as const;
export type ConfidentAiSeedMessageRoleEnum = typeof ConfidentAiSeedMessageRoleEnum[keyof typeof ConfidentAiSeedMessageRoleEnum];

/**
 * 
 * @export
 * @interface ConfidentAiState
 */
export interface ConfidentAiState {
    /**
     * 
     * @type {string}
     * @memberof ConfidentAiState
     */
    conversationId?: string;
}
/**
 * 
 * @export
 * @interface ConfidentAiToolCall
 */
export interface ConfidentAiToolCall {
    /**
     * 
     * @type {string}
     * @memberof ConfidentAiToolCall
     */
    name?: string;
    /**
     * 
     * @type {object}
     * @memberof ConfidentAiToolCall
     */
    output?: object;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ConfidentAiToolCall
     */
    input_parameters?: { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface ConfigurationIssue
 */
export interface ConfigurationIssue {
    /**
     * 
     * @type {string}
     * @memberof ConfigurationIssue
     */
    field?: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationIssue
     */
    message?: string;
}

/**
 * 
 * @export
 */
export const ConfigurationRegion = {
    Uk: 'UK',
    Ca: 'CA'
} as const;
export type ConfigurationRegion = typeof ConfigurationRegion[keyof typeof ConfigurationRegion];

/**
 * 
 * @export
 * @interface ConnectIntegrationRequest
 */
export interface ConnectIntegrationRequest {
    /**
     * 
     * @type {string}
     * @memberof ConnectIntegrationRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {Integration}
     * @memberof ConnectIntegrationRequest
     */
    integration: Integration;
    /**
     * 
     * @type {boolean}
     * @memberof ConnectIntegrationRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof ConnectIntegrationRequest
     */
    superchatApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectIntegrationRequest
     */
    superchatWebhookId?: string;
    /**
     * 
     * @type {string}
     * @memberof ConnectIntegrationRequest
     */
    superchatAimeUserEmail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConnectIntegrationRequest
     */
    superchatHandoverUserEmailList?: Array<string>;
}



/**
 * 
 * @export
 */
export const ContactCenterChannelType = {
    WhatsApp: 'WHATS_APP',
    Email: 'EMAIL',
    Sms: 'SMS'
} as const;
export type ContactCenterChannelType = typeof ContactCenterChannelType[keyof typeof ContactCenterChannelType];

/**
 * 
 * @export
 * @interface ContactCenterChatRequest
 */
export interface ContactCenterChatRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterChatRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterChatRequest
     */
    communicationId: string;
    /**
     * 
     * @type {number}
     * @memberof ContactCenterChatRequest
     */
    maxMessageLength?: number;
    /**
     * 
     * @type {ContactCenterChannelType}
     * @memberof ContactCenterChatRequest
     */
    channelType: ContactCenterChannelType;
    /**
     * 
     * @type {ContactCenterUserData}
     * @memberof ContactCenterChatRequest
     */
    userData?: ContactCenterUserData;
    /**
     * 
     * @type {Array<ContactCenterSeedMessage>}
     * @memberof ContactCenterChatRequest
     */
    messages: Array<ContactCenterSeedMessage>;
    /**
     * 
     * @type {FocusedVehicle}
     * @memberof ContactCenterChatRequest
     */
    focusedVehicle?: FocusedVehicle;
    /**
     * 
     * @type {boolean}
     * @memberof ContactCenterChatRequest
     */
    isHumanHandoverEnabled: boolean;
}


/**
 * 
 * @export
 * @interface ContactCenterChatResponse
 */
export interface ContactCenterChatResponse {
    /**
     * 
     * @type {UserDTO}
     * @memberof ContactCenterChatResponse
     */
    user?: UserDTO;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterChatResponse
     */
    message?: string;
    /**
     * 
     * @type {Array<CancelChatBooking200Response>}
     * @memberof ContactCenterChatResponse
     */
    chatEvents?: Array<CancelChatBooking200Response>;
}
/**
 * 
 * @export
 * @interface ContactCenterGenerateWelcomeMessageRequest
 */
export interface ContactCenterGenerateWelcomeMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {ContactCenterChannelType}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    channelType: ContactCenterChannelType;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    origin: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    goal: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    template: string;
    /**
     * 
     * @type {Array<ContactCenterSeedMessage>}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    messages?: Array<ContactCenterSeedMessage>;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    data?: { [key: string]: object; };
    /**
     * 
     * @type {ContactCenterUserData}
     * @memberof ContactCenterGenerateWelcomeMessageRequest
     */
    userData?: ContactCenterUserData;
}


/**
 * 
 * @export
 * @interface ContactCenterGenerateWelcomeMessageResponse
 */
export interface ContactCenterGenerateWelcomeMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterGenerateWelcomeMessageResponse
     */
    communicationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterGenerateWelcomeMessageResponse
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface ContactCenterQualificationRequest
 */
export interface ContactCenterQualificationRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterQualificationRequest
     */
    contactCenterCommunicationId: string;
    /**
     * 
     * @type {ContactCenterChannelType}
     * @memberof ContactCenterQualificationRequest
     */
    channelType: ContactCenterChannelType;
    /**
     * 
     * @type {Array<QualificationOption>}
     * @memberof ContactCenterQualificationRequest
     */
    qualificationOptions: Array<QualificationOption>;
}


/**
 * 
 * @export
 * @interface ContactCenterQualificationResponse
 */
export interface ContactCenterQualificationResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterQualificationResponse
     */
    contactCenterCommunicationId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterQualificationResponse
     */
    selectedOption?: string;
    /**
     * 
     * @type {number}
     * @memberof ContactCenterQualificationResponse
     */
    confidenceScore?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterQualificationResponse
     */
    confidenceReason?: string;
}
/**
 * 
 * @export
 * @interface ContactCenterSeedMessage
 */
export interface ContactCenterSeedMessage {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterSeedMessage
     */
    role: ContactCenterSeedMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterSeedMessage
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterSeedMessage
     */
    timestamp: string;
}


/**
 * @export
 */
export const ContactCenterSeedMessageRoleEnum = {
    User: 'USER',
    Assistant: 'ASSISTANT'
} as const;
export type ContactCenterSeedMessageRoleEnum = typeof ContactCenterSeedMessageRoleEnum[keyof typeof ContactCenterSeedMessageRoleEnum];

/**
 * 
 * @export
 * @interface ContactCenterStoreMessageRequest
 */
export interface ContactCenterStoreMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterStoreMessageRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterStoreMessageRequest
     */
    communicationId: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterStoreMessageRequest
     */
    messageRole: ContactCenterStoreMessageRequestMessageRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterStoreMessageRequest
     */
    message: string;
    /**
     * 
     * @type {ContactCenterChannelType}
     * @memberof ContactCenterStoreMessageRequest
     */
    channelType: ContactCenterChannelType;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterStoreMessageRequest
     */
    timestamp: string;
}


/**
 * @export
 */
export const ContactCenterStoreMessageRequestMessageRoleEnum = {
    User: 'USER',
    Assistant: 'ASSISTANT',
    Tool: 'TOOL'
} as const;
export type ContactCenterStoreMessageRequestMessageRoleEnum = typeof ContactCenterStoreMessageRequestMessageRoleEnum[keyof typeof ContactCenterStoreMessageRequestMessageRoleEnum];

/**
 * 
 * @export
 * @interface ContactCenterStoreMessageResponse
 */
export interface ContactCenterStoreMessageResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterStoreMessageResponse
     */
    status?: ContactCenterStoreMessageResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterStoreMessageResponse
     */
    errorMessage?: string;
}


/**
 * @export
 */
export const ContactCenterStoreMessageResponseStatusEnum = {
    Success: 'SUCCESS',
    Error: 'ERROR'
} as const;
export type ContactCenterStoreMessageResponseStatusEnum = typeof ContactCenterStoreMessageResponseStatusEnum[keyof typeof ContactCenterStoreMessageResponseStatusEnum];

/**
 * 
 * @export
 * @interface ContactCenterUserData
 */
export interface ContactCenterUserData {
    /**
     * 
     * @type {string}
     * @memberof ContactCenterUserData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterUserData
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactCenterUserData
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface ContactInformationResponse
 */
export interface ContactInformationResponse {
    /**
     * 
     * @type {string}
     * @memberof ContactInformationResponse
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformationResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformationResponse
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformationResponse
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformationResponse
     */
    town?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformationResponse
     */
    county?: string;
    /**
     * 
     * @type {string}
     * @memberof ContactInformationResponse
     */
    currentHomeAddress?: string;
}
/**
 * Content of the message
 * @export
 * @interface Content
 */
export interface Content {
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    body?: string;
    /**
     * 
     * @type {string}
     * @memberof Content
     */
    type?: ContentTypeEnum;
}


/**
 * @export
 */
export const ContentTypeEnum = {
    Text: 'text',
    Email: 'email',
    WhatsAppTemplate: 'whats_app_template',
    GenericTemplate: 'generic_template'
} as const;
export type ContentTypeEnum = typeof ContentTypeEnum[keyof typeof ContentTypeEnum];


/**
 * 
 * @export
 */
export const ConversationChannel = {
    Widget: 'WIDGET',
    SuperchatWhatsApp: 'SUPERCHAT_WHATS_APP',
    SuperchatEmail: 'SUPERCHAT_EMAIL',
    SuperchatSms: 'SUPERCHAT_SMS',
    SuperchatTelegram: 'SUPERCHAT_TELEGRAM',
    SuperchatInstagram: 'SUPERCHAT_INSTAGRAM',
    SuperchatFacebook: 'SUPERCHAT_FACEBOOK',
    ContactCenterWhatsApp: 'CONTACT_CENTER_WHATS_APP',
    ContactCenterEmail: 'CONTACT_CENTER_EMAIL',
    ContactCenterSms: 'CONTACT_CENTER_SMS',
    ConfidentAi: 'CONFIDENT_AI'
} as const;
export type ConversationChannel = typeof ConversationChannel[keyof typeof ConversationChannel];

/**
 * 
 * @export
 * @interface ConversationDTO
 */
export interface ConversationDTO {
    /**
     * 
     * @type {number}
     * @memberof ConversationDTO
     */
    id: number;
    /**
     * 
     * @type {UserDTO}
     * @memberof ConversationDTO
     */
    user: UserDTO;
    /**
     * 
     * @type {string}
     * @memberof ConversationDTO
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationDTO
     */
    closedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationDTO
     */
    lastMessageDateTime: string;
    /**
     * 
     * @type {ConversationType}
     * @memberof ConversationDTO
     */
    type: ConversationType;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof ConversationDTO
     */
    channel: ConversationChannel;
    /**
     * 
     * @type {InitializationType}
     * @memberof ConversationDTO
     */
    initializationType: InitializationType;
    /**
     * 
     * @type {Array<CancelChatBooking200Response>}
     * @memberof ConversationDTO
     */
    chatEvents: Array<CancelChatBooking200Response>;
}


/**
 * 
 * @export
 * @interface ConversationDetailResponse
 */
export interface ConversationDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof ConversationDetailResponse
     */
    conversationId: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationDetailResponse
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetailResponse
     */
    chatId: string;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof ConversationDetailResponse
     */
    channel: ConversationChannel;
    /**
     * 
     * @type {ConversationType}
     * @memberof ConversationDetailResponse
     */
    type: ConversationType;
    /**
     * 
     * @type {InitializationType}
     * @memberof ConversationDetailResponse
     */
    initializationType: InitializationType;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetailResponse
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetailResponse
     */
    closedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationDetailResponse
     */
    lastMessageDateTime: string;
    /**
     * 
     * @type {BotInfoResponse}
     * @memberof ConversationDetailResponse
     */
    bot: BotInfoResponse;
    /**
     * 
     * @type {Array<ChatHistoryResponse>}
     * @memberof ConversationDetailResponse
     */
    chatHistory: Array<ChatHistoryResponse>;
    /**
     * 
     * @type {Array<CancelChatBooking200Response>}
     * @memberof ConversationDetailResponse
     */
    chatEvents: Array<CancelChatBooking200Response>;
}


/**
 * 
 * @export
 * @interface ConversationListItemResponse
 */
export interface ConversationListItemResponse {
    /**
     * 
     * @type {number}
     * @memberof ConversationListItemResponse
     */
    conversationId: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationListItemResponse
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationListItemResponse
     */
    chatId: string;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof ConversationListItemResponse
     */
    channel: ConversationChannel;
    /**
     * 
     * @type {ConversationType}
     * @memberof ConversationListItemResponse
     */
    type: ConversationType;
    /**
     * 
     * @type {InitializationType}
     * @memberof ConversationListItemResponse
     */
    initializationType: InitializationType;
    /**
     * 
     * @type {string}
     * @memberof ConversationListItemResponse
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationListItemResponse
     */
    closedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationListItemResponse
     */
    lastMessageDateTime: string;
    /**
     * 
     * @type {number}
     * @memberof ConversationListItemResponse
     */
    messageCount: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationListItemResponse
     */
    eventCount: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationListItemResponse
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationListItemResponse
     */
    userEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof ConversationListItemResponse
     */
    userPhoneNumber?: string;
}



/**
 * 
 * @export
 */
export const ConversationStatus = {
    CustomerAssisted: 'CUSTOMER_ASSISTED',
    ContactDetailsProvided: 'CONTACT_DETAILS_PROVIDED'
} as const;
export type ConversationStatus = typeof ConversationStatus[keyof typeof ConversationStatus];

/**
 * 
 * @export
 * @interface ConversationSummaryResponse
 */
export interface ConversationSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof ConversationSummaryResponse
     */
    totalConversations: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationSummaryResponse
     */
    latestConversationId?: number;
    /**
     * 
     * @type {string}
     * @memberof ConversationSummaryResponse
     */
    latestConversationDate?: string;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof ConversationSummaryResponse
     */
    latestChannel?: ConversationChannel;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConversationSummaryResponse
     */
    channels?: Array<ConversationSummaryResponseChannelsEnum>;
}


/**
 * @export
 */
export const ConversationSummaryResponseChannelsEnum = {
    Widget: 'WIDGET',
    SuperchatWhatsApp: 'SUPERCHAT_WHATS_APP',
    SuperchatEmail: 'SUPERCHAT_EMAIL',
    SuperchatSms: 'SUPERCHAT_SMS',
    SuperchatTelegram: 'SUPERCHAT_TELEGRAM',
    SuperchatInstagram: 'SUPERCHAT_INSTAGRAM',
    SuperchatFacebook: 'SUPERCHAT_FACEBOOK',
    ContactCenterWhatsApp: 'CONTACT_CENTER_WHATS_APP',
    ContactCenterEmail: 'CONTACT_CENTER_EMAIL',
    ContactCenterSms: 'CONTACT_CENTER_SMS',
    ConfidentAi: 'CONFIDENT_AI'
} as const;
export type ConversationSummaryResponseChannelsEnum = typeof ConversationSummaryResponseChannelsEnum[keyof typeof ConversationSummaryResponseChannelsEnum];


/**
 * 
 * @export
 */
export const ConversationType = {
    Engaged: 'ENGAGED',
    Unengaged: 'UNENGAGED'
} as const;
export type ConversationType = typeof ConversationType[keyof typeof ConversationType];

/**
 * 
 * @export
 * @interface ConversationsPageResponse
 */
export interface ConversationsPageResponse {
    /**
     * 
     * @type {Array<ConversationListItemResponse>}
     * @memberof ConversationsPageResponse
     */
    content?: Array<ConversationListItemResponse>;
    /**
     * 
     * @type {PageableInfo}
     * @memberof ConversationsPageResponse
     */
    pageable?: PageableInfo;
    /**
     * 
     * @type {number}
     * @memberof ConversationsPageResponse
     */
    totalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationsPageResponse
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof ConversationsPageResponse
     */
    size?: number;
}

/**
 * 
 * @export
 */
export const ConvoStarterVisibility = {
    Bubble: 'BUBBLE',
    Chat: 'CHAT'
} as const;
export type ConvoStarterVisibility = typeof ConvoStarterVisibility[keyof typeof ConvoStarterVisibility];


/**
 * 
 * @export
 */
export const Country = {
    Gb: 'GB',
    Ie: 'IE',
    Ca: 'CA',
    Us: 'US',
    Fr: 'FR'
} as const;
export type Country = typeof Country[keyof typeof Country];

/**
 * 
 * @export
 * @interface CreateBotRequest
 */
export interface CreateBotRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    publicId: string;
    /**
     * 
     * @type {BotType}
     * @memberof CreateBotRequest
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    useMultiAgent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    vehicleProviderWarningEmailEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    externalCommunicationsDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    isReimportFinished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    siteURL: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    groupHash?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    conversationLimit: number;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    workingRange?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    lastRenewalDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    openAiModel?: CreateBotRequestOpenAiModelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBotRequest
     */
    publicFranchiseIdList: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    assistantEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    assistantEmailPassword?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateBotRequest
     */
    emailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    filtrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    transcriptSummaryEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    sharingLinkEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    surveyAfterMessagesEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    surveyAfterMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    surveyAfterBookingEnabled: boolean;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof CreateBotRequest
     */
    redirectProvider: RedirectProvider;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBotRequest
     */
    urlProcessorEnabled: boolean;
    /**
     * 
     * @type {MatchField}
     * @memberof CreateBotRequest
     */
    matchField?: MatchField;
    /**
     * 
     * @type {MatchType}
     * @memberof CreateBotRequest
     */
    matchType?: MatchType;
    /**
     * 
     * @type {number}
     * @memberof CreateBotRequest
     */
    segmentNumberFromTheEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    timezone?: CreateBotRequestTimezoneEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateBotRequest
     */
    defaultLocale?: CreateBotRequestDefaultLocaleEnum;
    /**
     * 
     * @type {Array<Country>}
     * @memberof CreateBotRequest
     */
    supportedPhoneNumberLocales: Array<Country>;
    /**
     * 
     * @type {Array<CcRecipientDTO>}
     * @memberof CreateBotRequest
     */
    ccRecipients?: Array<CcRecipientDTO>;
}


/**
 * @export
 */
export const CreateBotRequestOpenAiModelEnum = {
    _6Sol: 'gpt-5.6-sol',
    _6Terra: 'gpt-5.6-terra',
    _6Luna: 'gpt-5.6-luna',
    _4: 'gpt-5.4',
    _4Nano: 'gpt-5.4-nano',
    _4Mini: 'gpt-5.4-mini'
} as const;
export type CreateBotRequestOpenAiModelEnum = typeof CreateBotRequestOpenAiModelEnum[keyof typeof CreateBotRequestOpenAiModelEnum];

/**
 * @export
 */
export const CreateBotRequestTimezoneEnum = {
    EuropeLondon: 'EUROPE_LONDON',
    EuropeParis: 'EUROPE_PARIS',
    EuropeBerlin: 'EUROPE_BERLIN',
    EuropeMadrid: 'EUROPE_MADRID',
    AsiaTokyo: 'ASIA_TOKYO',
    AsiaDubai: 'ASIA_DUBAI',
    AmericaNewYork: 'AMERICA_NEW_YORK',
    AmericaToronto: 'AMERICA_TORONTO'
} as const;
export type CreateBotRequestTimezoneEnum = typeof CreateBotRequestTimezoneEnum[keyof typeof CreateBotRequestTimezoneEnum];

/**
 * @export
 */
export const CreateBotRequestDefaultLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type CreateBotRequestDefaultLocaleEnum = typeof CreateBotRequestDefaultLocaleEnum[keyof typeof CreateBotRequestDefaultLocaleEnum];

/**
 * 
 * @export
 * @interface CreateFranchiseRequest
 */
export interface CreateFranchiseRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateFranchiseRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFranchiseRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFranchiseRequest
     */
    franchiseHash?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateFranchiseRequest
     */
    urlPathPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFranchiseRequest
     */
    focusEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFranchiseRequest
     */
    sharedWithFocusedFranchises: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFranchiseRequest
     */
    franchiseEmailTranscriptRecipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFranchiseRequest
     */
    franchiseEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateFranchiseRequest
     */
    franchiseEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {CreateNewVehicleDataConfigurationRequest}
     * @memberof CreateFranchiseRequest
     */
    newVehicleDataConfiguration: CreateNewVehicleDataConfigurationRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateFranchiseRequest
     */
    publicLocationIdList: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateLocationRequest
 */
export interface CreateLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {CreateWorkScheduleRequest}
     * @memberof CreateLocationRequest
     */
    workSchedule: CreateWorkScheduleRequest;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof CreateLocationRequest
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    advertiserId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    filePath?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    feedId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    locationHash?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequest
     */
    locationEmailTranscriptRecipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationRequest
     */
    locationEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationRequest
     */
    locationEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {EnquiryProvider}
     * @memberof CreateLocationRequest
     */
    enquiryProvider: EnquiryProvider;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    dragon2000DealerId?: string;
    /**
     * 
     * @type {ConfigurationRegion}
     * @memberof CreateLocationRequest
     */
    em2Region?: ConfigurationRegion;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationRequest
     */
    aftersalesEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    serviceBookingUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequest
     */
    recallUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateLocationRequest
     */
    aftersalesEmailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationRequest
     */
    aftersalesEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateLocationRequest
     */
    aftersalesEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {CreateWorkScheduleRequest}
     * @memberof CreateLocationRequest
     */
    aftersalesWorkSchedule: CreateWorkScheduleRequest;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CreateLocationRequest
     */
    supportedVehicleManufacturers?: { [key: string]: Array<string>; };
}


/**
 * @export
 */
export const CreateLocationRequestSupportedVehicleManufacturersEnum = {
    Car: 'CAR',
    Lcv: 'LCV',
    Bike: 'BIKE'
} as const;
export type CreateLocationRequestSupportedVehicleManufacturersEnum = typeof CreateLocationRequestSupportedVehicleManufacturersEnum[keyof typeof CreateLocationRequestSupportedVehicleManufacturersEnum];

/**
 * 
 * @export
 * @interface CreateNewVehicleDataConfigurationRequest
 */
export interface CreateNewVehicleDataConfigurationRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateNewVehicleDataConfigurationRequest
     */
    isEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateNewVehicleDataConfigurationRequest
     */
    vehicleType: CreateNewVehicleDataConfigurationRequestVehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateNewVehicleDataConfigurationRequest
     */
    manufacturer: string;
}


/**
 * @export
 */
export const CreateNewVehicleDataConfigurationRequestVehicleTypeEnum = {
    Car: 'CAR',
    Lcv: 'LCV',
    Bike: 'BIKE'
} as const;
export type CreateNewVehicleDataConfigurationRequestVehicleTypeEnum = typeof CreateNewVehicleDataConfigurationRequestVehicleTypeEnum[keyof typeof CreateNewVehicleDataConfigurationRequestVehicleTypeEnum];

/**
 * 
 * @export
 * @interface CreateOfferRequest
 */
export interface CreateOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    publicBotId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    publicLocationId?: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof CreateOfferRequest
     */
    offerStatus: OfferStatus;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    archivedAt?: string;
    /**
     * 
     * @type {OfferType}
     * @memberof CreateOfferRequest
     */
    offerType: OfferType;
    /**
     * 
     * @type {OfferSource}
     * @memberof CreateOfferRequest
     */
    offerSource: OfferSource;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    offerSourceName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    redirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    imageUrl: string;
    /**
     * 
     * @type {CreateSubtractionRequest}
     * @memberof CreateOfferRequest
     */
    discount?: CreateSubtractionRequest;
    /**
     * 
     * @type {Currency}
     * @memberof CreateOfferRequest
     */
    currency?: Currency;
    /**
     * 
     * @type {string}
     * @memberof CreateOfferRequest
     */
    financeProduct?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    cashPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    monthlyPayments?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    customerDeposit?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    manufacturerDepositContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    totalDeposit?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    dealerContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    balanceToFinance?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    totalAmountPayable?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    totalChargeForCredit?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    optionalFinalPayment?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    durationOfAgreementInMonths?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    apr?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    fixedInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    mileagePerAnnum?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOfferRequest
     */
    excessMileageCharge?: number;
}


/**
 * 
 * @export
 * @interface CreateStripeIntentRequest
 */
export interface CreateStripeIntentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateStripeIntentRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateStripeIntentRequest
     */
    chatId: string;
}
/**
 * 
 * @export
 * @interface CreateSubtractionRequest
 */
export interface CreateSubtractionRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateSubtractionRequest
     */
    subtractionValue: number;
    /**
     * 
     * @type {SubtractionType}
     * @memberof CreateSubtractionRequest
     */
    subtractionType: SubtractionType;
}


/**
 * 
 * @export
 * @interface CreateWorkScheduleRequest
 */
export interface CreateWorkScheduleRequest {
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    monday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    tuesday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    wednesday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    thursday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    friday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    saturday: CreateWorkingHoursRequest;
    /**
     * 
     * @type {CreateWorkingHoursRequest}
     * @memberof CreateWorkScheduleRequest
     */
    sunday: CreateWorkingHoursRequest;
}
/**
 * 
 * @export
 * @interface CreateWorkingHoursRequest
 */
export interface CreateWorkingHoursRequest {
    /**
     * 
     * @type {LocalTime}
     * @memberof CreateWorkingHoursRequest
     */
    openTime?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof CreateWorkingHoursRequest
     */
    closeTime?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof CreateWorkingHoursRequest
     */
    isClosed: boolean;
}

/**
 * 
 * @export
 */
export const Currency = {
    Gbp: 'GBP',
    Usd: 'USD',
    Eur: 'EUR',
    Jpy: 'JPY',
    Aed: 'AED',
    Cad: 'CAD'
} as const;
export type Currency = typeof Currency[keyof typeof Currency];

/**
 * 
 * @export
 * @interface DefaultWidgetAppearanceSettingUi
 */
export interface DefaultWidgetAppearanceSettingUi {
    /**
     * 
     * @type {LocaleTag}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    locale: LocaleTag;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    brandColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    showFooterMessage: boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    footerMessage: string;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    showTerms: boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    termsTitle: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    termsUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {number}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    popUpDelaySec: number;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    initialBotMessage: string;
    /**
     * 
     * @type {Array<FullConvoStartersUI>}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    convoStarters?: Array<FullConvoStartersUI>;
    /**
     * 
     * @type {Array<VehicleDetailsButtonUi>}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    vehicleDetailsButtons?: Array<VehicleDetailsButtonUi>;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    enablePersonalizedVehicleDescription: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    gtmAnalyticsEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    assistantName: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultWidgetAppearanceSettingUi
     */
    personaPrompt: string;
}


/**
 * 
 * @export
 * @interface DeleteIntegrationRequest
 */
export interface DeleteIntegrationRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteIntegrationRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {number}
     * @memberof DeleteIntegrationRequest
     */
    configurationId: number;
    /**
     * 
     * @type {Integration}
     * @memberof DeleteIntegrationRequest
     */
    integration: Integration;
}



/**
 * 
 * @export
 */
export const DistanceUnit = {
    Miles: 'MILES',
    Kilometers: 'KILOMETERS'
} as const;
export type DistanceUnit = typeof DistanceUnit[keyof typeof DistanceUnit];

/**
 * 
 * @export
 * @interface Dragon2000EnquiryConfigurationDTO
 */
export interface Dragon2000EnquiryConfigurationDTO extends EnquiryConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof Dragon2000EnquiryConfigurationDTO
     */
    dealerId: string;
}



/**
 * 
 * @export
 */
export const DrivingLicence = {
    Full: 'FULL',
    Provisional: 'PROVISIONAL',
    None: 'NONE'
} as const;
export type DrivingLicence = typeof DrivingLicence[keyof typeof DrivingLicence];

/**
 * 
 * @export
 * @interface Em2DepartmentHashMappingDTO
 */
export interface Em2DepartmentHashMappingDTO {
    /**
     * 
     * @type {number}
     * @memberof Em2DepartmentHashMappingDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Em2DepartmentHashMappingDTO
     */
    departmentHash: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Em2DepartmentHashMappingDTO
     */
    eventTypes: Array<Em2DepartmentHashMappingDTOEventTypesEnum>;
}


/**
 * @export
 */
export const Em2DepartmentHashMappingDTOEventTypesEnum = {
    ReturnedLocationInformation: 'RETURNED_LOCATION_INFORMATION',
    ReturnedCompanyInformation: 'RETURNED_COMPANY_INFORMATION',
    ReturnedCompanyWorkingHours: 'RETURNED_COMPANY_WORKING_HOURS',
    ReturnedJourneyDetails: 'RETURNED_JOURNEY_DETAILS',
    CheckedTestDriveBookingAvailability: 'CHECKED_TEST_DRIVE_BOOKING_AVAILABILITY',
    CheckedCallBackBookingAvailability: 'CHECKED_CALL_BACK_BOOKING_AVAILABILITY',
    RequestedCallback: 'REQUESTED_CALLBACK',
    RequestedTestDrive: 'REQUESTED_TEST_DRIVE',
    RequestedEmailFollowUp: 'REQUESTED_EMAIL_FOLLOW_UP',
    RequestedServiceCallback: 'REQUESTED_SERVICE_CALLBACK',
    BookedCallBack: 'BOOKED_CALL_BACK',
    BookedEmailFollowUp: 'BOOKED_EMAIL_FOLLOW_UP',
    BookedTestDrive: 'BOOKED_TEST_DRIVE',
    ReturnedUsedVehicleInformation: 'RETURNED_USED_VEHICLE_INFORMATION',
    ReturnedNewVehicleInformation: 'RETURNED_NEW_VEHICLE_INFORMATION',
    ReturnedVehicleValuation: 'RETURNED_VEHICLE_VALUATION',
    ReturnedFinanceQuote: 'RETURNED_FINANCE_QUOTE',
    ReturnedFinanceApplication: 'RETURNED_FINANCE_APPLICATION',
    ReturnedStripeForm: 'RETURNED_STRIPE_FORM',
    ReservedVehicle: 'RESERVED_VEHICLE',
    RequestedLimitedVehicleInformation: 'REQUESTED_LIMITED_VEHICLE_INFORMATION',
    RequestedLimitedFinanceIllustration: 'REQUESTED_LIMITED_FINANCE_ILLUSTRATION',
    RequestedLimitedVehicleValuation: 'REQUESTED_LIMITED_VEHICLE_VALUATION',
    RequestedLimitedVehicleReservation: 'REQUESTED_LIMITED_VEHICLE_RESERVATION',
    AgentHandover: 'AGENT_HANDOVER',
    HumanHandover: 'HUMAN_HANDOVER',
    ReturnedAftersalesInformation: 'RETURNED_AFTERSALES_INFORMATION',
    ReturnedAftersalesWorkingHours: 'RETURNED_AFTERSALES_WORKING_HOURS',
    ReturnedServiceBookingUrl: 'RETURNED_SERVICE_BOOKING_URL',
    ReturnedRecallUrl: 'RETURNED_RECALL_URL',
    BookedServiceCallBack: 'BOOKED_SERVICE_CALL_BACK',
    ReturnedFuelCost: 'RETURNED_FUEL_COST'
} as const;
export type Em2DepartmentHashMappingDTOEventTypesEnum = typeof Em2DepartmentHashMappingDTOEventTypesEnum[keyof typeof Em2DepartmentHashMappingDTOEventTypesEnum];

/**
 * 
 * @export
 * @interface Em2EnquiryConfigurationDTO
 */
export interface Em2EnquiryConfigurationDTO extends EnquiryConfigurationDTO {
    /**
     * 
     * @type {ConfigurationRegion}
     * @memberof Em2EnquiryConfigurationDTO
     */
    region?: ConfigurationRegion;
    /**
     * 
     * @type {Array<Em2DepartmentHashMappingDTO>}
     * @memberof Em2EnquiryConfigurationDTO
     */
    departmentHashMappings?: Array<Em2DepartmentHashMappingDTO>;
    /**
     * 
     * @type {Array<Em2EnquiryTypeMappingDTO>}
     * @memberof Em2EnquiryConfigurationDTO
     */
    enquiryTypeMappings?: Array<Em2EnquiryTypeMappingDTO>;
}


/**
 * 
 * @export
 * @interface Em2EnquiryTypeMappingDTO
 */
export interface Em2EnquiryTypeMappingDTO {
    /**
     * 
     * @type {number}
     * @memberof Em2EnquiryTypeMappingDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Em2EnquiryTypeMappingDTO
     */
    eventType: Em2EnquiryTypeMappingDTOEventTypeEnum;
    /**
     * 
     * @type {Em2EnquiryVehicle}
     * @memberof Em2EnquiryTypeMappingDTO
     */
    vehicle?: Em2EnquiryVehicle;
    /**
     * 
     * @type {number}
     * @memberof Em2EnquiryTypeMappingDTO
     */
    enquiryTypeId: number;
    /**
     * 
     * @type {string}
     * @memberof Em2EnquiryTypeMappingDTO
     */
    enquiryTypeName: string;
}


/**
 * @export
 */
export const Em2EnquiryTypeMappingDTOEventTypeEnum = {
    ReturnedLocationInformation: 'RETURNED_LOCATION_INFORMATION',
    ReturnedCompanyInformation: 'RETURNED_COMPANY_INFORMATION',
    ReturnedCompanyWorkingHours: 'RETURNED_COMPANY_WORKING_HOURS',
    ReturnedJourneyDetails: 'RETURNED_JOURNEY_DETAILS',
    CheckedTestDriveBookingAvailability: 'CHECKED_TEST_DRIVE_BOOKING_AVAILABILITY',
    CheckedCallBackBookingAvailability: 'CHECKED_CALL_BACK_BOOKING_AVAILABILITY',
    RequestedCallback: 'REQUESTED_CALLBACK',
    RequestedTestDrive: 'REQUESTED_TEST_DRIVE',
    RequestedEmailFollowUp: 'REQUESTED_EMAIL_FOLLOW_UP',
    RequestedServiceCallback: 'REQUESTED_SERVICE_CALLBACK',
    BookedCallBack: 'BOOKED_CALL_BACK',
    BookedEmailFollowUp: 'BOOKED_EMAIL_FOLLOW_UP',
    BookedTestDrive: 'BOOKED_TEST_DRIVE',
    ReturnedUsedVehicleInformation: 'RETURNED_USED_VEHICLE_INFORMATION',
    ReturnedNewVehicleInformation: 'RETURNED_NEW_VEHICLE_INFORMATION',
    ReturnedVehicleValuation: 'RETURNED_VEHICLE_VALUATION',
    ReturnedFinanceQuote: 'RETURNED_FINANCE_QUOTE',
    ReturnedFinanceApplication: 'RETURNED_FINANCE_APPLICATION',
    ReturnedStripeForm: 'RETURNED_STRIPE_FORM',
    ReservedVehicle: 'RESERVED_VEHICLE',
    RequestedLimitedVehicleInformation: 'REQUESTED_LIMITED_VEHICLE_INFORMATION',
    RequestedLimitedFinanceIllustration: 'REQUESTED_LIMITED_FINANCE_ILLUSTRATION',
    RequestedLimitedVehicleValuation: 'REQUESTED_LIMITED_VEHICLE_VALUATION',
    RequestedLimitedVehicleReservation: 'REQUESTED_LIMITED_VEHICLE_RESERVATION',
    AgentHandover: 'AGENT_HANDOVER',
    HumanHandover: 'HUMAN_HANDOVER',
    ReturnedAftersalesInformation: 'RETURNED_AFTERSALES_INFORMATION',
    ReturnedAftersalesWorkingHours: 'RETURNED_AFTERSALES_WORKING_HOURS',
    ReturnedServiceBookingUrl: 'RETURNED_SERVICE_BOOKING_URL',
    ReturnedRecallUrl: 'RETURNED_RECALL_URL',
    BookedServiceCallBack: 'BOOKED_SERVICE_CALL_BACK',
    ReturnedFuelCost: 'RETURNED_FUEL_COST'
} as const;
export type Em2EnquiryTypeMappingDTOEventTypeEnum = typeof Em2EnquiryTypeMappingDTOEventTypeEnum[keyof typeof Em2EnquiryTypeMappingDTOEventTypeEnum];


/**
 * 
 * @export
 */
export const Em2EnquiryVehicle = {
    New: 'NEW',
    Used: 'USED'
} as const;
export type Em2EnquiryVehicle = typeof Em2EnquiryVehicle[keyof typeof Em2EnquiryVehicle];


/**
 * 
 * @export
 */
export const EmailCloneStrategy = {
    Keep: 'KEEP',
    Placeholder: 'PLACEHOLDER'
} as const;
export type EmailCloneStrategy = typeof EmailCloneStrategy[keyof typeof EmailCloneStrategy];

/**
 * 
 * @export
 * @interface EmailConfigurationDTO
 */
export interface EmailConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof EmailConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailConfigurationDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailConfigurationDTO
     */
    password?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailConfigurationDTO
     */
    transcriptRecipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof EmailConfigurationDTO
     */
    filtrationEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EmailConfigurationDTO
     */
    transcriptSummaryEnabled?: boolean;
}
/**
 * 
 * @export
 * @interface EmailSendingLogTableResponse
 */
export interface EmailSendingLogTableResponse {
    /**
     * 
     * @type {Array<EmailSendingLogUi>}
     * @memberof EmailSendingLogTableResponse
     */
    logs?: Array<EmailSendingLogUi>;
    /**
     * 
     * @type {number}
     * @memberof EmailSendingLogTableResponse
     */
    totalCount?: number;
}
/**
 * 
 * @export
 * @interface EmailSendingLogUi
 */
export interface EmailSendingLogUi {
    /**
     * 
     * @type {number}
     * @memberof EmailSendingLogUi
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailSendingLogUi
     */
    sentAt?: string;
    /**
     * 
     * @type {number}
     * @memberof EmailSendingLogUi
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof EmailSendingLogUi
     */
    lastMessageId?: number;
    /**
     * 
     * @type {string}
     * @memberof EmailSendingLogUi
     */
    conversationChannel?: EmailSendingLogUiConversationChannelEnum;
    /**
     * 
     * @type {string}
     * @memberof EmailSendingLogUi
     */
    emailType?: EmailSendingLogUiEmailTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EmailSendingLogUi
     */
    templateId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmailSendingLogUi
     */
    recipients?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof EmailSendingLogUi
     */
    ccRecipients?: { [key: string]: string; };
    /**
     * 
     * @type {TranscriptRoutingDecisionUi}
     * @memberof EmailSendingLogUi
     */
    routingDecision?: TranscriptRoutingDecisionUi;
}


/**
 * @export
 */
export const EmailSendingLogUiConversationChannelEnum = {
    Widget: 'WIDGET',
    SuperchatWhatsApp: 'SUPERCHAT_WHATS_APP',
    SuperchatEmail: 'SUPERCHAT_EMAIL',
    SuperchatSms: 'SUPERCHAT_SMS',
    SuperchatTelegram: 'SUPERCHAT_TELEGRAM',
    SuperchatInstagram: 'SUPERCHAT_INSTAGRAM',
    SuperchatFacebook: 'SUPERCHAT_FACEBOOK',
    ContactCenterWhatsApp: 'CONTACT_CENTER_WHATS_APP',
    ContactCenterEmail: 'CONTACT_CENTER_EMAIL',
    ContactCenterSms: 'CONTACT_CENTER_SMS',
    ConfidentAi: 'CONFIDENT_AI'
} as const;
export type EmailSendingLogUiConversationChannelEnum = typeof EmailSendingLogUiConversationChannelEnum[keyof typeof EmailSendingLogUiConversationChannelEnum];

/**
 * @export
 */
export const EmailSendingLogUiEmailTypeEnum = {
    TranscriptDefault: 'TRANSCRIPT_DEFAULT',
    TranscriptRouting: 'TRANSCRIPT_ROUTING',
    TranscriptAftersales: 'TRANSCRIPT_AFTERSALES',
    ImmediateMessage: 'IMMEDIATE_MESSAGE'
} as const;
export type EmailSendingLogUiEmailTypeEnum = typeof EmailSendingLogUiEmailTypeEnum[keyof typeof EmailSendingLogUiEmailTypeEnum];

/**
 * 
 * @export
 * @interface EmploymentAndResidenceResponse
 */
export interface EmploymentAndResidenceResponse {
    /**
     * 
     * @type {string}
     * @memberof EmploymentAndResidenceResponse
     */
    currentEmployerName?: string;
    /**
     * 
     * @type {string}
     * @memberof EmploymentAndResidenceResponse
     */
    previousEmployerName?: string;
    /**
     * 
     * @type {number}
     * @memberof EmploymentAndResidenceResponse
     */
    numberOfYearsSpentWithCurrentEmployer?: number;
    /**
     * 
     * @type {ResidentialStatus}
     * @memberof EmploymentAndResidenceResponse
     */
    residentialStatus?: ResidentialStatus;
    /**
     * 
     * @type {string}
     * @memberof EmploymentAndResidenceResponse
     */
    previousHomeAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof EmploymentAndResidenceResponse
     */
    numberOfYearsSpentAtCurrentAddress?: number;
    /**
     * 
     * @type {DrivingLicence}
     * @memberof EmploymentAndResidenceResponse
     */
    drivingLicence?: DrivingLicence;
}


/**
 * 
 * @export
 * @interface EnquiryConfigurationDTO
 */
export interface EnquiryConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof EnquiryConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {EnquiryProvider}
     * @memberof EnquiryConfigurationDTO
     */
    enquiryProvider: EnquiryProvider;
    /**
     * 
     * @type {boolean}
     * @memberof EnquiryConfigurationDTO
     */
    leadSummaryEnabled?: boolean;
}



/**
 * 
 * @export
 */
export const EnquiryProvider = {
    NoProvider: 'NO_PROVIDER',
    Dragon2000: 'DRAGON2000',
    Em2: 'EM2'
} as const;
export type EnquiryProvider = typeof EnquiryProvider[keyof typeof EnquiryProvider];

/**
 * 
 * @export
 * @interface EnumValueDTO
 */
export interface EnumValueDTO {
    /**
     * 
     * @type {string}
     * @memberof EnumValueDTO
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof EnumValueDTO
     */
    label: string;
}

/**
 * 
 * @export
 */
export const EventType = {
    ReturnedLocationInformation: 'RETURNED_LOCATION_INFORMATION',
    ReturnedCompanyInformation: 'RETURNED_COMPANY_INFORMATION',
    ReturnedCompanyWorkingHours: 'RETURNED_COMPANY_WORKING_HOURS',
    ReturnedJourneyDetails: 'RETURNED_JOURNEY_DETAILS',
    CheckedTestDriveBookingAvailability: 'CHECKED_TEST_DRIVE_BOOKING_AVAILABILITY',
    CheckedCallBackBookingAvailability: 'CHECKED_CALL_BACK_BOOKING_AVAILABILITY',
    RequestedCallback: 'REQUESTED_CALLBACK',
    RequestedTestDrive: 'REQUESTED_TEST_DRIVE',
    RequestedEmailFollowUp: 'REQUESTED_EMAIL_FOLLOW_UP',
    RequestedServiceCallback: 'REQUESTED_SERVICE_CALLBACK',
    BookedCallBack: 'BOOKED_CALL_BACK',
    BookedEmailFollowUp: 'BOOKED_EMAIL_FOLLOW_UP',
    BookedTestDrive: 'BOOKED_TEST_DRIVE',
    ReturnedUsedVehicleInformation: 'RETURNED_USED_VEHICLE_INFORMATION',
    ReturnedNewVehicleInformation: 'RETURNED_NEW_VEHICLE_INFORMATION',
    ReturnedVehicleValuation: 'RETURNED_VEHICLE_VALUATION',
    ReturnedFinanceQuote: 'RETURNED_FINANCE_QUOTE',
    ReturnedFinanceApplication: 'RETURNED_FINANCE_APPLICATION',
    ReturnedStripeForm: 'RETURNED_STRIPE_FORM',
    ReservedVehicle: 'RESERVED_VEHICLE',
    RequestedLimitedVehicleInformation: 'REQUESTED_LIMITED_VEHICLE_INFORMATION',
    RequestedLimitedFinanceIllustration: 'REQUESTED_LIMITED_FINANCE_ILLUSTRATION',
    RequestedLimitedVehicleValuation: 'REQUESTED_LIMITED_VEHICLE_VALUATION',
    RequestedLimitedVehicleReservation: 'REQUESTED_LIMITED_VEHICLE_RESERVATION',
    AgentHandover: 'AGENT_HANDOVER',
    HumanHandover: 'HUMAN_HANDOVER',
    ReturnedAftersalesInformation: 'RETURNED_AFTERSALES_INFORMATION',
    ReturnedAftersalesWorkingHours: 'RETURNED_AFTERSALES_WORKING_HOURS',
    ReturnedServiceBookingUrl: 'RETURNED_SERVICE_BOOKING_URL',
    ReturnedRecallUrl: 'RETURNED_RECALL_URL',
    BookedServiceCallBack: 'BOOKED_SERVICE_CALL_BACK',
    ReturnedFuelCost: 'RETURNED_FUEL_COST'
} as const;
export type EventType = typeof EventType[keyof typeof EventType];

/**
 * 
 * @export
 * @interface FeedbackOverviewRequest
 */
export interface FeedbackOverviewRequest {
    /**
     * 
     * @type {string}
     * @memberof FeedbackOverviewRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof FeedbackOverviewRequest
     */
    endDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FeedbackOverviewRequest
     */
    publicBotIdList?: Array<string>;
}
/**
 * 
 * @export
 * @interface FeedbackOverviewUi
 */
export interface FeedbackOverviewUi {
    /**
     * 
     * @type {number}
     * @memberof FeedbackOverviewUi
     */
    feedbackCount: number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackOverviewUi
     */
    positiveFeedbackCount: number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackOverviewUi
     */
    positiveFeedbackRate?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackOverviewUi
     */
    negativeWithCommentCount: number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackOverviewUi
     */
    surveyCount: number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackOverviewUi
     */
    averageSurveyRating?: number;
    /**
     * 
     * @type {number}
     * @memberof FeedbackOverviewUi
     */
    lowSurveyCount: number;
}

/**
 * 
 * @export
 */
export const FeedbackRating = {
    Positive: 'POSITIVE',
    Negative: 'NEGATIVE'
} as const;
export type FeedbackRating = typeof FeedbackRating[keyof typeof FeedbackRating];

/**
 * 
 * @export
 * @interface FeedbackSettingsResponse
 */
export interface FeedbackSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof FeedbackSettingsResponse
     */
    surveyAfterMessagesEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof FeedbackSettingsResponse
     */
    surveyAfterMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof FeedbackSettingsResponse
     */
    surveyAfterBookingEnabled: boolean;
}
/**
 * 
 * @export
 * @interface FieldEntryDTO
 */
export interface FieldEntryDTO {
    /**
     * 
     * @type {string}
     * @memberof FieldEntryDTO
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof FieldEntryDTO
     */
    value?: object;
}
/**
 * 
 * @export
 * @interface FieldOptionDTO
 */
export interface FieldOptionDTO {
    /**
     * 
     * @type {string}
     * @memberof FieldOptionDTO
     */
    field: FieldOptionDTOFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof FieldOptionDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FieldOptionDTO
     */
    fieldType: FieldOptionDTOFieldTypeEnum;
    /**
     * 
     * @type {Array<OperatorDTO>}
     * @memberof FieldOptionDTO
     */
    availableOperators: Array<OperatorDTO>;
    /**
     * 
     * @type {Array<EnumValueDTO>}
     * @memberof FieldOptionDTO
     */
    enumValues?: Array<EnumValueDTO>;
}


/**
 * @export
 */
export const FieldOptionDTOFieldEnum = {
    ServiceHistory: 'SERVICE_HISTORY',
    VehicleCondition: 'VEHICLE_CONDITION',
    Mileage: 'MILEAGE',
    Price: 'PRICE',
    OutstandingFinances: 'OUTSTANDING_FINANCES',
    BodyType: 'BODY_TYPE',
    Drivetrain: 'DRIVETRAIN',
    EmissionClass: 'EMISSION_CLASS',
    FuelType: 'FUEL_TYPE',
    Make: 'MAKE',
    Model: 'MODEL',
    TransmissionType: 'TRANSMISSION_TYPE',
    Owners: 'OWNERS',
    FirstRegistrationYear: 'FIRST_REGISTRATION_YEAR'
} as const;
export type FieldOptionDTOFieldEnum = typeof FieldOptionDTOFieldEnum[keyof typeof FieldOptionDTOFieldEnum];

/**
 * @export
 */
export const FieldOptionDTOFieldTypeEnum = {
    Number: 'NUMBER',
    String: 'STRING',
    StringListValue: 'STRING_LIST_VALUE',
    EnumValue: 'ENUM_VALUE'
} as const;
export type FieldOptionDTOFieldTypeEnum = typeof FieldOptionDTOFieldTypeEnum[keyof typeof FieldOptionDTOFieldTypeEnum];

/**
 * 
 * @export
 * @interface FileOnSftpVehicleDataConfigurationDTO
 */
export interface FileOnSftpVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof FileOnSftpVehicleDataConfigurationDTO
     */
    filePath: string;
}


/**
 * 
 * @export
 * @interface FinanceConfigurationDTO
 */
export interface FinanceConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof FinanceConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FinanceConfigurationDTO
     */
    iddUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof FinanceConfigurationDTO
     */
    interestRate?: number;
    /**
     * 
     * @type {string}
     * @memberof FinanceConfigurationDTO
     */
    financeProvider?: FinanceConfigurationDTOFinanceProviderEnum;
    /**
     * 
     * @type {IVendiProviderConfigDTO}
     * @memberof FinanceConfigurationDTO
     */
    ivendiProviderConfig?: IVendiProviderConfigDTO;
}


/**
 * @export
 */
export const FinanceConfigurationDTOFinanceProviderEnum = {
    Illustration: 'ILLUSTRATION',
    Ivendi: 'IVENDI',
    KeyloopFinanceService: 'KEYLOOP_FINANCE_SERVICE',
    Codeweavers: 'CODEWEAVERS'
} as const;
export type FinanceConfigurationDTOFinanceProviderEnum = typeof FinanceConfigurationDTOFinanceProviderEnum[keyof typeof FinanceConfigurationDTOFinanceProviderEnum];


/**
 * 
 * @export
 */
export const FinanceProvider = {
    Illustration: 'ILLUSTRATION',
    Ivendi: 'IVENDI',
    KeyloopFinanceService: 'KEYLOOP_FINANCE_SERVICE',
    Codeweavers: 'CODEWEAVERS'
} as const;
export type FinanceProvider = typeof FinanceProvider[keyof typeof FinanceProvider];

/**
 * 
 * @export
 * @interface FocusedVehicle
 */
export interface FocusedVehicle {
    /**
     * 
     * @type {string}
     * @memberof FocusedVehicle
     */
    vin?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusedVehicle
     */
    vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof FocusedVehicle
     */
    newVehicleId?: string;
}
/**
 * 
 * @export
 * @interface FranchiseDTO
 */
export interface FranchiseDTO {
    /**
     * 
     * @type {number}
     * @memberof FranchiseDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FranchiseDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof FranchiseDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FranchiseDTO
     */
    franchiseHash?: string;
    /**
     * 
     * @type {string}
     * @memberof FranchiseDTO
     */
    urlPathPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FranchiseDTO
     */
    focusEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FranchiseDTO
     */
    sharedWithFocusedFranchises?: boolean;
    /**
     * 
     * @type {EmailConfigurationDTO}
     * @memberof FranchiseDTO
     */
    emailConfiguration?: EmailConfigurationDTO;
    /**
     * 
     * @type {NewVehicleDataConfigurationDTO}
     * @memberof FranchiseDTO
     */
    newVehicleDataConfiguration?: NewVehicleDataConfigurationDTO;
    /**
     * 
     * @type {Array<LocationDTO>}
     * @memberof FranchiseDTO
     */
    locationList?: Array<LocationDTO>;
    /**
     * 
     * @type {Array<KnowledgeRecordDTO>}
     * @memberof FranchiseDTO
     */
    knowledgeRecords?: Array<KnowledgeRecordDTO>;
}
/**
 * 
 * @export
 * @interface FranchiseInListDTO
 */
export interface FranchiseInListDTO {
    /**
     * 
     * @type {number}
     * @memberof FranchiseInListDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FranchiseInListDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof FranchiseInListDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FranchiseInListDTO
     */
    franchiseHash?: string;
    /**
     * 
     * @type {string}
     * @memberof FranchiseInListDTO
     */
    urlPathPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FranchiseInListDTO
     */
    focusEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FranchiseInListDTO
     */
    sharedWithFocusedFranchises: boolean;
    /**
     * 
     * @type {Array<LocationOptionDTO>}
     * @memberof FranchiseInListDTO
     */
    locationList: Array<LocationOptionDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof FranchiseInListDTO
     */
    canBeDeleted: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FranchiseInListDTO
     */
    hasWarnings?: boolean;
}
/**
 * 
 * @export
 * @interface FranchiseOptionDTO
 */
export interface FranchiseOptionDTO {
    /**
     * 
     * @type {number}
     * @memberof FranchiseOptionDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FranchiseOptionDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof FranchiseOptionDTO
     */
    name: string;
    /**
     * 
     * @type {NewVehicleDataConfigurationDTO}
     * @memberof FranchiseOptionDTO
     */
    newVehicleDataConfiguration?: NewVehicleDataConfigurationDTO;
    /**
     * 
     * @type {Array<LocationOptionDTO>}
     * @memberof FranchiseOptionDTO
     */
    locationList?: Array<LocationOptionDTO>;
}
/**
 * 
 * @export
 * @interface FranchiseTableRequest
 */
export interface FranchiseTableRequest {
    /**
     * 
     * @type {number}
     * @memberof FranchiseTableRequest
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof FranchiseTableRequest
     */
    pageSize: number;
    /**
     * 
     * @type {FranchiseTableSortingField}
     * @memberof FranchiseTableRequest
     */
    sortBy?: FranchiseTableSortingField;
    /**
     * 
     * @type {SortDirection}
     * @memberof FranchiseTableRequest
     */
    sortDirection?: SortDirection;
    /**
     * 
     * @type {string}
     * @memberof FranchiseTableRequest
     */
    searchQuery?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FranchiseTableRequest
     */
    locationPublicIds?: Array<string>;
    /**
     * 
     * @type {PageableObject}
     * @memberof FranchiseTableRequest
     */
    pageable?: PageableObject;
}
/**
 * 
 * @export
 * @interface FranchiseTableResponse
 */
export interface FranchiseTableResponse {
    /**
     * 
     * @type {Array<FranchiseInListDTO>}
     * @memberof FranchiseTableResponse
     */
    franchises: Array<FranchiseInListDTO>;
    /**
     * 
     * @type {number}
     * @memberof FranchiseTableResponse
     */
    totalCount: number;
}

/**
 * 
 * @export
 */
export const FranchiseTableSortingField = {
    Name: 'NAME',
    Hash: 'HASH',
    UrlPattern: 'URL_PATTERN'
} as const;
export type FranchiseTableSortingField = typeof FranchiseTableSortingField[keyof typeof FranchiseTableSortingField];

/**
 * 
 * @export
 */
export const FuelType = {
    Diesel: 'DIESEL',
    Petrol: 'PETROL',
    Electric: 'ELECTRIC'
} as const;
export type FuelType = typeof FuelType[keyof typeof FuelType];

/**
 * 
 * @export
 * @interface FullBotUi
 */
export interface FullBotUi {
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    publicId: string;
    /**
     * 
     * @type {BotType}
     * @memberof FullBotUi
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    useMultiAgent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    vehicleProviderWarningEmailEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    externalCommunicationsDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    isReimportFinished: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    siteURL: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    groupHash?: string;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    conversationLimit: number;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    workingRange?: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    openAiModel?: FullBotUiOpenAiModelEnum;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    emailConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    assistantEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    assistantEmailPassword?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullBotUi
     */
    emailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {Array<FullLocationUi>}
     * @memberof FullBotUi
     */
    locationList: Array<FullLocationUi>;
    /**
     * 
     * @type {Array<FullFranchiseUi>}
     * @memberof FullBotUi
     */
    franchiseList: Array<FullFranchiseUi>;
    /**
     * 
     * @type {Array<KnowledgeRecordUi>}
     * @memberof FullBotUi
     */
    knowledgeRecords?: Array<KnowledgeRecordUi>;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    filtrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    transcriptSummaryEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    sharingLinkEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    surveyAfterMessagesEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    surveyAfterMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    surveyAfterBookingEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullBotUi
     */
    lastRenewalDate: string;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof FullBotUi
     */
    redirectProvider: RedirectProvider;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    urlProcessorConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof FullBotUi
     */
    urlProcessorEnabled: boolean;
    /**
     * 
     * @type {MatchField}
     * @memberof FullBotUi
     */
    matchField?: MatchField;
    /**
     * 
     * @type {MatchType}
     * @memberof FullBotUi
     */
    matchType?: MatchType;
    /**
     * 
     * @type {number}
     * @memberof FullBotUi
     */
    segmentNumberFromTheEnd?: number;
    /**
     * 
     * @type {SupportedTimezone}
     * @memberof FullBotUi
     */
    timezone: SupportedTimezone;
    /**
     * 
     * @type {LocaleTag}
     * @memberof FullBotUi
     */
    defaultLocale: LocaleTag;
    /**
     * 
     * @type {Array<Country>}
     * @memberof FullBotUi
     */
    supportedPhoneNumberLocales: Array<Country>;
    /**
     * 
     * @type {Array<CcRecipientDTO>}
     * @memberof FullBotUi
     */
    ccRecipients?: Array<CcRecipientDTO>;
    /**
     * 
     * @type {Array<WarningUi>}
     * @memberof FullBotUi
     */
    warnings?: Array<WarningUi>;
    /**
     * 
     * @type {Array<ConfigurationIssue>}
     * @memberof FullBotUi
     */
    configurationIssues?: Array<ConfigurationIssue>;
}


/**
 * @export
 */
export const FullBotUiOpenAiModelEnum = {
    _6Sol: 'gpt-5.6-sol',
    _6Terra: 'gpt-5.6-terra',
    _6Luna: 'gpt-5.6-luna',
    _4: 'gpt-5.4',
    _4Nano: 'gpt-5.4-nano',
    _4Mini: 'gpt-5.4-mini'
} as const;
export type FullBotUiOpenAiModelEnum = typeof FullBotUiOpenAiModelEnum[keyof typeof FullBotUiOpenAiModelEnum];

/**
 * 
 * @export
 * @interface FullConvoStartersUI
 */
export interface FullConvoStartersUI {
    /**
     * 
     * @type {number}
     * @memberof FullConvoStartersUI
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof FullConvoStartersUI
     */
    message: string;
    /**
     * 
     * @type {ConvoStarterVisibility}
     * @memberof FullConvoStartersUI
     */
    visibility: ConvoStarterVisibility;
}


/**
 * 
 * @export
 * @interface FullFranchiseUi
 */
export interface FullFranchiseUi {
    /**
     * 
     * @type {number}
     * @memberof FullFranchiseUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FullFranchiseUi
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof FullFranchiseUi
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FullFranchiseUi
     */
    franchiseHash?: string;
    /**
     * 
     * @type {string}
     * @memberof FullFranchiseUi
     */
    urlPathPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof FullFranchiseUi
     */
    focusEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullFranchiseUi
     */
    sharedWithFocusedFranchises: boolean;
    /**
     * 
     * @type {number}
     * @memberof FullFranchiseUi
     */
    franchiseEmailConfigurationId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullFranchiseUi
     */
    franchiseEmailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FullFranchiseUi
     */
    franchiseEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullFranchiseUi
     */
    franchiseEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {NewVehicleDataConfigurationDTO}
     * @memberof FullFranchiseUi
     */
    newVehicleDataConfiguration?: NewVehicleDataConfigurationDTO;
    /**
     * 
     * @type {Array<FullLocationUi>}
     * @memberof FullFranchiseUi
     */
    locationList: Array<FullLocationUi>;
    /**
     * 
     * @type {Array<WarningUi>}
     * @memberof FullFranchiseUi
     */
    warnings?: Array<WarningUi>;
    /**
     * 
     * @type {Array<KnowledgeRecordUi>}
     * @memberof FullFranchiseUi
     */
    knowledgeRecords?: Array<KnowledgeRecordUi>;
}
/**
 * 
 * @export
 * @interface FullLocationUi
 */
export interface FullLocationUi {
    /**
     * 
     * @type {number}
     * @memberof FullLocationUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    phoneNumber: string;
    /**
     * 
     * @type {WorkScheduleUi}
     * @memberof FullLocationUi
     */
    workSchedule: WorkScheduleUi;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof FullLocationUi
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {number}
     * @memberof FullLocationUi
     */
    vehicleDataConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    advertiserId?: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    filePath?: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    feedId?: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    locationHash?: string;
    /**
     * 
     * @type {number}
     * @memberof FullLocationUi
     */
    locationEmailConfigurationId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullLocationUi
     */
    locationEmailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FullLocationUi
     */
    locationEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullLocationUi
     */
    locationEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof FullLocationUi
     */
    enquiryConfigurationId: number;
    /**
     * 
     * @type {EnquiryProvider}
     * @memberof FullLocationUi
     */
    enquiryProvider: EnquiryProvider;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    dragon2000DealerId?: string;
    /**
     * 
     * @type {ConfigurationRegion}
     * @memberof FullLocationUi
     */
    em2Region?: ConfigurationRegion;
    /**
     * 
     * @type {boolean}
     * @memberof FullLocationUi
     */
    canBeDeleted: boolean;
    /**
     * 
     * @type {Array<WarningUi>}
     * @memberof FullLocationUi
     */
    warnings?: Array<WarningUi>;
    /**
     * 
     * @type {number}
     * @memberof FullLocationUi
     */
    aftersalesConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof FullLocationUi
     */
    aftersalesEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    serviceBookingUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FullLocationUi
     */
    recallUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FullLocationUi
     */
    aftersalesEmailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof FullLocationUi
     */
    aftersalesEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FullLocationUi
     */
    aftersalesEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {WorkScheduleUi}
     * @memberof FullLocationUi
     */
    aftersalesWorkSchedule: WorkScheduleUi;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof FullLocationUi
     */
    supportedVehicleManufacturers: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<KnowledgeRecordUi>}
     * @memberof FullLocationUi
     */
    knowledgeRecords?: Array<KnowledgeRecordUi>;
}


/**
 * @export
 */
export const FullLocationUiSupportedVehicleManufacturersEnum = {
    Car: 'CAR',
    Lcv: 'LCV',
    Bike: 'BIKE'
} as const;
export type FullLocationUiSupportedVehicleManufacturersEnum = typeof FullLocationUiSupportedVehicleManufacturersEnum[keyof typeof FullLocationUiSupportedVehicleManufacturersEnum];

/**
 * 
 * @export
 * @interface FullOfferUi
 */
export interface FullOfferUi {
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    publicBotId?: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    publicLocationId?: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof FullOfferUi
     */
    offerStatus: OfferStatus;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    archivedAt?: string;
    /**
     * 
     * @type {OfferType}
     * @memberof FullOfferUi
     */
    offerType: OfferType;
    /**
     * 
     * @type {OfferSource}
     * @memberof FullOfferUi
     */
    offerSource: OfferSource;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    offerSourceName: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    redirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    imageUrl: string;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof FullOfferUi
     */
    discount?: SubtractionUi;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    currency?: FullOfferUiCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof FullOfferUi
     */
    financeProduct?: string;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    cashPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    monthlyPayments?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    customerDeposit?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    manufacturerDepositContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    totalDeposit?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    dealerContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    balanceToFinance?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    totalAmountPayable?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    totalChargeForCredit?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    optionalFinalPayment?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    durationOfAgreementInMonths?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    apr?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    fixedInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    mileagePerAnnum?: number;
    /**
     * 
     * @type {number}
     * @memberof FullOfferUi
     */
    excessMileageCharge?: number;
}


/**
 * @export
 */
export const FullOfferUiCurrencyEnum = {
    Gbp: 'GBP',
    Usd: 'USD',
    Eur: 'EUR',
    Jpy: 'JPY',
    Aed: 'AED',
    Cad: 'CAD'
} as const;
export type FullOfferUiCurrencyEnum = typeof FullOfferUiCurrencyEnum[keyof typeof FullOfferUiCurrencyEnum];

/**
 * 
 * @export
 * @interface FullTranscriptUi
 */
export interface FullTranscriptUi {
    /**
     * 
     * @type {Array<ChatHistoryDTO>}
     * @memberof FullTranscriptUi
     */
    chatHistoryList: Array<ChatHistoryDTO>;
    /**
     * 
     * @type {BotTranscriptUi}
     * @memberof FullTranscriptUi
     */
    bot: BotTranscriptUi;
    /**
     * 
     * @type {Array<EmailSendingLogUi>}
     * @memberof FullTranscriptUi
     */
    emailSendingLogs: Array<EmailSendingLogUi>;
    /**
     * 
     * @type {Array<MessageFeedbackUi>}
     * @memberof FullTranscriptUi
     */
    messageFeedback: Array<MessageFeedbackUi>;
    /**
     * 
     * @type {Array<SurveyResponseUi>}
     * @memberof FullTranscriptUi
     */
    surveys: Array<SurveyResponseUi>;
}
/**
 * 
 * @export
 * @interface FullWidgetAppearanceSettingUi
 */
export interface FullWidgetAppearanceSettingUi {
    /**
     * 
     * @type {string}
     * @memberof FullWidgetAppearanceSettingUi
     */
    publicBotId: string;
    /**
     * 
     * @type {Array<WidgetAppearanceLocaleVariantUi>}
     * @memberof FullWidgetAppearanceSettingUi
     */
    localeVariants: Array<WidgetAppearanceLocaleVariantUi>;
}
/**
 * 
 * @export
 * @interface GetAvailableOfferRequest
 */
export interface GetAvailableOfferRequest {
    /**
     * 
     * @type {string}
     * @memberof GetAvailableOfferRequest
     */
    public_bot_id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableOfferRequest
     */
    public_location_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetAvailableOfferRequest
     */
    is_new: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableOfferRequest
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableOfferRequest
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof GetAvailableOfferRequest
     */
    vin?: string;
}

/**
 * 
 * @export
 */
export const HierarchyContextSource = {
    BackendLocked: 'BACKEND_LOCKED',
    ChatSelected: 'CHAT_SELECTED',
    SystemInferred: 'SYSTEM_INFERRED'
} as const;
export type HierarchyContextSource = typeof HierarchyContextSource[keyof typeof HierarchyContextSource];

/**
 * 
 * @export
 * @interface HumanHandoverChatEventDTO
 */
export interface HumanHandoverChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface IVendiProviderConfigDTO
 */
export interface IVendiProviderConfigDTO {
    /**
     * 
     * @type {number}
     * @memberof IVendiProviderConfigDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigDTO
     */
    apiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigDTO
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigDTO
     */
    clientSecret?: string;
    /**
     * 
     * @type {Array<LocationQuoteeIdDTO>}
     * @memberof IVendiProviderConfigDTO
     */
    locationQuoteeIds?: Array<LocationQuoteeIdDTO>;
}
/**
 * 
 * @export
 * @interface IVendiProviderConfigRequest
 */
export interface IVendiProviderConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof IVendiProviderConfigRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigRequest
     */
    apiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigRequest
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigRequest
     */
    clientSecret?: string;
    /**
     * 
     * @type {Array<LocationQuoteeIdRequest>}
     * @memberof IVendiProviderConfigRequest
     */
    locationQuoteeIds?: Array<LocationQuoteeIdRequest>;
}
/**
 * 
 * @export
 * @interface IVendiProviderConfigResponse
 */
export interface IVendiProviderConfigResponse {
    /**
     * 
     * @type {number}
     * @memberof IVendiProviderConfigResponse
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigResponse
     */
    apiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigResponse
     */
    clientId?: string;
    /**
     * 
     * @type {string}
     * @memberof IVendiProviderConfigResponse
     */
    clientSecret?: string;
    /**
     * 
     * @type {Array<LocationQuoteeIdResponse>}
     * @memberof IVendiProviderConfigResponse
     */
    locationQuoteeIds?: Array<LocationQuoteeIdResponse>;
}

/**
 * 
 * @export
 */
export const InitializationType = {
    Unsupported: 'UNSUPPORTED',
    OnOpenWidgetEvent: 'ON_OPEN_WIDGET_EVENT',
    OnUrlClick: 'ON_URL_CLICK',
    OnWidgetClick: 'ON_WIDGET_CLICK',
    OnSendingMessageFromModal: 'ON_SENDING_MESSAGE_FROM_MODAL',
    OnButtonClick: 'ON_BUTTON_CLICK',
    StaticFrameInit: 'STATIC_FRAME_INIT'
} as const;
export type InitializationType = typeof InitializationType[keyof typeof InitializationType];


/**
 * 
 * @export
 */
export const InputType = {
    Manual: 'MANUAL',
    Button: 'BUTTON'
} as const;
export type InputType = typeof InputType[keyof typeof InputType];


/**
 * 
 * @export
 */
export const Integration = {
    Superchat: 'SUPERCHAT'
} as const;
export type Integration = typeof Integration[keyof typeof Integration];

/**
 * 
 * @export
 * @interface KeyloopPipelineSearchVehicleDataConfigurationDTO
 */
export interface KeyloopPipelineSearchVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
}


/**
 * 
 * @export
 * @interface KeyloopValuationAccessTokenResponse
 */
export interface KeyloopValuationAccessTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof KeyloopValuationAccessTokenResponse
     */
    access_token?: string;
    /**
     * 
     * @type {string}
     * @memberof KeyloopValuationAccessTokenResponse
     */
    token_type?: string;
    /**
     * 
     * @type {number}
     * @memberof KeyloopValuationAccessTokenResponse
     */
    expires_in?: number;
}
/**
 * 
 * @export
 * @interface KnowledgeAttributeDefinitionDTO
 */
export interface KnowledgeAttributeDefinitionDTO {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeAttributeDefinitionDTO
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeAttributeDefinitionDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeAttributeDefinitionDTO
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof KnowledgeAttributeDefinitionDTO
     */
    values?: Array<string>;
}
/**
 * 
 * @export
 * @interface KnowledgeAttributeUi
 */
export interface KnowledgeAttributeUi {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeAttributeUi
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeAttributeUi
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeAttributeUi
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeAttributeUi
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof KnowledgeAttributeUi
     */
    values: Array<string>;
}
/**
 * 
 * @export
 * @interface KnowledgeContentRequest
 */
export interface KnowledgeContentRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof KnowledgeContentRequest
     */
    publicKnowledgeIds?: Array<string>;
}
/**
 * 
 * @export
 * @interface KnowledgeRecordAttributeDTO
 */
export interface KnowledgeRecordAttributeDTO {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordAttributeDTO
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordAttributeDTO
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface KnowledgeRecordAttributeRequest
 */
export interface KnowledgeRecordAttributeRequest {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordAttributeRequest
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordAttributeRequest
     */
    value?: string;
}
/**
 * 
 * @export
 * @interface KnowledgeRecordAttributeUi
 */
export interface KnowledgeRecordAttributeUi {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordAttributeUi
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordAttributeUi
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordAttributeUi
     */
    value: string;
}
/**
 * 
 * @export
 * @interface KnowledgeRecordContent
 */
export interface KnowledgeRecordContent {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordContent
     */
    publicKnowledgeId?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordContent
     */
    content?: string;
}
/**
 * 
 * @export
 * @interface KnowledgeRecordDTO
 */
export interface KnowledgeRecordDTO {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeRecordDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordDTO
     */
    publicId?: string;
    /**
     * 
     * @type {KnowledgeScope}
     * @memberof KnowledgeRecordDTO
     */
    scope: KnowledgeScope;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordDTO
     */
    knowledgeType: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordDTO
     */
    content: string;
    /**
     * 
     * @type {number}
     * @memberof KnowledgeRecordDTO
     */
    contentLength?: number;
    /**
     * 
     * @type {Array<KnowledgeRecordAttributeDTO>}
     * @memberof KnowledgeRecordDTO
     */
    attributes: Array<KnowledgeRecordAttributeDTO>;
}


/**
 * 
 * @export
 * @interface KnowledgeRecordUi
 */
export interface KnowledgeRecordUi {
    /**
     * 
     * @type {number}
     * @memberof KnowledgeRecordUi
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordUi
     */
    publicId?: string;
    /**
     * 
     * @type {KnowledgeScope}
     * @memberof KnowledgeRecordUi
     */
    scope: KnowledgeScope;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordUi
     */
    knowledgeType: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeRecordUi
     */
    content: string;
    /**
     * 
     * @type {Array<KnowledgeRecordAttributeUi>}
     * @memberof KnowledgeRecordUi
     */
    attributes: Array<KnowledgeRecordAttributeUi>;
}



/**
 * 
 * @export
 */
export const KnowledgeScope = {
    Assistant: 'ASSISTANT',
    Franchise: 'FRANCHISE',
    Location: 'LOCATION'
} as const;
export type KnowledgeScope = typeof KnowledgeScope[keyof typeof KnowledgeScope];

/**
 * 
 * @export
 * @interface KnowledgeTypeDefinitionDTO
 */
export interface KnowledgeTypeDefinitionDTO {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeTypeDefinitionDTO
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeTypeDefinitionDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeTypeDefinitionDTO
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface KnowledgeTypeUi
 */
export interface KnowledgeTypeUi {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeTypeUi
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeTypeUi
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeTypeUi
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeTypeUi
     */
    description: string;
    /**
     * 
     * @type {boolean}
     * @memberof KnowledgeTypeUi
     */
    builtIn: boolean;
}
/**
 * 
 * @export
 * @interface KnowledgeVectorRecordPageResponse
 */
export interface KnowledgeVectorRecordPageResponse {
    /**
     * 
     * @type {Array<KnowledgeVectorRecordResponse>}
     * @memberof KnowledgeVectorRecordPageResponse
     */
    records?: Array<KnowledgeVectorRecordResponse>;
    /**
     * 
     * @type {number}
     * @memberof KnowledgeVectorRecordPageResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof KnowledgeVectorRecordPageResponse
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof KnowledgeVectorRecordPageResponse
     */
    hasNext?: boolean;
}
/**
 * 
 * @export
 * @interface KnowledgeVectorRecordResponse
 */
export interface KnowledgeVectorRecordResponse {
    /**
     * 
     * @type {string}
     * @memberof KnowledgeVectorRecordResponse
     */
    publicKnowledgeId?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeVectorRecordResponse
     */
    scope?: KnowledgeVectorRecordResponseScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeVectorRecordResponse
     */
    knowledgeType?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeVectorRecordResponse
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeVectorRecordResponse
     */
    publicBotId?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeVectorRecordResponse
     */
    publicFranchiseId?: string;
    /**
     * 
     * @type {string}
     * @memberof KnowledgeVectorRecordResponse
     */
    publicLocationId?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof KnowledgeVectorRecordResponse
     */
    attributes?: { [key: string]: string; };
}


/**
 * @export
 */
export const KnowledgeVectorRecordResponseScopeEnum = {
    Assistant: 'ASSISTANT',
    Franchise: 'FRANCHISE',
    Location: 'LOCATION'
} as const;
export type KnowledgeVectorRecordResponseScopeEnum = typeof KnowledgeVectorRecordResponseScopeEnum[keyof typeof KnowledgeVectorRecordResponseScopeEnum];

/**
 * 
 * @export
 * @interface LastFocusedVehicleResponse
 */
export interface LastFocusedVehicleResponse {
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    vin?: string;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    make?: string;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    derivative?: string;
    /**
     * 
     * @type {number}
     * @memberof LastFocusedVehicleResponse
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof LastFocusedVehicleResponse
     */
    price?: number;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    transmission?: string;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    mileage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof LastFocusedVehicleResponse
     */
    is_new?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    fuel_type?: string;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    location_city?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LastFocusedVehicleResponse
     */
    image_urls?: Array<string>;
    /**
     * 
     * @type {Currency}
     * @memberof LastFocusedVehicleResponse
     */
    price_currency_code?: Currency;
    /**
     * 
     * @type {DistanceUnit}
     * @memberof LastFocusedVehicleResponse
     */
    odometer_unit?: DistanceUnit;
    /**
     * 
     * @type {string}
     * @memberof LastFocusedVehicleResponse
     */
    redirect_url?: string;
}


/**
 * 
 * @export
 * @interface LeadSettingsResponse
 */
export interface LeadSettingsResponse {
    /**
     * 
     * @type {EnquiryProvider}
     * @memberof LeadSettingsResponse
     */
    enquiryProvider: EnquiryProvider;
    /**
     * 
     * @type {Array<LocationLeadConfigResponse>}
     * @memberof LeadSettingsResponse
     */
    locationLeadConfigs: Array<LocationLeadConfigResponse>;
    /**
     * 
     * @type {Array<Em2EnquiryTypeMappingDTO>}
     * @memberof LeadSettingsResponse
     */
    enquiryTypeMappings?: Array<Em2EnquiryTypeMappingDTO>;
}


/**
 * 
 * @export
 * @interface LocalTime
 */
export interface LocalTime {
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    hour?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    minute?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    second?: number;
    /**
     * 
     * @type {number}
     * @memberof LocalTime
     */
    nano?: number;
}

/**
 * 
 * @export
 */
export const LocaleTag = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type LocaleTag = typeof LocaleTag[keyof typeof LocaleTag];

/**
 * 
 * @export
 * @interface LocationDTO
 */
export interface LocationDTO {
    /**
     * 
     * @type {number}
     * @memberof LocationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    locationHash?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDTO
     */
    ivendiQuoteeId?: string;
    /**
     * 
     * @type {WorkScheduleDTO}
     * @memberof LocationDTO
     */
    workSchedule?: WorkScheduleDTO;
    /**
     * 
     * @type {LocationDTOVehicleDataConfiguration}
     * @memberof LocationDTO
     */
    vehicleDataConfiguration?: LocationDTOVehicleDataConfiguration;
    /**
     * 
     * @type {EmailConfigurationDTO}
     * @memberof LocationDTO
     */
    emailConfiguration?: EmailConfigurationDTO;
    /**
     * 
     * @type {AftersalesConfigurationDTO}
     * @memberof LocationDTO
     */
    aftersalesConfiguration?: AftersalesConfigurationDTO;
    /**
     * 
     * @type {LocationDTOEnquiryConfiguration}
     * @memberof LocationDTO
     */
    enquiryConfiguration?: LocationDTOEnquiryConfiguration;
    /**
     * 
     * @type {Array<KnowledgeRecordDTO>}
     * @memberof LocationDTO
     */
    knowledgeRecords?: Array<KnowledgeRecordDTO>;
}
/**
 * @type LocationDTOEnquiryConfiguration
 * 
 * @export
 */
export type LocationDTOEnquiryConfiguration = Dragon2000EnquiryConfigurationDTO | Em2EnquiryConfigurationDTO | NoProviderEnquiryConfigurationDTO;
/**
 * @type LocationDTOVehicleDataConfiguration
 * 
 * @export
 */
export type LocationDTOVehicleDataConfiguration = AutotraderAndFileOnSftpVehicleDataConfigurationDTO | AutotraderVehicleDataConfigurationDTO | FileOnSftpVehicleDataConfigurationDTO | KeyloopPipelineSearchVehicleDataConfigurationDTO | NoProviderVehicleDataConfigurationDTO | PipelineStockFileVehicleDataConfigurationDTO | SpidersnetFileVehicleDataConfigurationDTO | TmcAutotraderVehicleDataConfigurationDTO;
/**
 * 
 * @export
 * @interface LocationInListDTO
 */
export interface LocationInListDTO {
    /**
     * 
     * @type {number}
     * @memberof LocationInListDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof LocationInListDTO
     */
    postcode: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationInListDTO
     */
    canBeDeleted: boolean;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof LocationInListDTO
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {boolean}
     * @memberof LocationInListDTO
     */
    hasWarnings?: boolean;
}


/**
 * 
 * @export
 * @interface LocationLeadConfigRequest
 */
export interface LocationLeadConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigRequest
     */
    locationPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigRequest
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigRequest
     */
    dragon2000DealerId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigRequest
     */
    em2Region?: LocationLeadConfigRequestEm2RegionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LocationLeadConfigRequest
     */
    leadSummaryEnabled?: boolean;
    /**
     * 
     * @type {Array<Em2DepartmentHashMappingDTO>}
     * @memberof LocationLeadConfigRequest
     */
    departmentHashMappings?: Array<Em2DepartmentHashMappingDTO>;
}


/**
 * @export
 */
export const LocationLeadConfigRequestEm2RegionEnum = {
    Uk: 'UK',
    Ca: 'CA'
} as const;
export type LocationLeadConfigRequestEm2RegionEnum = typeof LocationLeadConfigRequestEm2RegionEnum[keyof typeof LocationLeadConfigRequestEm2RegionEnum];

/**
 * 
 * @export
 * @interface LocationLeadConfigResponse
 */
export interface LocationLeadConfigResponse {
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigResponse
     */
    locationPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigResponse
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigResponse
     */
    dragon2000DealerId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationLeadConfigResponse
     */
    em2Region?: LocationLeadConfigResponseEm2RegionEnum;
    /**
     * 
     * @type {boolean}
     * @memberof LocationLeadConfigResponse
     */
    leadSummaryEnabled?: boolean;
    /**
     * 
     * @type {Array<Em2DepartmentHashMappingDTO>}
     * @memberof LocationLeadConfigResponse
     */
    departmentHashMappings?: Array<Em2DepartmentHashMappingDTO>;
}


/**
 * @export
 */
export const LocationLeadConfigResponseEm2RegionEnum = {
    Uk: 'UK',
    Ca: 'CA'
} as const;
export type LocationLeadConfigResponseEm2RegionEnum = typeof LocationLeadConfigResponseEm2RegionEnum[keyof typeof LocationLeadConfigResponseEm2RegionEnum];

/**
 * 
 * @export
 * @interface LocationOptionDTO
 */
export interface LocationOptionDTO {
    /**
     * 
     * @type {number}
     * @memberof LocationOptionDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof LocationOptionDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof LocationOptionDTO
     */
    locationName: string;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof LocationOptionDTO
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {string}
     * @memberof LocationOptionDTO
     */
    locationHash?: string;
}


/**
 * 
 * @export
 * @interface LocationQuoteeIdDTO
 */
export interface LocationQuoteeIdDTO {
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdDTO
     */
    locationPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdDTO
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdDTO
     */
    quoteeId?: string;
}
/**
 * 
 * @export
 * @interface LocationQuoteeIdRequest
 */
export interface LocationQuoteeIdRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdRequest
     */
    locationPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdRequest
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdRequest
     */
    quoteeId?: string;
}
/**
 * 
 * @export
 * @interface LocationQuoteeIdResponse
 */
export interface LocationQuoteeIdResponse {
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdResponse
     */
    locationPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdResponse
     */
    locationName?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationQuoteeIdResponse
     */
    quoteeId?: string;
}
/**
 * 
 * @export
 * @interface LocationTableRequest
 */
export interface LocationTableRequest {
    /**
     * 
     * @type {number}
     * @memberof LocationTableRequest
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof LocationTableRequest
     */
    pageSize: number;
    /**
     * 
     * @type {LocationTableSortingField}
     * @memberof LocationTableRequest
     */
    sortBy?: LocationTableSortingField;
    /**
     * 
     * @type {SortDirection}
     * @memberof LocationTableRequest
     */
    sortDirection?: SortDirection;
    /**
     * 
     * @type {string}
     * @memberof LocationTableRequest
     */
    searchQuery?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LocationTableRequest
     */
    vehicleDataProviders?: Array<LocationTableRequestVehicleDataProvidersEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof LocationTableRequest
     */
    aftersalesEnabled?: boolean;
    /**
     * 
     * @type {PageableObject}
     * @memberof LocationTableRequest
     */
    pageable?: PageableObject;
}


/**
 * @export
 */
export const LocationTableRequestVehicleDataProvidersEnum = {
    NoProvider: 'NO_PROVIDER',
    Autotrader: 'AUTOTRADER',
    TmcAutotrader: 'TMC_AUTOTRADER',
    FileOnSftp: 'FILE_ON_SFTP',
    PipelineStockFile: 'PIPELINE_STOCK_FILE',
    SpidersnetFile: 'SPIDERSNET_FILE',
    AutotraderAndFileOnSftp: 'AUTOTRADER_AND_FILE_ON_SFTP',
    KeyloopPipelineSearch: 'KEYLOOP_PIPELINE_SEARCH'
} as const;
export type LocationTableRequestVehicleDataProvidersEnum = typeof LocationTableRequestVehicleDataProvidersEnum[keyof typeof LocationTableRequestVehicleDataProvidersEnum];

/**
 * 
 * @export
 * @interface LocationTableResponse
 */
export interface LocationTableResponse {
    /**
     * 
     * @type {Array<LocationInListDTO>}
     * @memberof LocationTableResponse
     */
    locations: Array<LocationInListDTO>;
    /**
     * 
     * @type {number}
     * @memberof LocationTableResponse
     */
    totalCount: number;
}
/**
 * 
 * @export
 */
export const LocationTableSortingField = {
    PublicId: 'PUBLIC_ID',
    Name: 'NAME',
    City: 'CITY',
    Postcode: 'POSTCODE'
} as const;
export type LocationTableSortingField = typeof LocationTableSortingField[keyof typeof LocationTableSortingField];

/**
 * 
 * @export
 * @interface LocationVehicleProviderHealthRequest
 */
export interface LocationVehicleProviderHealthRequest {
    /**
     * 
     * @type {string}
     * @memberof LocationVehicleProviderHealthRequest
     */
    franchisePublicId: string;
    /**
     * 
     * @type {string}
     * @memberof LocationVehicleProviderHealthRequest
     */
    locationPublicId: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationVehicleProviderHealthRequest
     */
    anyVehicleReturned: boolean;
    /**
     * 
     * @type {string}
     * @memberof LocationVehicleProviderHealthRequest
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof LocationVehicleProviderHealthRequest
     */
    updatedAt?: string;
}

/**
 * 
 * @export
 */
export const MatchField = {
    ExternalStockId: 'EXTERNAL_STOCK_ID',
    Derivative: 'DERIVATIVE',
    KeyloopVehicleId: 'KEYLOOP_VEHICLE_ID',
    PipelineStockFileVehicleId: 'PIPELINE_STOCK_FILE_VEHICLE_ID'
} as const;
export type MatchField = typeof MatchField[keyof typeof MatchField];


/**
 * 
 * @export
 */
export const MatchType = {
    ExactMatch: 'EXACT_MATCH',
    FuzzyMatch: 'FUZZY_MATCH'
} as const;
export type MatchType = typeof MatchType[keyof typeof MatchType];

/**
 * 
 * @export
 * @interface MessageFeedbackInListUi
 */
export interface MessageFeedbackInListUi {
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackInListUi
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackInListUi
     */
    chatHistoryId: number;
    /**
     * 
     * @type {FeedbackRating}
     * @memberof MessageFeedbackInListUi
     */
    rating: FeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackInListUi
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackInListUi
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackInListUi
     */
    ratedMessage?: string;
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackInListUi
     */
    conversationId: number;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof MessageFeedbackInListUi
     */
    conversationChannel: ConversationChannel;
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackInListUi
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackInListUi
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackInListUi
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackInListUi
     */
    botName?: string;
}


/**
 * 
 * @export
 * @interface MessageFeedbackTableRequest
 */
export interface MessageFeedbackTableRequest {
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackTableRequest
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackTableRequest
     */
    pageSize: number;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackTableRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackTableRequest
     */
    endDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageFeedbackTableRequest
     */
    publicBotIdList?: Array<string>;
    /**
     * 
     * @type {Array<FeedbackRating>}
     * @memberof MessageFeedbackTableRequest
     */
    ratingList?: Array<FeedbackRating>;
    /**
     * 
     * @type {boolean}
     * @memberof MessageFeedbackTableRequest
     */
    withCommentOnly?: boolean;
    /**
     * 
     * @type {PageableObject}
     * @memberof MessageFeedbackTableRequest
     */
    pageable?: PageableObject;
}
/**
 * 
 * @export
 * @interface MessageFeedbackTableResponse
 */
export interface MessageFeedbackTableResponse {
    /**
     * 
     * @type {Array<MessageFeedbackInListUi>}
     * @memberof MessageFeedbackTableResponse
     */
    feedback: Array<MessageFeedbackInListUi>;
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackTableResponse
     */
    totalCount: number;
}
/**
 * 
 * @export
 * @interface MessageFeedbackUi
 */
export interface MessageFeedbackUi {
    /**
     * 
     * @type {number}
     * @memberof MessageFeedbackUi
     */
    chatHistoryId: number;
    /**
     * 
     * @type {FeedbackRating}
     * @memberof MessageFeedbackUi
     */
    rating: FeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackUi
     */
    comment?: string;
    /**
     * 
     * @type {string}
     * @memberof MessageFeedbackUi
     */
    updatedAt: string;
}



/**
 * 
 * @export
 */
export const MessageRole = {
    User: 'USER',
    Assistant: 'ASSISTANT',
    Tool: 'TOOL'
} as const;
export type MessageRole = typeof MessageRole[keyof typeof MessageRole];


/**
 * 
 * @export
 */
export const MessageType = {
    Text: 'TEXT',
    Gallery: 'GALLERY',
    Offers: 'OFFERS',
    Video: 'VIDEO',
    Stripe: 'STRIPE'
} as const;
export type MessageType = typeof MessageType[keyof typeof MessageType];

/**
 * 
 * @export
 * @interface ModifierRulesDTO
 */
export interface ModifierRulesDTO {
    /**
     * 
     * @type {number}
     * @memberof ModifierRulesDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModifierRulesDTO
     */
    isActive: boolean;
    /**
     * 
     * @type {Set<RuleSectionDTO>}
     * @memberof ModifierRulesDTO
     */
    ruleSections?: Set<RuleSectionDTO>;
}
/**
 * 
 * @export
 * @interface ModifierRulesEvaluationResponse
 */
export interface ModifierRulesEvaluationResponse {
    /**
     * 
     * @type {Array<AppliedAction>}
     * @memberof ModifierRulesEvaluationResponse
     */
    appliedActions?: Array<AppliedAction>;
}
/**
 * 
 * @export
 * @interface ModifierRulesResponse
 */
export interface ModifierRulesResponse {
    /**
     * 
     * @type {number}
     * @memberof ModifierRulesResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ModifierRulesResponse
     */
    isActive?: boolean;
    /**
     * 
     * @type {Set<RuleSectionResponse>}
     * @memberof ModifierRulesResponse
     */
    ruleSections?: Set<RuleSectionResponse>;
}
/**
 * 
 * @export
 * @interface NewVehicleDataConfigurationDTO
 */
export interface NewVehicleDataConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof NewVehicleDataConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NewVehicleDataConfigurationDTO
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof NewVehicleDataConfigurationDTO
     */
    vehicleType?: NewVehicleDataConfigurationDTOVehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof NewVehicleDataConfigurationDTO
     */
    manufacturer?: string;
}


/**
 * @export
 */
export const NewVehicleDataConfigurationDTOVehicleTypeEnum = {
    Car: 'CAR',
    Lcv: 'LCV',
    Bike: 'BIKE'
} as const;
export type NewVehicleDataConfigurationDTOVehicleTypeEnum = typeof NewVehicleDataConfigurationDTOVehicleTypeEnum[keyof typeof NewVehicleDataConfigurationDTOVehicleTypeEnum];

/**
 * 
 * @export
 * @interface NoProviderEnquiryConfigurationDTO
 */
export interface NoProviderEnquiryConfigurationDTO extends EnquiryConfigurationDTO {
}


/**
 * 
 * @export
 * @interface NoProviderVehicleDataConfigurationDTO
 */
export interface NoProviderVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
}


/**
 * 
 * @export
 * @interface OfferCardDataDTO
 */
export interface OfferCardDataDTO {
    /**
     * 
     * @type {number}
     * @memberof OfferCardDataDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    publicOfferId: string;
    /**
     * 
     * @type {OfferType}
     * @memberof OfferCardDataDTO
     */
    offerType: OfferType;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    redirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof OfferCardDataDTO
     */
    imageUrl: string;
    /**
     * 
     * @type {SubtractionType}
     * @memberof OfferCardDataDTO
     */
    discountType?: SubtractionType;
    /**
     * 
     * @type {number}
     * @memberof OfferCardDataDTO
     */
    discountValue?: number;
    /**
     * 
     * @type {number}
     * @memberof OfferCardDataDTO
     */
    monthlyPayments?: number;
}


/**
 * 
 * @export
 * @interface OfferInListDTO
 */
export interface OfferInListDTO {
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    publicBotId?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    publicLocationId?: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof OfferInListDTO
     */
    offerStatus: OfferStatus;
    /**
     * 
     * @type {OfferType}
     * @memberof OfferInListDTO
     */
    offerType: OfferType;
    /**
     * 
     * @type {OfferSource}
     * @memberof OfferInListDTO
     */
    offerSource: OfferSource;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    offerSourceName: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof OfferInListDTO
     */
    endDate: string;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof OfferInListDTO
     */
    discount?: SubtractionDTO;
    /**
     * 
     * @type {number}
     * @memberof OfferInListDTO
     */
    monthlyPayments?: number;
}


/**
 * 
 * @export
 * @interface OfferOptionsRequest
 */
export interface OfferOptionsRequest {
    /**
     * 
     * @type {string}
     * @memberof OfferOptionsRequest
     */
    publicBotId?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferOptionsRequest
     */
    publicLocationId?: string;
}

/**
 * 
 * @export
 */
export const OfferSource = {
    Api: 'API',
    Csv: 'CSV',
    Manual: 'MANUAL'
} as const;
export type OfferSource = typeof OfferSource[keyof typeof OfferSource];


/**
 * 
 * @export
 */
export const OfferStatus = {
    Active: 'ACTIVE',
    Archived: 'ARCHIVED'
} as const;
export type OfferStatus = typeof OfferStatus[keyof typeof OfferStatus];

/**
 * 
 * @export
 * @interface OfferTableRequest
 */
export interface OfferTableRequest {
    /**
     * 
     * @type {number}
     * @memberof OfferTableRequest
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof OfferTableRequest
     */
    pageSize: number;
    /**
     * 
     * @type {OfferTableSortingField}
     * @memberof OfferTableRequest
     */
    sortBy?: OfferTableSortingField;
    /**
     * 
     * @type {SortDirection}
     * @memberof OfferTableRequest
     */
    sortDirection?: SortDirection;
    /**
     * 
     * @type {string}
     * @memberof OfferTableRequest
     */
    searchQuery?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTableRequest
     */
    publicBotId?: string;
    /**
     * 
     * @type {string}
     * @memberof OfferTableRequest
     */
    publicLocationId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferTableRequest
     */
    makeList?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferTableRequest
     */
    modelList?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OfferTableRequest
     */
    offerSourceNameList?: Array<string>;
    /**
     * 
     * @type {Array<OfferType>}
     * @memberof OfferTableRequest
     */
    offerTypeList?: Array<OfferType>;
    /**
     * 
     * @type {PageableObject}
     * @memberof OfferTableRequest
     */
    pageable?: PageableObject;
}
/**
 * 
 * @export
 * @interface OfferTableResponse
 */
export interface OfferTableResponse {
    /**
     * 
     * @type {Array<OfferInListDTO>}
     * @memberof OfferTableResponse
     */
    offers: Array<OfferInListDTO>;
    /**
     * 
     * @type {number}
     * @memberof OfferTableResponse
     */
    totalCount: number;
}

/**
 * 
 * @export
 */
export const OfferTableSortingField = {
    Title: 'TITLE',
    Type: 'TYPE',
    Vehicle: 'VEHICLE',
    Dates: 'DATES',
    Source: 'SOURCE'
} as const;
export type OfferTableSortingField = typeof OfferTableSortingField[keyof typeof OfferTableSortingField];

/**
 * 
 * @export
 */
export const OfferType = {
    NewVehicle: 'NEW_VEHICLE',
    UsedVehicle: 'USED_VEHICLE',
    Service: 'SERVICE'
} as const;
export type OfferType = typeof OfferType[keyof typeof OfferType];

/**
 * 
 * @export
 * @interface OpeningHoursImportResult
 */
export interface OpeningHoursImportResult {
    /**
     * 
     * @type {number}
     * @memberof OpeningHoursImportResult
     */
    rowsRead?: number;
    /**
     * 
     * @type {number}
     * @memberof OpeningHoursImportResult
     */
    schedulesUpdated?: number;
    /**
     * 
     * @type {number}
     * @memberof OpeningHoursImportResult
     */
    schedulesUnchanged?: number;
}
/**
 * 
 * @export
 * @interface OperatorDTO
 */
export interface OperatorDTO {
    /**
     * 
     * @type {string}
     * @memberof OperatorDTO
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof OperatorDTO
     */
    title: string;
    /**
     * 
     * @type {boolean}
     * @memberof OperatorDTO
     */
    requireInputField: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OperatorDTO
     */
    requiredMultiValue: boolean;
}
/**
 * 
 * @export
 * @interface PCPConfigurationDTO
 */
export interface PCPConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof PCPConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PCPConfigurationDTO
     */
    isPcpEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PCPConfigurationDTO
     */
    apr?: number;
    /**
     * 
     * @type {number}
     * @memberof PCPConfigurationDTO
     */
    residualPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof PCPConfigurationDTO
     */
    dealerContribution?: number;
}
/**
 * 
 * @export
 * @interface PageableInfo
 */
export interface PageableInfo {
    /**
     * 
     * @type {number}
     * @memberof PageableInfo
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableInfo
     */
    pageSize?: number;
    /**
     * 
     * @type {SortInfo}
     * @memberof PageableInfo
     */
    sort?: SortInfo;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    paged?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    unpaged?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    pageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    pageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    offset?: number;
    /**
     * 
     * @type {Array<SortObject>}
     * @memberof PageableObject
     */
    sort?: Array<SortObject>;
}
/**
 * 
 * @export
 * @interface PartExchangeVehicleResponse
 */
export interface PartExchangeVehicleResponse {
    /**
     * 
     * @type {number}
     * @memberof PartExchangeVehicleResponse
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PartExchangeVehicleResponse
     */
    vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof PartExchangeVehicleResponse
     */
    make?: string;
    /**
     * 
     * @type {string}
     * @memberof PartExchangeVehicleResponse
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof PartExchangeVehicleResponse
     */
    generation?: string;
    /**
     * 
     * @type {number}
     * @memberof PartExchangeVehicleResponse
     */
    mileage?: number;
    /**
     * 
     * @type {string}
     * @memberof PartExchangeVehicleResponse
     */
    vehicleCondition?: string;
    /**
     * 
     * @type {string}
     * @memberof PartExchangeVehicleResponse
     */
    serviceHistory?: string;
    /**
     * 
     * @type {number}
     * @memberof PartExchangeVehicleResponse
     */
    outstandingFinances?: number;
    /**
     * 
     * @type {number}
     * @memberof PartExchangeVehicleResponse
     */
    grossCost?: number;
    /**
     * 
     * @type {number}
     * @memberof PartExchangeVehicleResponse
     */
    netCost?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PartExchangeVehicleResponse
     */
    isVatExcluded?: boolean;
}
/**
 * 
 * @export
 * @interface PersonalVehicleInfoDTO
 */
export interface PersonalVehicleInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof PersonalVehicleInfoDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalVehicleInfoDTO
     */
    vrm?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonalVehicleInfoDTO
     */
    mileage?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalVehicleInfoDTO
     */
    vehicleCondition?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalVehicleInfoDTO
     */
    serviceHistory?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonalVehicleInfoDTO
     */
    outstandingFinances?: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalVehicleInfoDTO
     */
    grossCost?: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalVehicleInfoDTO
     */
    netCost?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalVehicleInfoDTO
     */
    isVatExcluded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PersonalVehicleInfoDTO
     */
    make?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalVehicleInfoDTO
     */
    model?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalVehicleInfoDTO
     */
    generation?: string;
}
/**
 * 
 * @export
 * @interface PersonalizedVehicleDescriptionResponse
 */
export interface PersonalizedVehicleDescriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof PersonalizedVehicleDescriptionResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalizedVehicleDescriptionResponse
     */
    userMessagesCount?: string;
}
/**
 * 
 * @export
 * @interface PipelineStockFileVehicleDataConfigurationDTO
 */
export interface PipelineStockFileVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof PipelineStockFileVehicleDataConfigurationDTO
     */
    filePath: string;
}


/**
 * 
 * @export
 * @interface PublicTranscriptMessageUi
 */
export interface PublicTranscriptMessageUi {
    /**
     * 
     * @type {number}
     * @memberof PublicTranscriptMessageUi
     */
    id: number;
    /**
     * 
     * @type {MessageRole}
     * @memberof PublicTranscriptMessageUi
     */
    messageRole: MessageRole;
    /**
     * 
     * @type {MessageType}
     * @memberof PublicTranscriptMessageUi
     */
    messageType?: MessageType;
    /**
     * 
     * @type {string}
     * @memberof PublicTranscriptMessageUi
     */
    timestamp: string;
    /**
     * 
     * @type {string}
     * @memberof PublicTranscriptMessageUi
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof PublicTranscriptMessageUi
     */
    videoUrl?: string;
    /**
     * 
     * @type {Array<VehicleDataDTO>}
     * @memberof PublicTranscriptMessageUi
     */
    vehicleDataList?: Array<VehicleDataDTO>;
    /**
     * 
     * @type {Array<OfferCardDataDTO>}
     * @memberof PublicTranscriptMessageUi
     */
    offerCardDataList?: Array<OfferCardDataDTO>;
}


/**
 * 
 * @export
 * @interface PublicTranscriptUi
 */
export interface PublicTranscriptUi {
    /**
     * 
     * @type {BotTranscriptUi}
     * @memberof PublicTranscriptUi
     */
    bot: BotTranscriptUi;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof PublicTranscriptUi
     */
    conversationChannel: ConversationChannel;
    /**
     * 
     * @type {string}
     * @memberof PublicTranscriptUi
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof PublicTranscriptUi
     */
    userName?: string;
    /**
     * 
     * @type {Array<PublicTranscriptMessageUi>}
     * @memberof PublicTranscriptUi
     */
    messages: Array<PublicTranscriptMessageUi>;
}


/**
 * 
 * @export
 * @interface QualificationOption
 */
export interface QualificationOption {
    /**
     * 
     * @type {string}
     * @memberof QualificationOption
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QualificationOption
     */
    description?: string;
}

/**
 * 
 * @export
 */
export const RedirectProvider = {
    NoRedirect: 'NO_REDIRECT',
    Autotrader: 'AUTOTRADER',
    MotorDesk: 'MOTOR_DESK',
    MotorTech: 'MOTOR_TECH',
    ClickDealer: 'CLICK_DEALER'
} as const;
export type RedirectProvider = typeof RedirectProvider[keyof typeof RedirectProvider];


/**
 * 
 * @export
 */
export const RequestMode = {
    Request: 'REQUEST',
    Booking: 'BOOKING'
} as const;
export type RequestMode = typeof RequestMode[keyof typeof RequestMode];

/**
 * 
 * @export
 * @interface RequestedCallbackChatEventDTO
 */
export interface RequestedCallbackChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof RequestedCallbackChatEventDTO
     */
    location_identifier: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedCallbackChatEventDTO
     */
    preferred_date_time?: string;
}


/**
 * 
 * @export
 * @interface RequestedEmailFollowUpChatEventDTO
 */
export interface RequestedEmailFollowUpChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof RequestedEmailFollowUpChatEventDTO
     */
    location_identifier: string;
}


/**
 * 
 * @export
 * @interface RequestedLimitedFinanceIllustrationChatEventDTO
 */
export interface RequestedLimitedFinanceIllustrationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface RequestedLimitedVehicleInformationChatEventDTO
 */
export interface RequestedLimitedVehicleInformationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface RequestedLimitedVehicleReservationChatEventDTO
 */
export interface RequestedLimitedVehicleReservationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof RequestedLimitedVehicleReservationChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedLimitedVehicleReservationChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedLimitedVehicleReservationChatEventDTO
     */
    stock_vehicle_id?: string;
}


/**
 * 
 * @export
 * @interface RequestedLimitedVehicleValuationChatEventDTO
 */
export interface RequestedLimitedVehicleValuationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface RequestedServiceCallbackChatEventDTO
 */
export interface RequestedServiceCallbackChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof RequestedServiceCallbackChatEventDTO
     */
    location_identifier: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedServiceCallbackChatEventDTO
     */
    preferred_date_time?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedServiceCallbackChatEventDTO
     */
    user_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedServiceCallbackChatEventDTO
     */
    service_call_back_user_name: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedServiceCallbackChatEventDTO
     */
    service_call_back_user_phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedServiceCallbackChatEventDTO
     */
    user_vehicle_vrm: string;
    /**
     * 
     * @type {number}
     * @memberof RequestedServiceCallbackChatEventDTO
     */
    service_call_back_vehicle_mileage: number;
}


/**
 * 
 * @export
 * @interface RequestedTestDriveChatEventDTO
 */
export interface RequestedTestDriveChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    location_identifier: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    preferred_date_time?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    vds_internal_id?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    vehicle_make?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    vehicle_model?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    vehicle_variant?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestedTestDriveChatEventDTO
     */
    test_drive_vehicle_details?: string;
}


/**
 * 
 * @export
 * @interface RequestsConfigurationDTO
 */
export interface RequestsConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof RequestsConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsConfigurationDTO
     */
    callbackRequestsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RequestsConfigurationDTO
     */
    testDriveRequestsEnabled: boolean;
    /**
     * 
     * @type {RequestMode}
     * @memberof RequestsConfigurationDTO
     */
    callbackMode: RequestMode;
    /**
     * 
     * @type {RequestMode}
     * @memberof RequestsConfigurationDTO
     */
    testDriveMode: RequestMode;
}


/**
 * 
 * @export
 * @interface ReservationConfigurationDTO
 */
export interface ReservationConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof ReservationConfigurationDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ReservationConfigurationDTO
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationConfigurationDTO
     */
    stripeSecretKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ReservationConfigurationDTO
     */
    currency?: ReservationConfigurationDTOCurrencyEnum;
    /**
     * 
     * @type {number}
     * @memberof ReservationConfigurationDTO
     */
    price?: number;
}


/**
 * @export
 */
export const ReservationConfigurationDTOCurrencyEnum = {
    Gbp: 'GBP',
    Usd: 'USD',
    Eur: 'EUR',
    Jpy: 'JPY',
    Aed: 'AED',
    Cad: 'CAD'
} as const;
export type ReservationConfigurationDTOCurrencyEnum = typeof ReservationConfigurationDTOCurrencyEnum[keyof typeof ReservationConfigurationDTOCurrencyEnum];

/**
 * 
 * @export
 * @interface ReservedVehicleChatEventDTO
 */
export interface ReservedVehicleChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReservedVehicleChatEventDTO
     */
    stock_vehicle_vin: string;
    /**
     * 
     * @type {string}
     * @memberof ReservedVehicleChatEventDTO
     */
    stock_vehicle_vrm: string;
    /**
     * 
     * @type {string}
     * @memberof ReservedVehicleChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {Currency}
     * @memberof ReservedVehicleChatEventDTO
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof ReservedVehicleChatEventDTO
     */
    deposit_amount: number;
    /**
     * 
     * @type {string}
     * @memberof ReservedVehicleChatEventDTO
     */
    reserved_at: string;
}



/**
 * 
 * @export
 */
export const ResidentialStatus = {
    Owner: 'OWNER',
    Tenant: 'TENANT',
    CouncilTenant: 'COUNCIL_TENANT',
    LivingWithParents: 'LIVING_WITH_PARENTS'
} as const;
export type ResidentialStatus = typeof ResidentialStatus[keyof typeof ResidentialStatus];

/**
 * 
 * @export
 * @interface RetailPriceRuleDTO
 */
export interface RetailPriceRuleDTO {
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleDTO
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleDTO
     */
    max?: number;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof RetailPriceRuleDTO
     */
    subtraction?: SubtractionDTO;
}
/**
 * 
 * @export
 * @interface RetailPriceRuleUi
 */
export interface RetailPriceRuleUi {
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleUi
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleUi
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof RetailPriceRuleUi
     */
    max: number;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof RetailPriceRuleUi
     */
    subtraction: SubtractionUi;
}
/**
 * 
 * @export
 * @interface ReturnedAftersalesInformationChatEventDTO
 */
export interface ReturnedAftersalesInformationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedAftersalesInformationChatEventDTO
     */
    location_identifier: string;
}


/**
 * 
 * @export
 * @interface ReturnedAftersalesWorkingHoursChatEventDTO
 */
export interface ReturnedAftersalesWorkingHoursChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedAftersalesWorkingHoursChatEventDTO
     */
    location_identifier: string;
}


/**
 * 
 * @export
 * @interface ReturnedCompanyInformationChatEventDTO
 */
export interface ReturnedCompanyInformationChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReturnedCompanyWorkingHoursChatEventDTO
 */
export interface ReturnedCompanyWorkingHoursChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReturnedFinanceApplicationChatEventDTO
 */
export interface ReturnedFinanceApplicationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    location_identifier: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    stock_vehicle_vin: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    stock_vehicle_vrm: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    vehicle_make?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    vehicle_model?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    current_home_address: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    previous_home_address?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    number_of_months_spent_at_current_address: number;
    /**
     * 
     * @type {ResidentialStatus}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    residential_status: ResidentialStatus;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    current_employer_name: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    previous_employer_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    number_of_months_spent_with_current_employer: number;
    /**
     * 
     * @type {DrivingLicence}
     * @memberof ReturnedFinanceApplicationChatEventDTO
     */
    driving_licence: DrivingLicence;
}


/**
 * 
 * @export
 * @interface ReturnedFinanceQuoteChatEventDTO
 */
export interface ReturnedFinanceQuoteChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    vehicle_make?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    vehicle_model?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    finance_deposit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    finance_term?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    vehicle_vat?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    full_vehicle_price?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    total_deposit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    balance_to_finance?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    total_amount_payable?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    total_charge_for_credit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    monthly_payment?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    interest_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    apr?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    finance_type?: ReturnedFinanceQuoteChatEventDTOFinanceTypeEnum;
    /**
     * 
     * @type {FinanceProvider}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    finance_provider?: FinanceProvider;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_apr?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_residual_percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_dealer_contribution?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_term?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_deposit?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_monthly_payment?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_balloon_payment?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_total_payable_buy?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_total_payable_return?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    pcp_interest_paid_buy?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFinanceQuoteChatEventDTO
     */
    reason_for_pcp_refusal?: string;
}


/**
 * @export
 */
export const ReturnedFinanceQuoteChatEventDTOFinanceTypeEnum = {
    Hp: 'HP',
    Pcp: 'PCP'
} as const;
export type ReturnedFinanceQuoteChatEventDTOFinanceTypeEnum = typeof ReturnedFinanceQuoteChatEventDTOFinanceTypeEnum[keyof typeof ReturnedFinanceQuoteChatEventDTOFinanceTypeEnum];

/**
 * 
 * @export
 * @interface ReturnedFuelCostChatEventDTO
 */
export interface ReturnedFuelCostChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    user_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    user_vehicle_vrm?: string;
    /**
     * 
     * @type {FuelType}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_stock_vehicle_fuel_type: FuelType;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_stock_vehicle_mpg: number;
    /**
     * 
     * @type {FuelType}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_user_vehicle_fuel_type?: FuelType;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_user_vehicle_mpg?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_annual_mileage: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_fuel_prices?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_for_stock_vehicle?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedFuelCostChatEventDTO
     */
    fuel_cost_for_user_vehicle?: number;
}


/**
 * 
 * @export
 * @interface ReturnedJourneyDetailsChatEventDTO
 */
export interface ReturnedJourneyDetailsChatEventDTO extends ChatEventDTO {
}


/**
 * 
 * @export
 * @interface ReturnedLocationInformationChatEventDTO
 */
export interface ReturnedLocationInformationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedLocationInformationChatEventDTO
     */
    locationIdentifier?: string;
}


/**
 * 
 * @export
 * @interface ReturnedNewVehicleInformationChatEventDTO
 */
export interface ReturnedNewVehicleInformationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedNewVehicleInformationChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedNewVehicleInformationChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedNewVehicleInformationChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedNewVehicleInformationChatEventDTO
     */
    new_vehicle_search_query?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedNewVehicleInformationChatEventDTO
     */
    attempts_used?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedNewVehicleInformationChatEventDTO
     */
    public_franchise_id: string;
}


/**
 * 
 * @export
 * @interface ReturnedRecallUrlChatEventDTO
 */
export interface ReturnedRecallUrlChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedRecallUrlChatEventDTO
     */
    location_identifier: string;
}


/**
 * 
 * @export
 * @interface ReturnedServiceBookingUrlChatEventDTO
 */
export interface ReturnedServiceBookingUrlChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedServiceBookingUrlChatEventDTO
     */
    location_identifier: string;
}


/**
 * 
 * @export
 * @interface ReturnedStripeFormChatEventDTO
 */
export interface ReturnedStripeFormChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedStripeFormChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedStripeFormChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedStripeFormChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedStripeFormChatEventDTO
     */
    vehicle_make?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedStripeFormChatEventDTO
     */
    vehicle_model?: string;
}


/**
 * 
 * @export
 * @interface ReturnedUsedVehicleInformationChatEventDTO
 */
export interface ReturnedUsedVehicleInformationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedUsedVehicleInformationChatEventDTO
     */
    stock_vehicle_vin?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedUsedVehicleInformationChatEventDTO
     */
    stock_vehicle_vrm?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedUsedVehicleInformationChatEventDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedUsedVehicleInformationChatEventDTO
     */
    generated_sql_query?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedUsedVehicleInformationChatEventDTO
     */
    attempts_used?: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedUsedVehicleInformationChatEventDTO
     */
    vehicle_data_provider?: ReturnedUsedVehicleInformationChatEventDTOVehicleDataProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof ReturnedUsedVehicleInformationChatEventDTO
     */
    vehicle_search_query?: string;
}


/**
 * @export
 */
export const ReturnedUsedVehicleInformationChatEventDTOVehicleDataProviderEnum = {
    NoProvider: 'NO_PROVIDER',
    Autotrader: 'AUTOTRADER',
    TmcAutotrader: 'TMC_AUTOTRADER',
    FileOnSftp: 'FILE_ON_SFTP',
    PipelineStockFile: 'PIPELINE_STOCK_FILE',
    SpidersnetFile: 'SPIDERSNET_FILE',
    AutotraderAndFileOnSftp: 'AUTOTRADER_AND_FILE_ON_SFTP',
    KeyloopPipelineSearch: 'KEYLOOP_PIPELINE_SEARCH'
} as const;
export type ReturnedUsedVehicleInformationChatEventDTOVehicleDataProviderEnum = typeof ReturnedUsedVehicleInformationChatEventDTOVehicleDataProviderEnum[keyof typeof ReturnedUsedVehicleInformationChatEventDTOVehicleDataProviderEnum];

/**
 * 
 * @export
 * @interface ReturnedVehicleValuationChatEventDTO
 */
export interface ReturnedVehicleValuationChatEventDTO extends ChatEventDTO {
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    location_identifier: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    user_vehicle_vin?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    is_valuated_successfully: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuation_error_message: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    user_vehicle_vrm: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_make: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_model: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_mileage: number;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_condition?: string;
    /**
     * 
     * @type {string}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_service_history?: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_outstanding_finances: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_gross_cost: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_net_cost: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_is_vat_excluded: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReturnedVehicleValuationChatEventDTO
     */
    valuated_vehicle_matched_conditions?: Array<string>;
}


/**
 * 
 * @export
 * @interface RuleSectionDTO
 */
export interface RuleSectionDTO {
    /**
     * 
     * @type {number}
     * @memberof RuleSectionDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RuleSectionDTO
     */
    isAllMatch: boolean;
    /**
     * 
     * @type {ValuationActionDTO}
     * @memberof RuleSectionDTO
     */
    valuationAction: ValuationActionDTO;
    /**
     * 
     * @type {Set<ConditionGroupDTO>}
     * @memberof RuleSectionDTO
     */
    conditionGroups?: Set<ConditionGroupDTO>;
}
/**
 * 
 * @export
 * @interface RuleSectionResponse
 */
export interface RuleSectionResponse {
    /**
     * 
     * @type {number}
     * @memberof RuleSectionResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RuleSectionResponse
     */
    isAllMatch: boolean;
    /**
     * 
     * @type {ValuationActionResponse}
     * @memberof RuleSectionResponse
     */
    valuationAction: ValuationActionResponse;
    /**
     * 
     * @type {Set<ConditionGroupResponse>}
     * @memberof RuleSectionResponse
     */
    conditionGroups?: Set<ConditionGroupResponse>;
}
/**
 * 
 * @export
 * @interface SaveInitialBotMessageRequest
 */
export interface SaveInitialBotMessageRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveInitialBotMessageRequest
     */
    initialBotMessage: string;
    /**
     * 
     * @type {InitializationType}
     * @memberof SaveInitialBotMessageRequest
     */
    initializationType: InitializationType;
}


/**
 * 
 * @export
 * @interface SaveKnowledgeDefinitionRequest
 */
export interface SaveKnowledgeDefinitionRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveKnowledgeDefinitionRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SaveKnowledgeDefinitionRequest
     */
    description: string;
}
/**
 * 
 * @export
 * @interface SaveMessageFeedbackRequest
 */
export interface SaveMessageFeedbackRequest {
    /**
     * 
     * @type {FeedbackRating}
     * @memberof SaveMessageFeedbackRequest
     */
    rating: FeedbackRating;
    /**
     * 
     * @type {string}
     * @memberof SaveMessageFeedbackRequest
     */
    comment?: string;
}


/**
 * 
 * @export
 * @interface SaveSurveyRequest
 */
export interface SaveSurveyRequest {
    /**
     * 
     * @type {number}
     * @memberof SaveSurveyRequest
     */
    conversationId: number;
    /**
     * 
     * @type {SurveyTrigger}
     * @memberof SaveSurveyRequest
     */
    trigger: SurveyTrigger;
    /**
     * 
     * @type {Array<SurveyAnswerRequest>}
     * @memberof SaveSurveyRequest
     */
    answers: Array<SurveyAnswerRequest>;
}


/**
 * 
 * @export
 * @interface SectionContentDTO
 */
export interface SectionContentDTO {
    /**
     * 
     * @type {Array<FieldEntryDTO>}
     * @memberof SectionContentDTO
     */
    fields?: Array<FieldEntryDTO>;
    /**
     * 
     * @type {Array<object>}
     * @memberof SectionContentDTO
     */
    items?: Array<object>;
}
/**
 * 
 * @export
 * @interface SectionEntryDTO
 */
export interface SectionEntryDTO {
    /**
     * 
     * @type {SectionType}
     * @memberof SectionEntryDTO
     */
    type: SectionType;
    /**
     * 
     * @type {SectionContentDTO}
     * @memberof SectionEntryDTO
     */
    content: SectionContentDTO;
}



/**
 * 
 * @export
 */
export const SectionType = {
    KeyValue: 'KEY_VALUE',
    List: 'LIST'
} as const;
export type SectionType = typeof SectionType[keyof typeof SectionType];

/**
 * 
 * @export
 * @interface ServiceHistoryMultipliersDTO
 */
export interface ServiceHistoryMultipliersDTO {
    /**
     * 
     * @type {number}
     * @memberof ServiceHistoryMultipliersDTO
     */
    id?: number;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ServiceHistoryMultipliersDTO
     */
    fullHistorySubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ServiceHistoryMultipliersDTO
     */
    partHistorySubtraction?: SubtractionDTO;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ServiceHistoryMultipliersDTO
     */
    noHistorySubtraction?: SubtractionDTO;
}
/**
 * 
 * @export
 * @interface ServiceHistoryMultipliersUi
 */
export interface ServiceHistoryMultipliersUi {
    /**
     * 
     * @type {number}
     * @memberof ServiceHistoryMultipliersUi
     */
    id: number;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ServiceHistoryMultipliersUi
     */
    fullHistorySubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ServiceHistoryMultipliersUi
     */
    partHistorySubtraction: SubtractionUi;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ServiceHistoryMultipliersUi
     */
    noHistorySubtraction: SubtractionUi;
}
/**
 * 
 * @export
 * @interface SetStopTranscriptSendingRequest
 */
export interface SetStopTranscriptSendingRequest {
    /**
     * 
     * @type {boolean}
     * @memberof SetStopTranscriptSendingRequest
     */
    stopTranscriptSending: boolean;
}
/**
 * 
 * @export
 */
export const SortDirection = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type SortDirection = typeof SortDirection[keyof typeof SortDirection];

/**
 * 
 * @export
 * @interface SortInfo
 */
export interface SortInfo {
    /**
     * 
     * @type {boolean}
     * @memberof SortInfo
     */
    sorted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortInfo
     */
    unsorted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SortInfo
     */
    empty?: boolean;
}
/**
 * 
 * @export
 * @interface SortObject
 */
export interface SortObject {
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    direction?: string;
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    nullHandling?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    ascending?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SortObject
     */
    property?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SortObject
     */
    ignoreCase?: boolean;
}
/**
 * 
 * @export
 * @interface SpidersnetFileVehicleDataConfigurationDTO
 */
export interface SpidersnetFileVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof SpidersnetFileVehicleDataConfigurationDTO
     */
    feedId: string;
}



/**
 * 
 * @export
 */
export const StripeMessageStatus = {
    NotPaid: 'NOT_PAID',
    Processing: 'PROCESSING',
    PaidNotConfirmed: 'PAID_NOT_CONFIRMED',
    PaidConfirmed: 'PAID_CONFIRMED'
} as const;
export type StripeMessageStatus = typeof StripeMessageStatus[keyof typeof StripeMessageStatus];

/**
 * 
 * @export
 * @interface SubtractionDTO
 */
export interface SubtractionDTO {
    /**
     * 
     * @type {number}
     * @memberof SubtractionDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof SubtractionDTO
     */
    subtractionValue?: number;
    /**
     * 
     * @type {SubtractionType}
     * @memberof SubtractionDTO
     */
    subtractionType?: SubtractionType;
}



/**
 * 
 * @export
 */
export const SubtractionType = {
    Percentage: 'PERCENTAGE',
    Number: 'NUMBER'
} as const;
export type SubtractionType = typeof SubtractionType[keyof typeof SubtractionType];

/**
 * 
 * @export
 * @interface SubtractionUi
 */
export interface SubtractionUi {
    /**
     * 
     * @type {number}
     * @memberof SubtractionUi
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SubtractionUi
     */
    subtractionValue: number;
    /**
     * 
     * @type {SubtractionType}
     * @memberof SubtractionUi
     */
    subtractionType: SubtractionType;
}


/**
 * 
 * @export
 * @interface SummaryExtractedFacts
 */
export interface SummaryExtractedFacts {
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    town?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    county?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    lastFocusedVIN?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    userVehicleVrm?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    userVehicleMake?: string;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    userVehicleModel?: string;
    /**
     * 
     * @type {number}
     * @memberof SummaryExtractedFacts
     */
    userVehicleMileage?: number;
    /**
     * 
     * @type {string}
     * @memberof SummaryExtractedFacts
     */
    customerIntent?: string;
}
/**
 * 
 * @export
 * @interface SummaryResponse
 */
export interface SummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof SummaryResponse
     */
    narrativeSummary?: string;
    /**
     * 
     * @type {SummaryExtractedFacts}
     * @memberof SummaryResponse
     */
    extractedFacts?: SummaryExtractedFacts;
}
/**
 * 
 * @export
 * @interface SuperchatConfigurationDTO
 */
export interface SuperchatConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof SuperchatConfigurationDTO
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof SuperchatConfigurationDTO
     */
    enabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof SuperchatConfigurationDTO
     */
    apiKey: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatConfigurationDTO
     */
    webhookId: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatConfigurationDTO
     */
    aimeUserEmail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SuperchatConfigurationDTO
     */
    handoverUserEmailList?: Array<string>;
}
/**
 * Contact information
 * @export
 * @interface SuperchatContactInfo
 */
export interface SuperchatContactInfo {
    /**
     * 
     * @type {string}
     * @memberof SuperchatContactInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatContactInfo
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatContactInfo
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatContactInfo
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatContactInfo
     */
    channel_id?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatContactInfo
     */
    contact_id?: string;
}
/**
 * Payload received from Superchat webhook
 * @export
 * @interface SuperchatWebhookMessage
 */
export interface SuperchatWebhookMessage {
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    status?: SuperchatWebhookMessageStatusEnum;
    /**
     * 
     * @type {Content}
     * @memberof SuperchatWebhookMessage
     */
    content?: Content;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    direction?: SuperchatWebhookMessageDirectionEnum;
    /**
     * 
     * @type {Array<SuperchatContactInfo>}
     * @memberof SuperchatWebhookMessage
     */
    to?: Array<SuperchatContactInfo>;
    /**
     * 
     * @type {SuperchatContactInfo}
     * @memberof SuperchatWebhookMessage
     */
    from?: SuperchatContactInfo;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    in_reply_to?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookMessage
     */
    conversation_id?: string;
}


/**
 * @export
 */
export const SuperchatWebhookMessageStatusEnum = {
    Sent: 'sent',
    Failed: 'failed',
    Received: 'received'
} as const;
export type SuperchatWebhookMessageStatusEnum = typeof SuperchatWebhookMessageStatusEnum[keyof typeof SuperchatWebhookMessageStatusEnum];

/**
 * @export
 */
export const SuperchatWebhookMessageDirectionEnum = {
    Inbound: 'inbound',
    Outbound: 'outbound'
} as const;
export type SuperchatWebhookMessageDirectionEnum = typeof SuperchatWebhookMessageDirectionEnum[keyof typeof SuperchatWebhookMessageDirectionEnum];

/**
 * 
 * @export
 * @interface SuperchatWebhookRequest
 */
export interface SuperchatWebhookRequest {
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SuperchatWebhookRequest
     */
    event?: SuperchatWebhookRequestEventEnum;
    /**
     * 
     * @type {SuperchatWebhookMessage}
     * @memberof SuperchatWebhookRequest
     */
    message?: SuperchatWebhookMessage;
}


/**
 * @export
 */
export const SuperchatWebhookRequestEventEnum = {
    MessageInbound: 'message_inbound',
    MessageOutbound: 'message_outbound',
    ContactUpdated: 'contact_updated',
    ContactCreated: 'contact_created',
    ContactDeleted: 'contact_deleted',
    ConversationOpened: 'conversation_opened',
    ConversationSnoozed: 'conversation_snoozed',
    ConversationDone: 'conversation_done',
    NoteCreated: 'note_created'
} as const;
export type SuperchatWebhookRequestEventEnum = typeof SuperchatWebhookRequestEventEnum[keyof typeof SuperchatWebhookRequestEventEnum];


/**
 * 
 * @export
 */
export const SupportedTimezone = {
    EuropeLondon: 'EUROPE_LONDON',
    EuropeParis: 'EUROPE_PARIS',
    EuropeBerlin: 'EUROPE_BERLIN',
    EuropeMadrid: 'EUROPE_MADRID',
    AsiaTokyo: 'ASIA_TOKYO',
    AsiaDubai: 'ASIA_DUBAI',
    AmericaNewYork: 'AMERICA_NEW_YORK',
    AmericaToronto: 'AMERICA_TORONTO'
} as const;
export type SupportedTimezone = typeof SupportedTimezone[keyof typeof SupportedTimezone];

/**
 * 
 * @export
 * @interface SurveyAnswerRequest
 */
export interface SurveyAnswerRequest {
    /**
     * 
     * @type {SurveyQuestion}
     * @memberof SurveyAnswerRequest
     */
    question: SurveyQuestion;
    /**
     * 
     * @type {number}
     * @memberof SurveyAnswerRequest
     */
    rating: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyAnswerRequest
     */
    comment?: string;
}


/**
 * 
 * @export
 * @interface SurveyAnswerUi
 */
export interface SurveyAnswerUi {
    /**
     * 
     * @type {SurveyQuestion}
     * @memberof SurveyAnswerUi
     */
    question: SurveyQuestion;
    /**
     * 
     * @type {number}
     * @memberof SurveyAnswerUi
     */
    rating: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyAnswerUi
     */
    comment?: string;
}


/**
 * 
 * @export
 * @interface SurveyInListUi
 */
export interface SurveyInListUi {
    /**
     * 
     * @type {number}
     * @memberof SurveyInListUi
     */
    id: number;
    /**
     * 
     * @type {SurveyTrigger}
     * @memberof SurveyInListUi
     */
    trigger: SurveyTrigger;
    /**
     * 
     * @type {string}
     * @memberof SurveyInListUi
     */
    createdAt: string;
    /**
     * 
     * @type {Array<SurveyAnswerUi>}
     * @memberof SurveyInListUi
     */
    answers: Array<SurveyAnswerUi>;
    /**
     * 
     * @type {number}
     * @memberof SurveyInListUi
     */
    conversationId: number;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof SurveyInListUi
     */
    conversationChannel: ConversationChannel;
    /**
     * 
     * @type {number}
     * @memberof SurveyInListUi
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyInListUi
     */
    userName?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInListUi
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyInListUi
     */
    botName?: string;
}



/**
 * 
 * @export
 */
export const SurveyQuestion = {
    Helpfulness: 'HELPFULNESS',
    Accuracy: 'ACCURACY',
    Clarity: 'CLARITY'
} as const;
export type SurveyQuestion = typeof SurveyQuestion[keyof typeof SurveyQuestion];


/**
 * 
 * @export
 */
export const SurveyRatingGroup = {
    Low: 'LOW',
    Mixed: 'MIXED',
    High: 'HIGH'
} as const;
export type SurveyRatingGroup = typeof SurveyRatingGroup[keyof typeof SurveyRatingGroup];

/**
 * 
 * @export
 * @interface SurveyResponseUi
 */
export interface SurveyResponseUi {
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseUi
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyResponseUi
     */
    conversationId: number;
    /**
     * 
     * @type {SurveyTrigger}
     * @memberof SurveyResponseUi
     */
    trigger: SurveyTrigger;
    /**
     * 
     * @type {string}
     * @memberof SurveyResponseUi
     */
    createdAt: string;
    /**
     * 
     * @type {Array<SurveyAnswerUi>}
     * @memberof SurveyResponseUi
     */
    answers: Array<SurveyAnswerUi>;
}


/**
 * 
 * @export
 * @interface SurveyTableRequest
 */
export interface SurveyTableRequest {
    /**
     * 
     * @type {number}
     * @memberof SurveyTableRequest
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyTableRequest
     */
    pageSize: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyTableRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof SurveyTableRequest
     */
    endDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SurveyTableRequest
     */
    publicBotIdList?: Array<string>;
    /**
     * 
     * @type {SurveyRatingGroup}
     * @memberof SurveyTableRequest
     */
    ratingGroup?: SurveyRatingGroup;
    /**
     * 
     * @type {Array<SurveyTrigger>}
     * @memberof SurveyTableRequest
     */
    triggerList?: Array<SurveyTrigger>;
    /**
     * 
     * @type {boolean}
     * @memberof SurveyTableRequest
     */
    withCommentOnly?: boolean;
    /**
     * 
     * @type {PageableObject}
     * @memberof SurveyTableRequest
     */
    pageable?: PageableObject;
}


/**
 * 
 * @export
 * @interface SurveyTableResponse
 */
export interface SurveyTableResponse {
    /**
     * 
     * @type {Array<SurveyInListUi>}
     * @memberof SurveyTableResponse
     */
    surveys: Array<SurveyInListUi>;
    /**
     * 
     * @type {number}
     * @memberof SurveyTableResponse
     */
    totalCount: number;
}

/**
 * 
 * @export
 */
export const SurveyTrigger = {
    EndChat: 'END_CHAT',
    MessageCount: 'MESSAGE_COUNT',
    Booking: 'BOOKING'
} as const;
export type SurveyTrigger = typeof SurveyTrigger[keyof typeof SurveyTrigger];


/**
 * 
 * @export
 */
export const TextDirection = {
    Ltr: 'LTR',
    Rtl: 'RTL'
} as const;
export type TextDirection = typeof TextDirection[keyof typeof TextDirection];

/**
 * 
 * @export
 * @interface TmcAutotraderVehicleDataConfigurationDTO
 */
export interface TmcAutotraderVehicleDataConfigurationDTO extends VehicleDataConfigurationDTO {
    /**
     * 
     * @type {string}
     * @memberof TmcAutotraderVehicleDataConfigurationDTO
     */
    advertiserId: string;
}


/**
 * 
 * @export
 * @interface ToggleIntegrationRequest
 */
export interface ToggleIntegrationRequest {
    /**
     * 
     * @type {string}
     * @memberof ToggleIntegrationRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {number}
     * @memberof ToggleIntegrationRequest
     */
    configurationId: number;
    /**
     * 
     * @type {Integration}
     * @memberof ToggleIntegrationRequest
     */
    integration: Integration;
}


/**
 * 
 * @export
 * @interface ToolCallDTO
 */
export interface ToolCallDTO {
    /**
     * 
     * @type {number}
     * @memberof ToolCallDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ToolCallDTO
     */
    callId: string;
    /**
     * 
     * @type {string}
     * @memberof ToolCallDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ToolCallDTO
     */
    arguments?: string;
}
/**
 * 
 * @export
 * @interface ToolSettingsDTO
 */
export interface ToolSettingsDTO {
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsDTO
     */
    id?: number;
    /**
     * 
     * @type {RequestsConfigurationDTO}
     * @memberof ToolSettingsDTO
     */
    requestsConfiguration: RequestsConfigurationDTO;
    /**
     * 
     * @type {Set<BookingConfigDTO>}
     * @memberof ToolSettingsDTO
     */
    bookingConfigs: Set<BookingConfigDTO>;
    /**
     * 
     * @type {VehicleSearchConfigDTO}
     * @memberof ToolSettingsDTO
     */
    vehicleSearchConfig: VehicleSearchConfigDTO;
    /**
     * 
     * @type {FinanceConfigurationDTO}
     * @memberof ToolSettingsDTO
     */
    financeConfiguration: FinanceConfigurationDTO;
    /**
     * 
     * @type {PCPConfigurationDTO}
     * @memberof ToolSettingsDTO
     */
    pcpConfiguration: PCPConfigurationDTO;
    /**
     * 
     * @type {ValuationConfigurationDTO}
     * @memberof ToolSettingsDTO
     */
    valuationConfiguration: ValuationConfigurationDTO;
    /**
     * 
     * @type {ReservationConfigurationDTO}
     * @memberof ToolSettingsDTO
     */
    reservationConfiguration: ReservationConfigurationDTO;
}
/**
 * 
 * @export
 * @interface ToolSettingsResponse
 */
export interface ToolSettingsResponse {
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    toolSettingsId: number;
    /**
     * 
     * @type {RequestsConfigurationDTO}
     * @memberof ToolSettingsResponse
     */
    requestsConfiguration: RequestsConfigurationDTO;
    /**
     * 
     * @type {Array<BookingConfigUi>}
     * @memberof ToolSettingsResponse
     */
    bookingConfigs: Array<BookingConfigUi>;
    /**
     * 
     * @type {VehicleSearchConfigDTO}
     * @memberof ToolSettingsResponse
     */
    vehicleSearchConfig: VehicleSearchConfigDTO;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    financeConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof ToolSettingsResponse
     */
    financeIddUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    financeInterestRate?: number;
    /**
     * 
     * @type {FinanceProvider}
     * @memberof ToolSettingsResponse
     */
    financeProvider?: FinanceProvider;
    /**
     * 
     * @type {IVendiProviderConfigResponse}
     * @memberof ToolSettingsResponse
     */
    ivendiProviderConfig?: IVendiProviderConfigResponse;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    pcpConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof ToolSettingsResponse
     */
    isPcpEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    pcpAPR?: number;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    pcpResidualPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    pcpDealerContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    valuationConfigurationId: number;
    /**
     * 
     * @type {ValuationPriceType}
     * @memberof ToolSettingsResponse
     */
    valuationPriceType: ValuationPriceType;
    /**
     * 
     * @type {ValuationProvider}
     * @memberof ToolSettingsResponse
     */
    valuationProvider: ValuationProvider;
    /**
     * 
     * @type {string}
     * @memberof ToolSettingsResponse
     */
    valuationServiceGroupSoftwareHash?: string;
    /**
     * 
     * @type {Array<RetailPriceRuleUi>}
     * @memberof ToolSettingsResponse
     */
    retailPriceRules: Array<RetailPriceRuleUi>;
    /**
     * 
     * @type {ConditionMultipliersUi}
     * @memberof ToolSettingsResponse
     */
    conditionMultipliers: ConditionMultipliersUi;
    /**
     * 
     * @type {ServiceHistoryMultipliersUi}
     * @memberof ToolSettingsResponse
     */
    serviceHistoryMultipliers: ServiceHistoryMultipliersUi;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    minDeduction: number;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    maxDeduction: number;
    /**
     * 
     * @type {ModifierRulesResponse}
     * @memberof ToolSettingsResponse
     */
    modifierRules: ModifierRulesResponse;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    reservationConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof ToolSettingsResponse
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof ToolSettingsResponse
     */
    stripeSecretKey?: string;
    /**
     * 
     * @type {Currency}
     * @memberof ToolSettingsResponse
     */
    currency?: Currency;
    /**
     * 
     * @type {number}
     * @memberof ToolSettingsResponse
     */
    price?: number;
}


/**
 * 
 * @export
 * @interface TranscriptAnalyticsCountByChannel
 */
export interface TranscriptAnalyticsCountByChannel {
    /**
     * 
     * @type {ConversationChannel}
     * @memberof TranscriptAnalyticsCountByChannel
     */
    conversationChannel?: ConversationChannel;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsCountByChannel
     */
    count?: number;
}


/**
 * 
 * @export
 * @interface TranscriptAnalyticsCountByLabel
 */
export interface TranscriptAnalyticsCountByLabel {
    /**
     * 
     * @type {string}
     * @memberof TranscriptAnalyticsCountByLabel
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsCountByLabel
     */
    count?: number;
}
/**
 * 
 * @export
 * @interface TranscriptAnalyticsDailyTrendPoint
 */
export interface TranscriptAnalyticsDailyTrendPoint {
    /**
     * 
     * @type {string}
     * @memberof TranscriptAnalyticsDailyTrendPoint
     */
    date?: string;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsDailyTrendPoint
     */
    conversations?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsDailyTrendPoint
     */
    communicatedUsers?: number;
}
/**
 * 
 * @export
 * @interface TranscriptAnalyticsNewVsReturningUsers
 */
export interface TranscriptAnalyticsNewVsReturningUsers {
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsNewVsReturningUsers
     */
    newUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsNewVsReturningUsers
     */
    returningUsers?: number;
}
/**
 * 
 * @export
 * @interface TranscriptAnalyticsOverview
 */
export interface TranscriptAnalyticsOverview {
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    communicatedUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    conversations?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    newUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    returningUsers?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    averageResponseTimeSeconds?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    assistantMessages?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    failedResponses?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    successRate?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    averageMessagesPerConversation?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    totalToolCalls?: number;
    /**
     * 
     * @type {string}
     * @memberof TranscriptAnalyticsOverview
     */
    mostUsedTool?: string;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    mostUsedToolCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    totalInputTokensUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    totalOutputTokensUsed?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    averageInputTokensPerConversation?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    averageOutputTokensPerConversation?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    averageInputTokensPerUser?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptAnalyticsOverview
     */
    averageOutputTokensPerUser?: number;
}
/**
 * 
 * @export
 * @interface TranscriptAnalyticsRequest
 */
export interface TranscriptAnalyticsRequest {
    /**
     * 
     * @type {string}
     * @memberof TranscriptAnalyticsRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptAnalyticsRequest
     */
    endDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TranscriptAnalyticsRequest
     */
    publicBotIdList?: Array<string>;
    /**
     * 
     * @type {Array<ConversationChannel>}
     * @memberof TranscriptAnalyticsRequest
     */
    conversationChannelList?: Array<ConversationChannel>;
    /**
     * 
     * @type {string}
     * @memberof TranscriptAnalyticsRequest
     */
    clientUtcOffset?: string;
}
/**
 * 
 * @export
 * @interface TranscriptAnalyticsResponse
 */
export interface TranscriptAnalyticsResponse {
    /**
     * 
     * @type {TranscriptAnalyticsOverview}
     * @memberof TranscriptAnalyticsResponse
     */
    overview?: TranscriptAnalyticsOverview;
    /**
     * 
     * @type {Array<TranscriptAnalyticsDailyTrendPoint>}
     * @memberof TranscriptAnalyticsResponse
     */
    dailyTrend?: Array<TranscriptAnalyticsDailyTrendPoint>;
    /**
     * 
     * @type {Array<TranscriptAnalyticsCountByLabel>}
     * @memberof TranscriptAnalyticsResponse
     */
    messageTypeBreakdown?: Array<TranscriptAnalyticsCountByLabel>;
    /**
     * 
     * @type {Array<TranscriptAnalyticsCountByLabel>}
     * @memberof TranscriptAnalyticsResponse
     */
    toolUsageBreakdown?: Array<TranscriptAnalyticsCountByLabel>;
    /**
     * 
     * @type {Array<TranscriptAnalyticsCountByChannel>}
     * @memberof TranscriptAnalyticsResponse
     */
    channelBreakdown?: Array<TranscriptAnalyticsCountByChannel>;
    /**
     * 
     * @type {TranscriptAnalyticsNewVsReturningUsers}
     * @memberof TranscriptAnalyticsResponse
     */
    newVsReturningUsers?: TranscriptAnalyticsNewVsReturningUsers;
}
/**
 * 
 * @export
 * @interface TranscriptInListDTO
 */
export interface TranscriptInListDTO {
    /**
     * 
     * @type {number}
     * @memberof TranscriptInListDTO
     */
    userId: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptInListDTO
     */
    conversationId: number;
    /**
     * 
     * @type {ConversationChannel}
     * @memberof TranscriptInListDTO
     */
    conversationChannel: ConversationChannel;
    /**
     * 
     * @type {string}
     * @memberof TranscriptInListDTO
     */
    startedAt: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptInListDTO
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptInListDTO
     */
    userEmail: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptInListDTO
     */
    userPhoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptInListDTO
     */
    publicBotId: string;
    /**
     * 
     * @type {Array<CancelChatBooking200Response>}
     * @memberof TranscriptInListDTO
     */
    chatEvents: Array<CancelChatBooking200Response>;
}


/**
 * 
 * @export
 * @interface TranscriptRoutingDecisionUi
 */
export interface TranscriptRoutingDecisionUi {
    /**
     * 
     * @type {number}
     * @memberof TranscriptRoutingDecisionUi
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptRoutingDecisionUi
     */
    conversationId?: number;
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingDecisionUi
     */
    leadIntentSummary?: string;
    /**
     * 
     * @type {Array<TranscriptRoutingDepartmentSelectionUi>}
     * @memberof TranscriptRoutingDecisionUi
     */
    departmentSelections?: Array<TranscriptRoutingDepartmentSelectionUi>;
}
/**
 * 
 * @export
 * @interface TranscriptRoutingDepartmentDTO
 */
export interface TranscriptRoutingDepartmentDTO {
    /**
     * 
     * @type {number}
     * @memberof TranscriptRoutingDepartmentDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingDepartmentDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingDepartmentDTO
     */
    summaryGuidance?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TranscriptRoutingDepartmentDTO
     */
    filtrationEnabled?: boolean;
    /**
     * 
     * @type {Set<string>}
     * @memberof TranscriptRoutingDepartmentDTO
     */
    eventTypes?: Set<TranscriptRoutingDepartmentDTOEventTypesEnum>;
}


/**
 * @export
 */
export const TranscriptRoutingDepartmentDTOEventTypesEnum = {
    ReturnedLocationInformation: 'RETURNED_LOCATION_INFORMATION',
    ReturnedCompanyInformation: 'RETURNED_COMPANY_INFORMATION',
    ReturnedCompanyWorkingHours: 'RETURNED_COMPANY_WORKING_HOURS',
    ReturnedJourneyDetails: 'RETURNED_JOURNEY_DETAILS',
    CheckedTestDriveBookingAvailability: 'CHECKED_TEST_DRIVE_BOOKING_AVAILABILITY',
    CheckedCallBackBookingAvailability: 'CHECKED_CALL_BACK_BOOKING_AVAILABILITY',
    RequestedCallback: 'REQUESTED_CALLBACK',
    RequestedTestDrive: 'REQUESTED_TEST_DRIVE',
    RequestedEmailFollowUp: 'REQUESTED_EMAIL_FOLLOW_UP',
    RequestedServiceCallback: 'REQUESTED_SERVICE_CALLBACK',
    BookedCallBack: 'BOOKED_CALL_BACK',
    BookedEmailFollowUp: 'BOOKED_EMAIL_FOLLOW_UP',
    BookedTestDrive: 'BOOKED_TEST_DRIVE',
    ReturnedUsedVehicleInformation: 'RETURNED_USED_VEHICLE_INFORMATION',
    ReturnedNewVehicleInformation: 'RETURNED_NEW_VEHICLE_INFORMATION',
    ReturnedVehicleValuation: 'RETURNED_VEHICLE_VALUATION',
    ReturnedFinanceQuote: 'RETURNED_FINANCE_QUOTE',
    ReturnedFinanceApplication: 'RETURNED_FINANCE_APPLICATION',
    ReturnedStripeForm: 'RETURNED_STRIPE_FORM',
    ReservedVehicle: 'RESERVED_VEHICLE',
    RequestedLimitedVehicleInformation: 'REQUESTED_LIMITED_VEHICLE_INFORMATION',
    RequestedLimitedFinanceIllustration: 'REQUESTED_LIMITED_FINANCE_ILLUSTRATION',
    RequestedLimitedVehicleValuation: 'REQUESTED_LIMITED_VEHICLE_VALUATION',
    RequestedLimitedVehicleReservation: 'REQUESTED_LIMITED_VEHICLE_RESERVATION',
    AgentHandover: 'AGENT_HANDOVER',
    HumanHandover: 'HUMAN_HANDOVER',
    ReturnedAftersalesInformation: 'RETURNED_AFTERSALES_INFORMATION',
    ReturnedAftersalesWorkingHours: 'RETURNED_AFTERSALES_WORKING_HOURS',
    ReturnedServiceBookingUrl: 'RETURNED_SERVICE_BOOKING_URL',
    ReturnedRecallUrl: 'RETURNED_RECALL_URL',
    BookedServiceCallBack: 'BOOKED_SERVICE_CALL_BACK',
    ReturnedFuelCost: 'RETURNED_FUEL_COST'
} as const;
export type TranscriptRoutingDepartmentDTOEventTypesEnum = typeof TranscriptRoutingDepartmentDTOEventTypesEnum[keyof typeof TranscriptRoutingDepartmentDTOEventTypesEnum];

/**
 * 
 * @export
 * @interface TranscriptRoutingDepartmentSelectionUi
 */
export interface TranscriptRoutingDepartmentSelectionUi {
    /**
     * 
     * @type {number}
     * @memberof TranscriptRoutingDepartmentSelectionUi
     */
    departmentId?: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptRoutingDepartmentSelectionUi
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingDepartmentSelectionUi
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingDepartmentSelectionUi
     */
    source?: string;
}
/**
 * 
 * @export
 * @interface TranscriptRoutingLocationDTO
 */
export interface TranscriptRoutingLocationDTO {
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingLocationDTO
     */
    locationPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingLocationDTO
     */
    locationName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TranscriptRoutingLocationDTO
     */
    catchAllRecipients?: Array<string>;
    /**
     * 
     * @type {Array<TranscriptRoutingLocationDepartmentDTO>}
     * @memberof TranscriptRoutingLocationDTO
     */
    departments?: Array<TranscriptRoutingLocationDepartmentDTO>;
}
/**
 * 
 * @export
 * @interface TranscriptRoutingLocationDepartmentDTO
 */
export interface TranscriptRoutingLocationDepartmentDTO {
    /**
     * 
     * @type {number}
     * @memberof TranscriptRoutingLocationDepartmentDTO
     */
    departmentId?: number;
    /**
     * 
     * @type {string}
     * @memberof TranscriptRoutingLocationDepartmentDTO
     */
    departmentName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TranscriptRoutingLocationDepartmentDTO
     */
    emailAddresses?: Array<string>;
}
/**
 * 
 * @export
 * @interface TranscriptRoutingSettingsResponse
 */
export interface TranscriptRoutingSettingsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof TranscriptRoutingSettingsResponse
     */
    enabled?: boolean;
    /**
     * 
     * @type {Array<TranscriptRoutingDepartmentDTO>}
     * @memberof TranscriptRoutingSettingsResponse
     */
    departments?: Array<TranscriptRoutingDepartmentDTO>;
    /**
     * 
     * @type {Array<TranscriptRoutingLocationDTO>}
     * @memberof TranscriptRoutingSettingsResponse
     */
    locations?: Array<TranscriptRoutingLocationDTO>;
}
/**
 * 
 * @export
 * @interface TranscriptTableRequest
 */
export interface TranscriptTableRequest {
    /**
     * 
     * @type {number}
     * @memberof TranscriptTableRequest
     */
    pageNumber: number;
    /**
     * 
     * @type {number}
     * @memberof TranscriptTableRequest
     */
    pageSize: number;
    /**
     * 
     * @type {TranscriptTableSortingField}
     * @memberof TranscriptTableRequest
     */
    sortBy?: TranscriptTableSortingField;
    /**
     * 
     * @type {SortDirection}
     * @memberof TranscriptTableRequest
     */
    sortDirection?: SortDirection;
    /**
     * 
     * @type {string}
     * @memberof TranscriptTableRequest
     */
    searchQuery?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptTableRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TranscriptTableRequest
     */
    endDate?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TranscriptTableRequest
     */
    chatOutcome?: Array<TranscriptTableRequestChatOutcomeEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TranscriptTableRequest
     */
    followUp?: Array<TranscriptTableRequestFollowUpEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TranscriptTableRequest
     */
    publicBotIdList?: Array<string>;
    /**
     * 
     * @type {Array<ConversationStatus>}
     * @memberof TranscriptTableRequest
     */
    conversationStatusList?: Array<ConversationStatus>;
    /**
     * 
     * @type {PageableObject}
     * @memberof TranscriptTableRequest
     */
    pageable?: PageableObject;
}


/**
 * @export
 */
export const TranscriptTableRequestChatOutcomeEnum = {
    ReturnedLocationInformation: 'RETURNED_LOCATION_INFORMATION',
    ReturnedCompanyInformation: 'RETURNED_COMPANY_INFORMATION',
    ReturnedCompanyWorkingHours: 'RETURNED_COMPANY_WORKING_HOURS',
    ReturnedJourneyDetails: 'RETURNED_JOURNEY_DETAILS',
    CheckedTestDriveBookingAvailability: 'CHECKED_TEST_DRIVE_BOOKING_AVAILABILITY',
    CheckedCallBackBookingAvailability: 'CHECKED_CALL_BACK_BOOKING_AVAILABILITY',
    RequestedCallback: 'REQUESTED_CALLBACK',
    RequestedTestDrive: 'REQUESTED_TEST_DRIVE',
    RequestedEmailFollowUp: 'REQUESTED_EMAIL_FOLLOW_UP',
    RequestedServiceCallback: 'REQUESTED_SERVICE_CALLBACK',
    BookedCallBack: 'BOOKED_CALL_BACK',
    BookedEmailFollowUp: 'BOOKED_EMAIL_FOLLOW_UP',
    BookedTestDrive: 'BOOKED_TEST_DRIVE',
    ReturnedUsedVehicleInformation: 'RETURNED_USED_VEHICLE_INFORMATION',
    ReturnedNewVehicleInformation: 'RETURNED_NEW_VEHICLE_INFORMATION',
    ReturnedVehicleValuation: 'RETURNED_VEHICLE_VALUATION',
    ReturnedFinanceQuote: 'RETURNED_FINANCE_QUOTE',
    ReturnedFinanceApplication: 'RETURNED_FINANCE_APPLICATION',
    ReturnedStripeForm: 'RETURNED_STRIPE_FORM',
    ReservedVehicle: 'RESERVED_VEHICLE',
    RequestedLimitedVehicleInformation: 'REQUESTED_LIMITED_VEHICLE_INFORMATION',
    RequestedLimitedFinanceIllustration: 'REQUESTED_LIMITED_FINANCE_ILLUSTRATION',
    RequestedLimitedVehicleValuation: 'REQUESTED_LIMITED_VEHICLE_VALUATION',
    RequestedLimitedVehicleReservation: 'REQUESTED_LIMITED_VEHICLE_RESERVATION',
    AgentHandover: 'AGENT_HANDOVER',
    HumanHandover: 'HUMAN_HANDOVER',
    ReturnedAftersalesInformation: 'RETURNED_AFTERSALES_INFORMATION',
    ReturnedAftersalesWorkingHours: 'RETURNED_AFTERSALES_WORKING_HOURS',
    ReturnedServiceBookingUrl: 'RETURNED_SERVICE_BOOKING_URL',
    ReturnedRecallUrl: 'RETURNED_RECALL_URL',
    BookedServiceCallBack: 'BOOKED_SERVICE_CALL_BACK',
    ReturnedFuelCost: 'RETURNED_FUEL_COST'
} as const;
export type TranscriptTableRequestChatOutcomeEnum = typeof TranscriptTableRequestChatOutcomeEnum[keyof typeof TranscriptTableRequestChatOutcomeEnum];

/**
 * @export
 */
export const TranscriptTableRequestFollowUpEnum = {
    ReturnedLocationInformation: 'RETURNED_LOCATION_INFORMATION',
    ReturnedCompanyInformation: 'RETURNED_COMPANY_INFORMATION',
    ReturnedCompanyWorkingHours: 'RETURNED_COMPANY_WORKING_HOURS',
    ReturnedJourneyDetails: 'RETURNED_JOURNEY_DETAILS',
    CheckedTestDriveBookingAvailability: 'CHECKED_TEST_DRIVE_BOOKING_AVAILABILITY',
    CheckedCallBackBookingAvailability: 'CHECKED_CALL_BACK_BOOKING_AVAILABILITY',
    RequestedCallback: 'REQUESTED_CALLBACK',
    RequestedTestDrive: 'REQUESTED_TEST_DRIVE',
    RequestedEmailFollowUp: 'REQUESTED_EMAIL_FOLLOW_UP',
    RequestedServiceCallback: 'REQUESTED_SERVICE_CALLBACK',
    BookedCallBack: 'BOOKED_CALL_BACK',
    BookedEmailFollowUp: 'BOOKED_EMAIL_FOLLOW_UP',
    BookedTestDrive: 'BOOKED_TEST_DRIVE',
    ReturnedUsedVehicleInformation: 'RETURNED_USED_VEHICLE_INFORMATION',
    ReturnedNewVehicleInformation: 'RETURNED_NEW_VEHICLE_INFORMATION',
    ReturnedVehicleValuation: 'RETURNED_VEHICLE_VALUATION',
    ReturnedFinanceQuote: 'RETURNED_FINANCE_QUOTE',
    ReturnedFinanceApplication: 'RETURNED_FINANCE_APPLICATION',
    ReturnedStripeForm: 'RETURNED_STRIPE_FORM',
    ReservedVehicle: 'RESERVED_VEHICLE',
    RequestedLimitedVehicleInformation: 'REQUESTED_LIMITED_VEHICLE_INFORMATION',
    RequestedLimitedFinanceIllustration: 'REQUESTED_LIMITED_FINANCE_ILLUSTRATION',
    RequestedLimitedVehicleValuation: 'REQUESTED_LIMITED_VEHICLE_VALUATION',
    RequestedLimitedVehicleReservation: 'REQUESTED_LIMITED_VEHICLE_RESERVATION',
    AgentHandover: 'AGENT_HANDOVER',
    HumanHandover: 'HUMAN_HANDOVER',
    ReturnedAftersalesInformation: 'RETURNED_AFTERSALES_INFORMATION',
    ReturnedAftersalesWorkingHours: 'RETURNED_AFTERSALES_WORKING_HOURS',
    ReturnedServiceBookingUrl: 'RETURNED_SERVICE_BOOKING_URL',
    ReturnedRecallUrl: 'RETURNED_RECALL_URL',
    BookedServiceCallBack: 'BOOKED_SERVICE_CALL_BACK',
    ReturnedFuelCost: 'RETURNED_FUEL_COST'
} as const;
export type TranscriptTableRequestFollowUpEnum = typeof TranscriptTableRequestFollowUpEnum[keyof typeof TranscriptTableRequestFollowUpEnum];

/**
 * 
 * @export
 * @interface TranscriptTableResponse
 */
export interface TranscriptTableResponse {
    /**
     * 
     * @type {Array<TranscriptInListDTO>}
     * @memberof TranscriptTableResponse
     */
    transcripts: Array<TranscriptInListDTO>;
    /**
     * 
     * @type {number}
     * @memberof TranscriptTableResponse
     */
    totalCount: number;
}
/**
 * 
 * @export
 */
export const TranscriptTableSortingField = {
    Channel: 'CHANNEL',
    Customer: 'CUSTOMER',
    DateTime: 'DATE_TIME'
} as const;
export type TranscriptTableSortingField = typeof TranscriptTableSortingField[keyof typeof TranscriptTableSortingField];

/**
 * 
 * @export
 * @interface UpdateBookingConfigRequest
 */
export interface UpdateBookingConfigRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingConfigRequest
     */
    id?: number;
    /**
     * 
     * @type {BookingType}
     * @memberof UpdateBookingConfigRequest
     */
    bookingType: BookingType;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingConfigRequest
     */
    bookingStepSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingConfigRequest
     */
    timeToCloseSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBookingConfigRequest
     */
    minimumNoticeSeconds: number;
}


/**
 * 
 * @export
 * @interface UpdateBotFeedbackSettingsRequest
 */
export interface UpdateBotFeedbackSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBotFeedbackSettingsRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotFeedbackSettingsRequest
     */
    surveyAfterMessagesEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotFeedbackSettingsRequest
     */
    surveyAfterMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotFeedbackSettingsRequest
     */
    surveyAfterBookingEnabled: boolean;
}
/**
 * 
 * @export
 * @interface UpdateBotLeadSettingsRequest
 */
export interface UpdateBotLeadSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBotLeadSettingsRequest
     */
    botPublicId: string;
    /**
     * 
     * @type {EnquiryProvider}
     * @memberof UpdateBotLeadSettingsRequest
     */
    enquiryProvider: EnquiryProvider;
    /**
     * 
     * @type {Array<LocationLeadConfigRequest>}
     * @memberof UpdateBotLeadSettingsRequest
     */
    locationLeadConfigs?: Array<LocationLeadConfigRequest>;
    /**
     * 
     * @type {Array<Em2EnquiryTypeMappingDTO>}
     * @memberof UpdateBotLeadSettingsRequest
     */
    enquiryTypeMappings?: Array<Em2EnquiryTypeMappingDTO>;
}


/**
 * 
 * @export
 * @interface UpdateBotRequest
 */
export interface UpdateBotRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    publicId: string;
    /**
     * 
     * @type {BotType}
     * @memberof UpdateBotRequest
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    useMultiAgent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    vehicleProviderWarningEmailEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    externalCommunicationsDisabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    isReimportFinished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    siteName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    siteURL: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    groupHash?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    conversationLimit: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    workingRange?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    lastRenewalDate: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    teamInfo?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    openAiApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    openAiModel?: UpdateBotRequestOpenAiModelEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    emailConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    assistantEmail: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    assistantEmailPassword: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBotRequest
     */
    emailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    filtrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    transcriptSummaryEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    sharingLinkEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    surveyAfterMessagesEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    surveyAfterMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    surveyAfterBookingEnabled: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateBotRequest
     */
    publicFranchiseIdList: Array<string>;
    /**
     * 
     * @type {RedirectProvider}
     * @memberof UpdateBotRequest
     */
    redirectProvider: RedirectProvider;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    urlProcessorConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotRequest
     */
    urlProcessorEnabled: boolean;
    /**
     * 
     * @type {MatchField}
     * @memberof UpdateBotRequest
     */
    matchField?: MatchField;
    /**
     * 
     * @type {MatchType}
     * @memberof UpdateBotRequest
     */
    matchType?: MatchType;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotRequest
     */
    segmentNumberFromTheEnd?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    timezone?: UpdateBotRequestTimezoneEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotRequest
     */
    defaultLocale?: UpdateBotRequestDefaultLocaleEnum;
    /**
     * 
     * @type {Array<Country>}
     * @memberof UpdateBotRequest
     */
    supportedPhoneNumberLocales: Array<Country>;
    /**
     * 
     * @type {Array<CcRecipientDTO>}
     * @memberof UpdateBotRequest
     */
    ccRecipients?: Array<CcRecipientDTO>;
}


/**
 * @export
 */
export const UpdateBotRequestOpenAiModelEnum = {
    _6Sol: 'gpt-5.6-sol',
    _6Terra: 'gpt-5.6-terra',
    _6Luna: 'gpt-5.6-luna',
    _4: 'gpt-5.4',
    _4Nano: 'gpt-5.4-nano',
    _4Mini: 'gpt-5.4-mini'
} as const;
export type UpdateBotRequestOpenAiModelEnum = typeof UpdateBotRequestOpenAiModelEnum[keyof typeof UpdateBotRequestOpenAiModelEnum];

/**
 * @export
 */
export const UpdateBotRequestTimezoneEnum = {
    EuropeLondon: 'EUROPE_LONDON',
    EuropeParis: 'EUROPE_PARIS',
    EuropeBerlin: 'EUROPE_BERLIN',
    EuropeMadrid: 'EUROPE_MADRID',
    AsiaTokyo: 'ASIA_TOKYO',
    AsiaDubai: 'ASIA_DUBAI',
    AmericaNewYork: 'AMERICA_NEW_YORK',
    AmericaToronto: 'AMERICA_TORONTO'
} as const;
export type UpdateBotRequestTimezoneEnum = typeof UpdateBotRequestTimezoneEnum[keyof typeof UpdateBotRequestTimezoneEnum];

/**
 * @export
 */
export const UpdateBotRequestDefaultLocaleEnum = {
    EnGb: 'EN_GB',
    EnUs: 'EN_US',
    EnCa: 'EN_CA',
    FrFr: 'FR_FR',
    FrCa: 'FR_CA',
    DeDe: 'DE_DE',
    EsEs: 'ES_ES',
    JaJp: 'JA_JP',
    ArAe: 'AR_AE'
} as const;
export type UpdateBotRequestDefaultLocaleEnum = typeof UpdateBotRequestDefaultLocaleEnum[keyof typeof UpdateBotRequestDefaultLocaleEnum];

/**
 * 
 * @export
 * @interface UpdateBotToolSettingsRequest
 */
export interface UpdateBotToolSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateBotToolSettingsRequest
     */
    botPublicId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    toolSettingsId: number;
    /**
     * 
     * @type {UpdateRequestsConfigurationRequest}
     * @memberof UpdateBotToolSettingsRequest
     */
    requestsConfiguration: UpdateRequestsConfigurationRequest;
    /**
     * 
     * @type {Array<UpdateBookingConfigRequest>}
     * @memberof UpdateBotToolSettingsRequest
     */
    bookingConfigs: Array<UpdateBookingConfigRequest>;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    vehicleSearchConfigId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotToolSettingsRequest
     */
    searchNearestByPostcodeEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    financeConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotToolSettingsRequest
     */
    financeIddUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    financeInterestRate?: number;
    /**
     * 
     * @type {FinanceProvider}
     * @memberof UpdateBotToolSettingsRequest
     */
    financeProvider?: FinanceProvider;
    /**
     * 
     * @type {IVendiProviderConfigRequest}
     * @memberof UpdateBotToolSettingsRequest
     */
    ivendiProviderConfig?: IVendiProviderConfigRequest;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    pcpConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBotToolSettingsRequest
     */
    isPcpEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    pcpAPR?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    pcpResidualPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    pcpDealerContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    valuationConfigurationId: number;
    /**
     * 
     * @type {ValuationPriceType}
     * @memberof UpdateBotToolSettingsRequest
     */
    valuationPriceType?: ValuationPriceType;
    /**
     * 
     * @type {ValuationProvider}
     * @memberof UpdateBotToolSettingsRequest
     */
    valuationProvider?: ValuationProvider;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotToolSettingsRequest
     */
    valuationServiceGroupSoftwareHash?: string;
    /**
     * 
     * @type {Array<UpdateRetailPriceRuleRequest>}
     * @memberof UpdateBotToolSettingsRequest
     */
    retailPriceRules: Array<UpdateRetailPriceRuleRequest>;
    /**
     * 
     * @type {UpdateConditionMultipliersRequest}
     * @memberof UpdateBotToolSettingsRequest
     */
    conditionMultipliers: UpdateConditionMultipliersRequest;
    /**
     * 
     * @type {UpdateServiceHistoryMultipliersRequest}
     * @memberof UpdateBotToolSettingsRequest
     */
    serviceHistoryMultipliers: UpdateServiceHistoryMultipliersRequest;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    minDeduction: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    maxDeduction: number;
    /**
     * 
     * @type {UpdateModifierRulesRequest}
     * @memberof UpdateBotToolSettingsRequest
     */
    modifierRules: UpdateModifierRulesRequest;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    reservationConfigurationId: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotToolSettingsRequest
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBotToolSettingsRequest
     */
    stripeSecretKey?: string;
    /**
     * 
     * @type {Currency}
     * @memberof UpdateBotToolSettingsRequest
     */
    currency?: Currency;
    /**
     * 
     * @type {number}
     * @memberof UpdateBotToolSettingsRequest
     */
    price?: number;
}


/**
 * 
 * @export
 * @interface UpdateConditionGroupRequest
 */
export interface UpdateConditionGroupRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateConditionGroupRequest
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateConditionGroupRequest
     */
    isAllMatch: boolean;
    /**
     * 
     * @type {Set<UpdateConditionRequest>}
     * @memberof UpdateConditionGroupRequest
     */
    conditions?: Set<UpdateConditionRequest>;
}
/**
 * 
 * @export
 * @interface UpdateConditionMultipliersRequest
 */
export interface UpdateConditionMultipliersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateConditionMultipliersRequest
     */
    id?: number;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    excellentSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    goodSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    averageSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    belowAverageSubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateConditionMultipliersRequest
     */
    poorSubtraction: UpdateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface UpdateConditionRequest
 */
export interface UpdateConditionRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateConditionRequest
     */
    id?: number;
    /**
     * 
     * @type {ConditionOperator}
     * @memberof UpdateConditionRequest
     */
    operator: ConditionOperator;
    /**
     * 
     * @type {ConditionField}
     * @memberof UpdateConditionRequest
     */
    conditionField: ConditionField;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateConditionRequest
     */
    comparedValues?: Array<string>;
}


/**
 * 
 * @export
 * @interface UpdateFranchiseRequest
 */
export interface UpdateFranchiseRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateFranchiseRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFranchiseRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFranchiseRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFranchiseRequest
     */
    franchiseHash?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateFranchiseRequest
     */
    urlPathPattern?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFranchiseRequest
     */
    focusEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFranchiseRequest
     */
    sharedWithFocusedFranchises: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateFranchiseRequest
     */
    franchiseEmailConfigurationId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFranchiseRequest
     */
    franchiseEmailTranscriptRecipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFranchiseRequest
     */
    franchiseEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateFranchiseRequest
     */
    franchiseEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {UpdateNewVehicleDataConfigurationRequest}
     * @memberof UpdateFranchiseRequest
     */
    newVehicleDataConfiguration: UpdateNewVehicleDataConfigurationRequest;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateFranchiseRequest
     */
    publicLocationIdList: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateIntegrationRequest
 */
export interface UpdateIntegrationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateIntegrationRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateIntegrationRequest
     */
    configurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateIntegrationRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {Integration}
     * @memberof UpdateIntegrationRequest
     */
    integration: Integration;
    /**
     * 
     * @type {string}
     * @memberof UpdateIntegrationRequest
     */
    superchatApiKey?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIntegrationRequest
     */
    superchatWebhookId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIntegrationRequest
     */
    superchatAimeUserEmail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateIntegrationRequest
     */
    superchatHandoverUserEmailList?: Array<string>;
}


/**
 * 
 * @export
 * @interface UpdateKnowledgeRecordRequest
 */
export interface UpdateKnowledgeRecordRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateKnowledgeRecordRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateKnowledgeRecordRequest
     */
    knowledgeType: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKnowledgeRecordRequest
     */
    content: string;
    /**
     * 
     * @type {Array<KnowledgeRecordAttributeRequest>}
     * @memberof UpdateKnowledgeRecordRequest
     */
    attributes?: Array<KnowledgeRecordAttributeRequest>;
}
/**
 * 
 * @export
 * @interface UpdateKnowledgeRecordsRequest
 */
export interface UpdateKnowledgeRecordsRequest {
    /**
     * 
     * @type {KnowledgeScope}
     * @memberof UpdateKnowledgeRecordsRequest
     */
    scope: KnowledgeScope;
    /**
     * 
     * @type {string}
     * @memberof UpdateKnowledgeRecordsRequest
     */
    botPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKnowledgeRecordsRequest
     */
    franchisePublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKnowledgeRecordsRequest
     */
    locationPublicId?: string;
    /**
     * 
     * @type {Array<UpdateKnowledgeRecordRequest>}
     * @memberof UpdateKnowledgeRecordsRequest
     */
    knowledgeRecords: Array<UpdateKnowledgeRecordRequest>;
}


/**
 * 
 * @export
 * @interface UpdateLocationRequest
 */
export interface UpdateLocationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    postcode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {UpdateWorkScheduleRequest}
     * @memberof UpdateLocationRequest
     */
    workSchedule: UpdateWorkScheduleRequest;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    vehicleDataConfigurationId: number;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof UpdateLocationRequest
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    advertiserId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    filePath?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    feedId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    locationHash?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    locationEmailConfigurationId?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLocationRequest
     */
    locationEmailTranscriptRecipients?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationRequest
     */
    locationEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationRequest
     */
    locationEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    enquiryConfigurationId: number;
    /**
     * 
     * @type {EnquiryProvider}
     * @memberof UpdateLocationRequest
     */
    enquiryProvider: EnquiryProvider;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    dragon2000DealerId?: string;
    /**
     * 
     * @type {ConfigurationRegion}
     * @memberof UpdateLocationRequest
     */
    em2Region?: ConfigurationRegion;
    /**
     * 
     * @type {number}
     * @memberof UpdateLocationRequest
     */
    aftersalesConfigurationId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationRequest
     */
    aftersalesEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    serviceBookingUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLocationRequest
     */
    recallUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateLocationRequest
     */
    aftersalesEmailTranscriptRecipients: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationRequest
     */
    aftersalesEmailFiltrationEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateLocationRequest
     */
    aftersalesEmailTranscriptSummaryEnabled: boolean;
    /**
     * 
     * @type {UpdateWorkScheduleRequest}
     * @memberof UpdateLocationRequest
     */
    aftersalesWorkSchedule: UpdateWorkScheduleRequest;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof UpdateLocationRequest
     */
    supportedVehicleManufacturers?: { [key: string]: Array<string>; };
}


/**
 * @export
 */
export const UpdateLocationRequestSupportedVehicleManufacturersEnum = {
    Car: 'CAR',
    Lcv: 'LCV',
    Bike: 'BIKE'
} as const;
export type UpdateLocationRequestSupportedVehicleManufacturersEnum = typeof UpdateLocationRequestSupportedVehicleManufacturersEnum[keyof typeof UpdateLocationRequestSupportedVehicleManufacturersEnum];

/**
 * 
 * @export
 * @interface UpdateModifierRulesRequest
 */
export interface UpdateModifierRulesRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateModifierRulesRequest
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateModifierRulesRequest
     */
    isActive: boolean;
    /**
     * 
     * @type {Set<UpdateRuleSectionRequest>}
     * @memberof UpdateModifierRulesRequest
     */
    ruleSections?: Set<UpdateRuleSectionRequest>;
}
/**
 * 
 * @export
 * @interface UpdateNewVehicleDataConfigurationRequest
 */
export interface UpdateNewVehicleDataConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateNewVehicleDataConfigurationRequest
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateNewVehicleDataConfigurationRequest
     */
    isEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewVehicleDataConfigurationRequest
     */
    vehicleType: UpdateNewVehicleDataConfigurationRequestVehicleTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateNewVehicleDataConfigurationRequest
     */
    manufacturer: string;
}


/**
 * @export
 */
export const UpdateNewVehicleDataConfigurationRequestVehicleTypeEnum = {
    Car: 'CAR',
    Lcv: 'LCV',
    Bike: 'BIKE'
} as const;
export type UpdateNewVehicleDataConfigurationRequestVehicleTypeEnum = typeof UpdateNewVehicleDataConfigurationRequestVehicleTypeEnum[keyof typeof UpdateNewVehicleDataConfigurationRequestVehicleTypeEnum];

/**
 * 
 * @export
 * @interface UpdateOfferRequest
 */
export interface UpdateOfferRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    publicId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    publicBotId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    publicLocationId?: string;
    /**
     * 
     * @type {OfferStatus}
     * @memberof UpdateOfferRequest
     */
    offerStatus: OfferStatus;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    archivedAt?: string;
    /**
     * 
     * @type {OfferType}
     * @memberof UpdateOfferRequest
     */
    offerType: OfferType;
    /**
     * 
     * @type {OfferSource}
     * @memberof UpdateOfferRequest
     */
    offerSource: OfferSource;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    offerSourceName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    startDate: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    endDate: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    redirectUrl: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    imageUrl: string;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateOfferRequest
     */
    discount?: UpdateSubtractionRequest;
    /**
     * 
     * @type {Currency}
     * @memberof UpdateOfferRequest
     */
    currency?: Currency;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferRequest
     */
    financeProduct?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    cashPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    monthlyPayments?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    customerDeposit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    manufacturerDepositContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    totalDeposit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    dealerContribution?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    balanceToFinance?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    totalAmountPayable?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    totalChargeForCredit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    optionalFinalPayment?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    durationOfAgreementInMonths?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    apr?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    fixedInterestRate?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    mileagePerAnnum?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferRequest
     */
    excessMileageCharge?: number;
}


/**
 * 
 * @export
 * @interface UpdateRequestsConfigurationRequest
 */
export interface UpdateRequestsConfigurationRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRequestsConfigurationRequest
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRequestsConfigurationRequest
     */
    callbackRequestsEnabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRequestsConfigurationRequest
     */
    testDriveRequestsEnabled: boolean;
    /**
     * 
     * @type {RequestMode}
     * @memberof UpdateRequestsConfigurationRequest
     */
    callbackMode: RequestMode;
    /**
     * 
     * @type {RequestMode}
     * @memberof UpdateRequestsConfigurationRequest
     */
    testDriveMode: RequestMode;
}


/**
 * 
 * @export
 * @interface UpdateRetailPriceRuleRequest
 */
export interface UpdateRetailPriceRuleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRetailPriceRuleRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRetailPriceRuleRequest
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateRetailPriceRuleRequest
     */
    max: number;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateRetailPriceRuleRequest
     */
    subtraction: UpdateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface UpdateRuleSectionRequest
 */
export interface UpdateRuleSectionRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateRuleSectionRequest
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRuleSectionRequest
     */
    isAllMatch: boolean;
    /**
     * 
     * @type {UpdateValuationActionRequest}
     * @memberof UpdateRuleSectionRequest
     */
    valuationAction: UpdateValuationActionRequest;
    /**
     * 
     * @type {Set<UpdateConditionGroupRequest>}
     * @memberof UpdateRuleSectionRequest
     */
    conditionGroups?: Set<UpdateConditionGroupRequest>;
}
/**
 * 
 * @export
 * @interface UpdateServiceHistoryMultipliersRequest
 */
export interface UpdateServiceHistoryMultipliersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    id?: number;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    fullHistorySubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    partHistorySubtraction: UpdateSubtractionRequest;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateServiceHistoryMultipliersRequest
     */
    noHistorySubtraction: UpdateSubtractionRequest;
}
/**
 * 
 * @export
 * @interface UpdateSubtractionRequest
 */
export interface UpdateSubtractionRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateSubtractionRequest
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateSubtractionRequest
     */
    subtractionValue: number;
    /**
     * 
     * @type {SubtractionType}
     * @memberof UpdateSubtractionRequest
     */
    subtractionType: SubtractionType;
}


/**
 * 
 * @export
 * @interface UpdateTranscriptRoutingRequest
 */
export interface UpdateTranscriptRoutingRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTranscriptRoutingRequest
     */
    botPublicId: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTranscriptRoutingRequest
     */
    enabled: boolean;
    /**
     * 
     * @type {Array<TranscriptRoutingDepartmentDTO>}
     * @memberof UpdateTranscriptRoutingRequest
     */
    departments?: Array<TranscriptRoutingDepartmentDTO>;
    /**
     * 
     * @type {Array<TranscriptRoutingLocationDTO>}
     * @memberof UpdateTranscriptRoutingRequest
     */
    locations?: Array<TranscriptRoutingLocationDTO>;
}
/**
 * 
 * @export
 * @interface UpdateValuationActionRequest
 */
export interface UpdateValuationActionRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateValuationActionRequest
     */
    id?: number;
    /**
     * 
     * @type {ActionType}
     * @memberof UpdateValuationActionRequest
     */
    actionType: ActionType;
    /**
     * 
     * @type {UpdateSubtractionRequest}
     * @memberof UpdateValuationActionRequest
     */
    priceModifier?: UpdateSubtractionRequest;
}


/**
 * 
 * @export
 * @interface UpdateVehicleDetailsButtonRequest
 */
export interface UpdateVehicleDetailsButtonRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    buttonText: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    message?: string;
    /**
     * 
     * @type {ClickAction}
     * @memberof UpdateVehicleDetailsButtonRequest
     */
    clickAction: ClickAction;
}


/**
 * 
 * @export
 * @interface UpdateVehicleProviderHealthRequest
 */
export interface UpdateVehicleProviderHealthRequest {
    /**
     * 
     * @type {Array<LocationVehicleProviderHealthRequest>}
     * @memberof UpdateVehicleProviderHealthRequest
     */
    locations: Array<LocationVehicleProviderHealthRequest>;
}
/**
 * 
 * @export
 * @interface UpdateWidgetAppearanceLocaleVariantRequest
 */
export interface UpdateWidgetAppearanceLocaleVariantRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    id?: number;
    /**
     * 
     * @type {LocaleTag}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    locale: LocaleTag;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    brandColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    showFooterMessage: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    footerMessage: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    showTerms: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    termsTitle: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    termsUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    popUpDelaySec: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    gtmAnalyticsEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    initialBotMessage: string;
    /**
     * 
     * @type {Array<UpdateWidgetConvoStartersRequest>}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    convoStarters?: Array<UpdateWidgetConvoStartersRequest>;
    /**
     * 
     * @type {Array<UpdateVehicleDetailsButtonRequest>}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    vehicleDetailsButtons?: Array<UpdateVehicleDetailsButtonRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    enablePersonalizedVehicleDescription: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    assistantName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceLocaleVariantRequest
     */
    personaPrompt: string;
}


/**
 * 
 * @export
 * @interface UpdateWidgetAppearanceSettingsRequest
 */
export interface UpdateWidgetAppearanceSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {Array<UpdateWidgetAppearanceLocaleVariantRequest>}
     * @memberof UpdateWidgetAppearanceSettingsRequest
     */
    localeVariants: Array<UpdateWidgetAppearanceLocaleVariantRequest>;
}
/**
 * 
 * @export
 * @interface UpdateWidgetConvoStartersRequest
 */
export interface UpdateWidgetConvoStartersRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWidgetConvoStartersRequest
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetConvoStartersRequest
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateWidgetConvoStartersRequest
     */
    visibility: string;
}
/**
 * 
 * @export
 * @interface UpdateWorkScheduleRequest
 */
export interface UpdateWorkScheduleRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkScheduleRequest
     */
    id?: number;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    monday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    tuesday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    wednesday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    thursday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    friday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    saturday: UpdateWorkingHoursRequest;
    /**
     * 
     * @type {UpdateWorkingHoursRequest}
     * @memberof UpdateWorkScheduleRequest
     */
    sunday: UpdateWorkingHoursRequest;
}
/**
 * 
 * @export
 * @interface UpdateWorkingHoursRequest
 */
export interface UpdateWorkingHoursRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateWorkingHoursRequest
     */
    id?: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof UpdateWorkingHoursRequest
     */
    openTime?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof UpdateWorkingHoursRequest
     */
    closeTime?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateWorkingHoursRequest
     */
    isClosed: boolean;
}
/**
 * 
 * @export
 * @interface UrlProcessorConfigurationDTO
 */
export interface UrlProcessorConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof UrlProcessorConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UrlProcessorConfigurationDTO
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UrlProcessorConfigurationDTO
     */
    matchField?: UrlProcessorConfigurationDTOMatchFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof UrlProcessorConfigurationDTO
     */
    matchType?: UrlProcessorConfigurationDTOMatchTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UrlProcessorConfigurationDTO
     */
    segmentNumberFromTheEnd?: number;
}


/**
 * @export
 */
export const UrlProcessorConfigurationDTOMatchFieldEnum = {
    ExternalStockId: 'EXTERNAL_STOCK_ID',
    Derivative: 'DERIVATIVE',
    KeyloopVehicleId: 'KEYLOOP_VEHICLE_ID',
    PipelineStockFileVehicleId: 'PIPELINE_STOCK_FILE_VEHICLE_ID'
} as const;
export type UrlProcessorConfigurationDTOMatchFieldEnum = typeof UrlProcessorConfigurationDTOMatchFieldEnum[keyof typeof UrlProcessorConfigurationDTOMatchFieldEnum];

/**
 * @export
 */
export const UrlProcessorConfigurationDTOMatchTypeEnum = {
    ExactMatch: 'EXACT_MATCH',
    FuzzyMatch: 'FUZZY_MATCH'
} as const;
export type UrlProcessorConfigurationDTOMatchTypeEnum = typeof UrlProcessorConfigurationDTOMatchTypeEnum[keyof typeof UrlProcessorConfigurationDTOMatchTypeEnum];

/**
 * 
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    publicId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    chatId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    superchatConversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    contactCenterCommunicationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    confidentConversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    town?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    county?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    lastFocusedVIN?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    lastFocusedNewVehicleId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    activeFranchisePublicId?: string;
    /**
     * 
     * @type {HierarchyContextSource}
     * @memberof UserDTO
     */
    activeFranchiseContextSource?: HierarchyContextSource;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    activeLocationPublicId?: string;
    /**
     * 
     * @type {HierarchyContextSource}
     * @memberof UserDTO
     */
    activeLocationContextSource?: HierarchyContextSource;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    currentHomeAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    previousHomeAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    numberOfMonthsSpentAtCurrentAddress?: number;
    /**
     * 
     * @type {ResidentialStatus}
     * @memberof UserDTO
     */
    residentialStatus?: ResidentialStatus;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    currentEmployerName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    previousEmployerName?: string;
    /**
     * 
     * @type {number}
     * @memberof UserDTO
     */
    numberOfMonthsSpentWithCurrentEmployer?: number;
    /**
     * 
     * @type {DrivingLicence}
     * @memberof UserDTO
     */
    drivingLicence?: DrivingLicence;
    /**
     * 
     * @type {AgentName}
     * @memberof UserDTO
     */
    currentAgent?: AgentName;
    /**
     * 
     * @type {PersonalVehicleInfoDTO}
     * @memberof UserDTO
     */
    personalVehicleInfo?: PersonalVehicleInfoDTO;
}


/**
 * 
 * @export
 * @interface UserDetailResponse
 */
export interface UserDetailResponse {
    /**
     * 
     * @type {number}
     * @memberof UserDetailResponse
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    chatId: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    superchatConversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailResponse
     */
    createdAt: string;
    /**
     * 
     * @type {ContactInformationResponse}
     * @memberof UserDetailResponse
     */
    contactInformation: ContactInformationResponse;
    /**
     * 
     * @type {EmploymentAndResidenceResponse}
     * @memberof UserDetailResponse
     */
    employmentAndResidence: EmploymentAndResidenceResponse;
    /**
     * 
     * @type {LastFocusedVehicleResponse}
     * @memberof UserDetailResponse
     */
    vehicleInterest?: LastFocusedVehicleResponse;
    /**
     * 
     * @type {PartExchangeVehicleResponse}
     * @memberof UserDetailResponse
     */
    partExchangeVehicle?: PartExchangeVehicleResponse;
    /**
     * 
     * @type {ConversationSummaryResponse}
     * @memberof UserDetailResponse
     */
    conversationSummary: ConversationSummaryResponse;
    /**
     * 
     * @type {BotInfoResponse}
     * @memberof UserDetailResponse
     */
    bot: BotInfoResponse;
}
/**
 * 
 * @export
 * @interface ValuationActionDTO
 */
export interface ValuationActionDTO {
    /**
     * 
     * @type {number}
     * @memberof ValuationActionDTO
     */
    id?: number;
    /**
     * 
     * @type {ActionType}
     * @memberof ValuationActionDTO
     */
    actionType: ActionType;
    /**
     * 
     * @type {SubtractionDTO}
     * @memberof ValuationActionDTO
     */
    priceModifier?: SubtractionDTO;
}


/**
 * 
 * @export
 * @interface ValuationActionResponse
 */
export interface ValuationActionResponse {
    /**
     * 
     * @type {number}
     * @memberof ValuationActionResponse
     */
    id?: number;
    /**
     * 
     * @type {ActionType}
     * @memberof ValuationActionResponse
     */
    actionType: ActionType;
    /**
     * 
     * @type {SubtractionUi}
     * @memberof ValuationActionResponse
     */
    priceModifier?: SubtractionUi;
}


/**
 * 
 * @export
 * @interface ValuationConfigurationDTO
 */
export interface ValuationConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof ValuationConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ValuationConfigurationDTO
     */
    valuationProvider?: ValuationConfigurationDTOValuationProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof ValuationConfigurationDTO
     */
    valuationServiceGroupSoftwareHash?: string;
    /**
     * 
     * @type {Array<RetailPriceRuleDTO>}
     * @memberof ValuationConfigurationDTO
     */
    retailPriceRules?: Array<RetailPriceRuleDTO>;
    /**
     * 
     * @type {ConditionMultipliersDTO}
     * @memberof ValuationConfigurationDTO
     */
    conditionMultipliers?: ConditionMultipliersDTO;
    /**
     * 
     * @type {ServiceHistoryMultipliersDTO}
     * @memberof ValuationConfigurationDTO
     */
    serviceHistoryMultipliers?: ServiceHistoryMultipliersDTO;
    /**
     * 
     * @type {number}
     * @memberof ValuationConfigurationDTO
     */
    minDeduction?: number;
    /**
     * 
     * @type {number}
     * @memberof ValuationConfigurationDTO
     */
    maxDeduction?: number;
    /**
     * 
     * @type {string}
     * @memberof ValuationConfigurationDTO
     */
    valuationPriceType?: ValuationConfigurationDTOValuationPriceTypeEnum;
    /**
     * 
     * @type {ModifierRulesDTO}
     * @memberof ValuationConfigurationDTO
     */
    modifierRules?: ModifierRulesDTO;
    /**
     * 
     * @type {Array<ValuationProviderOptionDTO>}
     * @memberof ValuationConfigurationDTO
     */
    vehicle_conditions_options?: Array<ValuationProviderOptionDTO>;
    /**
     * 
     * @type {Array<ValuationProviderOptionDTO>}
     * @memberof ValuationConfigurationDTO
     */
    vehicle_service_histories_options?: Array<ValuationProviderOptionDTO>;
}


/**
 * @export
 */
export const ValuationConfigurationDTOValuationProviderEnum = {
    Autotrader: 'AUTOTRADER',
    KeyloopValuationService: 'KEYLOOP_VALUATION_SERVICE'
} as const;
export type ValuationConfigurationDTOValuationProviderEnum = typeof ValuationConfigurationDTOValuationProviderEnum[keyof typeof ValuationConfigurationDTOValuationProviderEnum];

/**
 * @export
 */
export const ValuationConfigurationDTOValuationPriceTypeEnum = {
    PartExchange: 'PART_EXCHANGE',
    Trade: 'TRADE',
    Retail: 'RETAIL',
    Private: 'PRIVATE'
} as const;
export type ValuationConfigurationDTOValuationPriceTypeEnum = typeof ValuationConfigurationDTOValuationPriceTypeEnum[keyof typeof ValuationConfigurationDTOValuationPriceTypeEnum];


/**
 * 
 * @export
 */
export const ValuationPriceType = {
    PartExchange: 'PART_EXCHANGE',
    Trade: 'TRADE',
    Retail: 'RETAIL',
    Private: 'PRIVATE'
} as const;
export type ValuationPriceType = typeof ValuationPriceType[keyof typeof ValuationPriceType];


/**
 * 
 * @export
 */
export const ValuationProvider = {
    Autotrader: 'AUTOTRADER',
    KeyloopValuationService: 'KEYLOOP_VALUATION_SERVICE'
} as const;
export type ValuationProvider = typeof ValuationProvider[keyof typeof ValuationProvider];

/**
 * 
 * @export
 * @interface ValuationProviderOptionDTO
 */
export interface ValuationProviderOptionDTO {
    /**
     * 
     * @type {string}
     * @memberof ValuationProviderOptionDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ValuationProviderOptionDTO
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ValuationProviderOptionDTO
     */
    description?: string;
}

/**
 * 
 * @export
 */
export const VehicleCondition = {
    Excellent: 'EXCELLENT',
    Good: 'GOOD',
    Average: 'AVERAGE',
    BelowAverage: 'BELOW_AVERAGE',
    Poor: 'POOR'
} as const;
export type VehicleCondition = typeof VehicleCondition[keyof typeof VehicleCondition];

/**
 * 
 * @export
 * @interface VehicleDataConfigurationDTO
 */
export interface VehicleDataConfigurationDTO {
    /**
     * 
     * @type {number}
     * @memberof VehicleDataConfigurationDTO
     */
    id?: number;
    /**
     * 
     * @type {VehicleDataProvider}
     * @memberof VehicleDataConfigurationDTO
     */
    vehicleDataProvider: VehicleDataProvider;
    /**
     * 
     * @type {VehicleProviderHealthDTO}
     * @memberof VehicleDataConfigurationDTO
     */
    vehicleProviderHealth?: VehicleProviderHealthDTO;
}


/**
 * 
 * @export
 * @interface VehicleDataDTO
 */
export interface VehicleDataDTO {
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    vin?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    registration: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    derivative: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    mileage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDataDTO
     */
    is_new: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    new_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    stock_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    location_city: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    price_label?: string;
    /**
     * 
     * @type {Currency}
     * @memberof VehicleDataDTO
     */
    price_currency_code: Currency;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDataDTO
     */
    image_list: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    redirect_url?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    vat_status?: string;
    /**
     * 
     * @type {DistanceUnit}
     * @memberof VehicleDataDTO
     */
    odometer_unit: DistanceUnit;
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    year_of_manufacture?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    fuel_type?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDataDTO
     */
    transmission_type?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDataDTO
     */
    is_vat_included?: boolean;
    /**
     * 
     * @type {number}
     * @memberof VehicleDataDTO
     */
    number_of_available_offers?: number;
}



/**
 * 
 * @export
 */
export const VehicleDataProvider = {
    NoProvider: 'NO_PROVIDER',
    Autotrader: 'AUTOTRADER',
    TmcAutotrader: 'TMC_AUTOTRADER',
    FileOnSftp: 'FILE_ON_SFTP',
    PipelineStockFile: 'PIPELINE_STOCK_FILE',
    SpidersnetFile: 'SPIDERSNET_FILE',
    AutotraderAndFileOnSftp: 'AUTOTRADER_AND_FILE_ON_SFTP',
    KeyloopPipelineSearch: 'KEYLOOP_PIPELINE_SEARCH'
} as const;
export type VehicleDataProvider = typeof VehicleDataProvider[keyof typeof VehicleDataProvider];

/**
 * 
 * @export
 * @interface VehicleDetailsButtonDTO
 */
export interface VehicleDetailsButtonDTO {
    /**
     * 
     * @type {number}
     * @memberof VehicleDetailsButtonDTO
     */
    id?: number;
    /**
     * 
     * @type {LocaleTag}
     * @memberof VehicleDetailsButtonDTO
     */
    locale?: LocaleTag;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonDTO
     */
    buttonText?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonDTO
     */
    message?: string;
    /**
     * 
     * @type {ClickAction}
     * @memberof VehicleDetailsButtonDTO
     */
    clickAction?: ClickAction;
}


/**
 * 
 * @export
 * @interface VehicleDetailsButtonUi
 */
export interface VehicleDetailsButtonUi {
    /**
     * 
     * @type {number}
     * @memberof VehicleDetailsButtonUi
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonUi
     */
    buttonText: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsButtonUi
     */
    message?: string;
    /**
     * 
     * @type {ClickAction}
     * @memberof VehicleDetailsButtonUi
     */
    clickAction: ClickAction;
}


/**
 * 
 * @export
 * @interface VehicleDetailsCardDTO
 */
export interface VehicleDetailsCardDTO {
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsCardDTO
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsCardDTO
     */
    model: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsCardDTO
     */
    derivative: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleDetailsCardDTO
     */
    price?: number;
    /**
     * 
     * @type {{ [key: string]: SectionEntryDTO; }}
     * @memberof VehicleDetailsCardDTO
     */
    sections?: { [key: string]: SectionEntryDTO; };
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDetailsCardDTO
     */
    is_new: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsCardDTO
     */
    new_vehicle_id?: string;
    /**
     * 
     * @type {Currency}
     * @memberof VehicleDetailsCardDTO
     */
    price_currency_code: Currency;
    /**
     * 
     * @type {DistanceUnit}
     * @memberof VehicleDetailsCardDTO
     */
    odometer_unit: DistanceUnit;
    /**
     * 
     * @type {Array<string>}
     * @memberof VehicleDetailsCardDTO
     */
    image_list: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof VehicleDetailsCardDTO
     */
    redirect_url?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDetailsCardDTO
     */
    is_vat_included?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleDetailsCardDTO
     */
    has_any_offer_available?: boolean;
}


/**
 * 
 * @export
 * @interface VehicleHeaderCardDTO
 */
export interface VehicleHeaderCardDTO {
    /**
     * 
     * @type {string}
     * @memberof VehicleHeaderCardDTO
     */
    vin: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleHeaderCardDTO
     */
    registration: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleHeaderCardDTO
     */
    make: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleHeaderCardDTO
     */
    model: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleHeaderCardDTO
     */
    price?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleHeaderCardDTO
     */
    is_new: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleHeaderCardDTO
     */
    new_vehicle_id?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleHeaderCardDTO
     */
    price_currency_code: VehicleHeaderCardDTOPriceCurrencyCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof VehicleHeaderCardDTO
     */
    image_url: string;
}


/**
 * @export
 */
export const VehicleHeaderCardDTOPriceCurrencyCodeEnum = {
    Gbp: 'GBP',
    Usd: 'USD',
    Eur: 'EUR',
    Jpy: 'JPY',
    Aed: 'AED',
    Cad: 'CAD'
} as const;
export type VehicleHeaderCardDTOPriceCurrencyCodeEnum = typeof VehicleHeaderCardDTOPriceCurrencyCodeEnum[keyof typeof VehicleHeaderCardDTOPriceCurrencyCodeEnum];

/**
 * 
 * @export
 * @interface VehicleModifierRulesRequest
 */
export interface VehicleModifierRulesRequest {
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    bodyType?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    drivetrain?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    emissionClass?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    fuelType?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    make?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    model?: string;
    /**
     * 
     * @type {number}
     * @memberof VehicleModifierRulesRequest
     */
    owners?: number;
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    transmissionType?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleModifierRulesRequest
     */
    firstRegistrationDate?: string;
    /**
     * 
     * @type {VehicleServiceHistory}
     * @memberof VehicleModifierRulesRequest
     */
    serviceHistory?: VehicleServiceHistory;
    /**
     * 
     * @type {VehicleCondition}
     * @memberof VehicleModifierRulesRequest
     */
    vehicleCondition?: VehicleCondition;
    /**
     * 
     * @type {number}
     * @memberof VehicleModifierRulesRequest
     */
    mileage?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleModifierRulesRequest
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof VehicleModifierRulesRequest
     */
    outstandingFinances?: number;
}


/**
 * 
 * @export
 * @interface VehicleProviderHealthDTO
 */
export interface VehicleProviderHealthDTO {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleProviderHealthDTO
     */
    anyVehicleReturned?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleProviderHealthDTO
     */
    errorMessage?: string;
    /**
     * 
     * @type {string}
     * @memberof VehicleProviderHealthDTO
     */
    updatedAt?: string;
}
/**
 * 
 * @export
 * @interface VehicleSearchConfigDTO
 */
export interface VehicleSearchConfigDTO {
    /**
     * 
     * @type {number}
     * @memberof VehicleSearchConfigDTO
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleSearchConfigDTO
     */
    searchNearestByPostcodeEnabled: boolean;
}

/**
 * 
 * @export
 */
export const VehicleServiceHistory = {
    FullHistory: 'FULL_HISTORY',
    PartHistory: 'PART_HISTORY',
    NoHistory: 'NO_HISTORY'
} as const;
export type VehicleServiceHistory = typeof VehicleServiceHistory[keyof typeof VehicleServiceHistory];


/**
 * 
 * @export
 */
export const WarningTargetType = {
    Location: 'LOCATION',
    Franchise: 'FRANCHISE'
} as const;
export type WarningTargetType = typeof WarningTargetType[keyof typeof WarningTargetType];


/**
 * 
 * @export
 */
export const WarningType = {
    VehicleProvider: 'VEHICLE_PROVIDER',
    FranchiseFocusStock: 'FRANCHISE_FOCUS_STOCK'
} as const;
export type WarningType = typeof WarningType[keyof typeof WarningType];

/**
 * 
 * @export
 * @interface WarningUi
 */
export interface WarningUi {
    /**
     * 
     * @type {WarningType}
     * @memberof WarningUi
     */
    type: WarningType;
    /**
     * 
     * @type {string}
     * @memberof WarningUi
     */
    message: string;
    /**
     * 
     * @type {WarningTargetType}
     * @memberof WarningUi
     */
    targetType: WarningTargetType;
    /**
     * 
     * @type {string}
     * @memberof WarningUi
     */
    targetPublicId?: string;
    /**
     * 
     * @type {string}
     * @memberof WarningUi
     */
    targetName?: string;
    /**
     * 
     * @type {string}
     * @memberof WarningUi
     */
    updatedAt?: string;
}


/**
 * 
 * @export
 * @interface WidgetAppearanceConfigDTO
 */
export interface WidgetAppearanceConfigDTO {
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    mainColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof WidgetAppearanceConfigDTO
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceConfigDTO
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceConfigDTO
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceConfigDTO
     */
    popUpDelaySec: number;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    showFooterMessage: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    footerMessage?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    showTerms: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    termsTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    termsUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    initialBotMessage: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetAppearanceConfigDTO
     */
    bubbleConvoStarters?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WidgetAppearanceConfigDTO
     */
    chatConvoStarters?: Array<string>;
    /**
     * 
     * @type {Array<VehicleDetailsButtonDTO>}
     * @memberof WidgetAppearanceConfigDTO
     */
    vehicleDetailsButtons?: Array<VehicleDetailsButtonDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    enablePersonalizedVehicleDescription?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceConfigDTO
     */
    gtmAnalyticsEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceConfigDTO
     */
    assistantName: string;
}


/**
 * 
 * @export
 * @interface WidgetAppearanceLocaleVariantUi
 */
export interface WidgetAppearanceLocaleVariantUi {
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    id?: number;
    /**
     * 
     * @type {LocaleTag}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    locale: LocaleTag;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    brandColour: string;
    /**
     * 
     * @type {WidgetPosition}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    widgetPosition: WidgetPosition;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    horizontalOffsetPx: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    verticalOffsetPx: number;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    hidePoweredBy: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    showFooterMessage: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    footerMessage: string;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    showTerms: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    termsTitle: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    termsUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    promptPopUpView: boolean;
    /**
     * 
     * @type {number}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    popUpDelaySec: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    initialBotMessage: string;
    /**
     * 
     * @type {Array<FullConvoStartersUI>}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    convoStarters?: Array<FullConvoStartersUI>;
    /**
     * 
     * @type {Array<VehicleDetailsButtonUi>}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    vehicleDetailsButtons?: Array<VehicleDetailsButtonUi>;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    enablePersonalizedVehicleDescription: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    gtmAnalyticsEnabled: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    assistantName: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetAppearanceLocaleVariantUi
     */
    personaPrompt: string;
}


/**
 * 
 * @export
 * @interface WidgetChatHistoryResponse
 */
export interface WidgetChatHistoryResponse {
    /**
     * 
     * @type {Array<WidgetChatMessage>}
     * @memberof WidgetChatHistoryResponse
     */
    messages: Array<WidgetChatMessage>;
    /**
     * 
     * @type {number}
     * @memberof WidgetChatHistoryResponse
     */
    conversationId?: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetChatHistoryResponse
     */
    userId: number;
}
/**
 * 
 * @export
 * @interface WidgetChatInitializeResponse
 */
export interface WidgetChatInitializeResponse {
    /**
     * 
     * @type {number}
     * @memberof WidgetChatInitializeResponse
     */
    conversationId: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetChatInitializeResponse
     */
    userId: number;
    /**
     * 
     * @type {WidgetChatMessage}
     * @memberof WidgetChatInitializeResponse
     */
    initialBotMessage: WidgetChatMessage;
}
/**
 * 
 * @export
 * @interface WidgetChatMessage
 */
export interface WidgetChatMessage {
    /**
     * 
     * @type {number}
     * @memberof WidgetChatMessage
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof WidgetChatMessage
     */
    conversationId?: number;
    /**
     * 
     * @type {MessageType}
     * @memberof WidgetChatMessage
     */
    type: MessageType;
    /**
     * 
     * @type {MessageRole}
     * @memberof WidgetChatMessage
     */
    role: MessageRole;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatMessage
     */
    message?: string;
    /**
     * 
     * @type {Array<VehicleDataDTO>}
     * @memberof WidgetChatMessage
     */
    vehicleDataList?: Array<VehicleDataDTO>;
    /**
     * 
     * @type {Array<OfferCardDataDTO>}
     * @memberof WidgetChatMessage
     */
    offerCardDataList?: Array<OfferCardDataDTO>;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatMessage
     */
    videoUrl?: string;
    /**
     * 
     * @type {StripeMessageStatus}
     * @memberof WidgetChatMessage
     */
    stripeMessageStatus?: StripeMessageStatus;
    /**
     * 
     * @type {number}
     * @memberof WidgetChatMessage
     */
    stripePaymentId?: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatMessage
     */
    timestamp: string;
    /**
     * 
     * @type {FeedbackRating}
     * @memberof WidgetChatMessage
     */
    feedbackRating?: FeedbackRating;
}


/**
 * 
 * @export
 * @interface WidgetChatRequest
 */
export interface WidgetChatRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    publicBotId: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    chatId: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    message: string;
    /**
     * 
     * @type {InitializationType}
     * @memberof WidgetChatRequest
     */
    initializationType: InitializationType;
    /**
     * 
     * @type {InputType}
     * @memberof WidgetChatRequest
     */
    inputType: InputType;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    pageFullUrl: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatRequest
     */
    franchiseHash?: string;
    /**
     * 
     * @type {LocaleTag}
     * @memberof WidgetChatRequest
     */
    locale?: LocaleTag;
    /**
     * 
     * @type {FocusedVehicle}
     * @memberof WidgetChatRequest
     */
    focusedVehicle?: FocusedVehicle;
}


/**
 * 
 * @export
 * @interface WidgetChatResponse
 */
export interface WidgetChatResponse {
    /**
     * 
     * @type {Array<WidgetChatMessage>}
     * @memberof WidgetChatResponse
     */
    widgetChatMessages: Array<WidgetChatMessage>;
    /**
     * 
     * @type {Array<CancelChatBooking200Response>}
     * @memberof WidgetChatResponse
     */
    widgetChatEvents?: Array<CancelChatBooking200Response>;
    /**
     * 
     * @type {number}
     * @memberof WidgetChatResponse
     */
    conversationId: number;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatResponse
     */
    currentlyFocusedVin?: string;
    /**
     * 
     * @type {string}
     * @memberof WidgetChatResponse
     */
    currentlyFocusedNewVehicleId?: string;
}

/**
 * 
 * @export
 */
export const WidgetPosition = {
    Left: 'BOTTOM_LEFT',
    Right: 'BOTTOM_RIGHT'
} as const;
export type WidgetPosition = typeof WidgetPosition[keyof typeof WidgetPosition];

/**
 * 
 * @export
 * @interface WidgetSettings
 */
export interface WidgetSettings {
    /**
     * 
     * @type {string}
     * @memberof WidgetSettings
     */
    name: string;
    /**
     * 
     * @type {BotType}
     * @memberof WidgetSettings
     */
    botType: BotType;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetSettings
     */
    showWidget: boolean;
    /**
     * 
     * @type {string}
     * @memberof WidgetSettings
     */
    stripePublicKey?: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetSettings
     */
    reservationPrice?: number;
    /**
     * 
     * @type {Currency}
     * @memberof WidgetSettings
     */
    reservationCurrency?: Currency;
    /**
     * 
     * @type {LocaleTag}
     * @memberof WidgetSettings
     */
    locale?: LocaleTag;
    /**
     * 
     * @type {TextDirection}
     * @memberof WidgetSettings
     */
    direction?: TextDirection;
    /**
     * 
     * @type {SupportedTimezone}
     * @memberof WidgetSettings
     */
    timezone?: SupportedTimezone;
    /**
     * 
     * @type {WidgetAppearanceConfigDTO}
     * @memberof WidgetSettings
     */
    widgetAppearanceSetting: WidgetAppearanceConfigDTO;
    /**
     * 
     * @type {WidgetSurveySettings}
     * @memberof WidgetSettings
     */
    surveySettings: WidgetSurveySettings;
}


/**
 * 
 * @export
 * @interface WidgetSurveySettings
 */
export interface WidgetSurveySettings {
    /**
     * 
     * @type {boolean}
     * @memberof WidgetSurveySettings
     */
    afterMessagesEnabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof WidgetSurveySettings
     */
    afterMessagesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof WidgetSurveySettings
     */
    afterBookingEnabled: boolean;
}
/**
 * 
 * @export
 * @interface WidgetUserInitializationResponse
 */
export interface WidgetUserInitializationResponse {
    /**
     * 
     * @type {string}
     * @memberof WidgetUserInitializationResponse
     */
    chatId: string;
    /**
     * 
     * @type {number}
     * @memberof WidgetUserInitializationResponse
     */
    userId: number;
}
/**
 * 
 * @export
 * @interface WorkScheduleDTO
 */
export interface WorkScheduleDTO {
    /**
     * 
     * @type {number}
     * @memberof WorkScheduleDTO
     */
    id?: number;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    monday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    tuesday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    wednesday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    thursday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    friday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    saturday?: WorkingHoursDTO;
    /**
     * 
     * @type {WorkingHoursDTO}
     * @memberof WorkScheduleDTO
     */
    sunday?: WorkingHoursDTO;
}
/**
 * 
 * @export
 * @interface WorkScheduleUi
 */
export interface WorkScheduleUi {
    /**
     * 
     * @type {number}
     * @memberof WorkScheduleUi
     */
    id: number;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    monday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    tuesday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    wednesday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    thursday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    friday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    saturday: WorkingHoursUi;
    /**
     * 
     * @type {WorkingHoursUi}
     * @memberof WorkScheduleUi
     */
    sunday: WorkingHoursUi;
}
/**
 * 
 * @export
 * @interface WorkingHoursDTO
 */
export interface WorkingHoursDTO {
    /**
     * 
     * @type {number}
     * @memberof WorkingHoursDTO
     */
    id?: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursDTO
     */
    openTime?: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursDTO
     */
    closeTime?: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursDTO
     */
    isClosed?: boolean;
}
/**
 * 
 * @export
 * @interface WorkingHoursUi
 */
export interface WorkingHoursUi {
    /**
     * 
     * @type {number}
     * @memberof WorkingHoursUi
     */
    id: number;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursUi
     */
    openTime: LocalTime;
    /**
     * 
     * @type {LocalTime}
     * @memberof WorkingHoursUi
     */
    closeTime: LocalTime;
    /**
     * 
     * @type {boolean}
     * @memberof WorkingHoursUi
     */
    isClosed: boolean;
}
